// Gerado automaticamente de emojiselectorBM.html por app/scripts/generateWhatsAppEmojiManifest.js.
// Nao edite manualmente.

const whatsAppEmojiGroups = [
  {
    "id": "smileys",
    "title": "Smileys",
    "emojis": [
      {
        "icon": "😀",
        "code": "1f600"
      },
      {
        "icon": "😃",
        "code": "1f603"
      },
      {
        "icon": "😄",
        "code": "1f604"
      },
      {
        "icon": "😁",
        "code": "1f601"
      },
      {
        "icon": "😆",
        "code": "1f606"
      },
      {
        "icon": "🥹",
        "code": "1f979"
      },
      {
        "icon": "😅",
        "code": "1f605"
      },
      {
        "icon": "😂",
        "code": "1f602"
      },
      {
        "icon": "🤣",
        "code": "1f923"
      },
      {
        "icon": "🥲",
        "code": "1f972"
      },
      {
        "icon": "☺️",
        "code": "263a"
      },
      {
        "icon": "😊",
        "code": "1f60a"
      },
      {
        "icon": "😇",
        "code": "1f607"
      },
      {
        "icon": "🙂",
        "code": "1f642"
      },
      {
        "icon": "🙃",
        "code": "1f643"
      },
      {
        "icon": "😉",
        "code": "1f609"
      },
      {
        "icon": "😌",
        "code": "1f60c"
      },
      {
        "icon": "😍",
        "code": "1f60d"
      },
      {
        "icon": "🥰",
        "code": "1f970"
      },
      {
        "icon": "😘",
        "code": "1f618"
      },
      {
        "icon": "😗",
        "code": "1f617"
      },
      {
        "icon": "😙",
        "code": "1f619"
      },
      {
        "icon": "😚",
        "code": "1f61a"
      },
      {
        "icon": "😋",
        "code": "1f60b"
      },
      {
        "icon": "😛",
        "code": "1f61b"
      },
      {
        "icon": "😝",
        "code": "1f61d"
      },
      {
        "icon": "😜",
        "code": "1f61c"
      },
      {
        "icon": "🤪",
        "code": "1f92a"
      },
      {
        "icon": "🤨",
        "code": "1f928"
      },
      {
        "icon": "🧐",
        "code": "1f9d0"
      },
      {
        "icon": "🤓",
        "code": "1f913"
      },
      {
        "icon": "😎",
        "code": "1f60e"
      },
      {
        "icon": "🥸",
        "code": "1f978"
      },
      {
        "icon": "🤩",
        "code": "1f929"
      },
      {
        "icon": "🥳",
        "code": "1f973"
      },
      {
        "icon": "🙂‍↕️",
        "code": "1f642-200d-2195"
      },
      {
        "icon": "😏",
        "code": "1f60f"
      },
      {
        "icon": "😒",
        "code": "1f612"
      },
      {
        "icon": "🙂‍↔️",
        "code": "1f642-200d-2194"
      },
      {
        "icon": "😞",
        "code": "1f61e"
      },
      {
        "icon": "😔",
        "code": "1f614"
      },
      {
        "icon": "😟",
        "code": "1f61f"
      },
      {
        "icon": "😕",
        "code": "1f615"
      },
      {
        "icon": "🙁",
        "code": "1f641"
      },
      {
        "icon": "☹️",
        "code": "2639"
      },
      {
        "icon": "😣",
        "code": "1f623"
      },
      {
        "icon": "😖",
        "code": "1f616"
      },
      {
        "icon": "😫",
        "code": "1f62b"
      },
      {
        "icon": "😩",
        "code": "1f629"
      },
      {
        "icon": "🥺",
        "code": "1f97a"
      },
      {
        "icon": "😢",
        "code": "1f622"
      },
      {
        "icon": "😭",
        "code": "1f62d"
      },
      {
        "icon": "😤",
        "code": "1f624"
      },
      {
        "icon": "😠",
        "code": "1f620"
      },
      {
        "icon": "😡",
        "code": "1f621"
      },
      {
        "icon": "🤬",
        "code": "1f92c"
      },
      {
        "icon": "🤯",
        "code": "1f92f"
      },
      {
        "icon": "😳",
        "code": "1f633"
      },
      {
        "icon": "🥵",
        "code": "1f975"
      },
      {
        "icon": "🥶",
        "code": "1f976"
      },
      {
        "icon": "😶‍🌫️",
        "code": "1f636-200d-1f32b"
      },
      {
        "icon": "😱",
        "code": "1f631"
      },
      {
        "icon": "😨",
        "code": "1f628"
      },
      {
        "icon": "😰",
        "code": "1f630"
      },
      {
        "icon": "😥",
        "code": "1f625"
      },
      {
        "icon": "😓",
        "code": "1f613"
      },
      {
        "icon": "🤗",
        "code": "1f917"
      },
      {
        "icon": "🤔",
        "code": "1f914"
      },
      {
        "icon": "🫣",
        "code": "1fae3"
      },
      {
        "icon": "🤭",
        "code": "1f92d"
      },
      {
        "icon": "🫢",
        "code": "1fae2"
      },
      {
        "icon": "🫡",
        "code": "1fae1"
      },
      {
        "icon": "🤫",
        "code": "1f92b"
      },
      {
        "icon": "🫠",
        "code": "1fae0"
      },
      {
        "icon": "🤥",
        "code": "1f925"
      },
      {
        "icon": "😶",
        "code": "1f636"
      },
      {
        "icon": "🫥",
        "code": "1fae5"
      },
      {
        "icon": "😐",
        "code": "1f610"
      },
      {
        "icon": "🫤",
        "code": "1fae4"
      },
      {
        "icon": "😑",
        "code": "1f611"
      },
      {
        "icon": "🫨",
        "code": "1fae8"
      },
      {
        "icon": "😬",
        "code": "1f62c"
      },
      {
        "icon": "🙄",
        "code": "1f644"
      },
      {
        "icon": "😯",
        "code": "1f62f"
      },
      {
        "icon": "😦",
        "code": "1f626"
      },
      {
        "icon": "😧",
        "code": "1f627"
      },
      {
        "icon": "😮",
        "code": "1f62e"
      },
      {
        "icon": "😲",
        "code": "1f632"
      },
      {
        "icon": "🥱",
        "code": "1f971"
      },
      {
        "icon": "🫩",
        "code": "1fae9"
      },
      {
        "icon": "😴",
        "code": "1f634"
      },
      {
        "icon": "🤤",
        "code": "1f924"
      },
      {
        "icon": "😪",
        "code": "1f62a"
      },
      {
        "icon": "😮‍💨",
        "code": "1f62e-200d-1f4a8"
      },
      {
        "icon": "😵",
        "code": "1f635"
      },
      {
        "icon": "😵‍💫",
        "code": "1f635-200d-1f4ab"
      },
      {
        "icon": "🤐",
        "code": "1f910"
      },
      {
        "icon": "🥴",
        "code": "1f974"
      },
      {
        "icon": "🤢",
        "code": "1f922"
      },
      {
        "icon": "🤮",
        "code": "1f92e"
      },
      {
        "icon": "🤧",
        "code": "1f927"
      },
      {
        "icon": "😷",
        "code": "1f637"
      },
      {
        "icon": "🤒",
        "code": "1f912"
      },
      {
        "icon": "🤕",
        "code": "1f915"
      },
      {
        "icon": "🤑",
        "code": "1f911"
      },
      {
        "icon": "🤠",
        "code": "1f920"
      },
      {
        "icon": "😈",
        "code": "1f608"
      },
      {
        "icon": "👿",
        "code": "1f47f"
      },
      {
        "icon": "👹",
        "code": "1f479"
      },
      {
        "icon": "👺",
        "code": "1f47a"
      },
      {
        "icon": "🤡",
        "code": "1f921"
      },
      {
        "icon": "💩",
        "code": "1f4a9"
      },
      {
        "icon": "👻",
        "code": "1f47b"
      },
      {
        "icon": "💀",
        "code": "1f480"
      },
      {
        "icon": "☠️",
        "code": "2620"
      },
      {
        "icon": "👽",
        "code": "1f47d"
      },
      {
        "icon": "👾",
        "code": "1f47e"
      },
      {
        "icon": "🤖",
        "code": "1f916"
      },
      {
        "icon": "🎃",
        "code": "1f383"
      },
      {
        "icon": "😺",
        "code": "1f63a"
      },
      {
        "icon": "😸",
        "code": "1f638"
      },
      {
        "icon": "😹",
        "code": "1f639"
      },
      {
        "icon": "😻",
        "code": "1f63b"
      },
      {
        "icon": "😼",
        "code": "1f63c"
      },
      {
        "icon": "😽",
        "code": "1f63d"
      },
      {
        "icon": "🙀",
        "code": "1f640"
      },
      {
        "icon": "😿",
        "code": "1f63f"
      },
      {
        "icon": "😾",
        "code": "1f63e"
      },
      {
        "icon": "🫶",
        "code": "1faf6"
      },
      {
        "icon": "🤲",
        "code": "1f932"
      },
      {
        "icon": "👐",
        "code": "1f450"
      },
      {
        "icon": "🙌",
        "code": "1f64c"
      },
      {
        "icon": "👏",
        "code": "1f44f"
      },
      {
        "icon": "🤝",
        "code": "1f91d"
      },
      {
        "icon": "👍",
        "code": "1f44d"
      },
      {
        "icon": "👎",
        "code": "1f44e"
      },
      {
        "icon": "👊",
        "code": "1f44a"
      },
      {
        "icon": "✊",
        "code": "270a"
      },
      {
        "icon": "🤛",
        "code": "1f91b"
      },
      {
        "icon": "🤜",
        "code": "1f91c"
      },
      {
        "icon": "🫷",
        "code": "1faf7"
      },
      {
        "icon": "🫸",
        "code": "1faf8"
      },
      {
        "icon": "🤞",
        "code": "1f91e"
      },
      {
        "icon": "✌️",
        "code": "270c"
      },
      {
        "icon": "🫰",
        "code": "1faf0"
      },
      {
        "icon": "🤟",
        "code": "1f91f"
      },
      {
        "icon": "🤘",
        "code": "1f918"
      },
      {
        "icon": "👌",
        "code": "1f44c"
      },
      {
        "icon": "🤌",
        "code": "1f90c"
      },
      {
        "icon": "🤏",
        "code": "1f90f"
      },
      {
        "icon": "🫳",
        "code": "1faf3"
      },
      {
        "icon": "🫴",
        "code": "1faf4"
      },
      {
        "icon": "👈",
        "code": "1f448"
      },
      {
        "icon": "👉",
        "code": "1f449"
      },
      {
        "icon": "👆",
        "code": "1f446"
      },
      {
        "icon": "👇",
        "code": "1f447"
      },
      {
        "icon": "☝️",
        "code": "261d"
      },
      {
        "icon": "✋",
        "code": "270b"
      },
      {
        "icon": "🤚",
        "code": "1f91a"
      },
      {
        "icon": "🖐️",
        "code": "1f590"
      },
      {
        "icon": "🖖",
        "code": "1f596"
      },
      {
        "icon": "👋",
        "code": "1f44b"
      },
      {
        "icon": "🤙",
        "code": "1f919"
      },
      {
        "icon": "🫲",
        "code": "1faf2"
      },
      {
        "icon": "🫱",
        "code": "1faf1"
      },
      {
        "icon": "💪",
        "code": "1f4aa"
      },
      {
        "icon": "🦾",
        "code": "1f9be"
      },
      {
        "icon": "🖕",
        "code": "1f595"
      },
      {
        "icon": "✍️",
        "code": "270d"
      },
      {
        "icon": "🙏",
        "code": "1f64f"
      },
      {
        "icon": "🫵",
        "code": "1faf5"
      },
      {
        "icon": "🦶",
        "code": "1f9b6"
      },
      {
        "icon": "🦵",
        "code": "1f9b5"
      },
      {
        "icon": "🦿",
        "code": "1f9bf"
      },
      {
        "icon": "💄",
        "code": "1f484"
      },
      {
        "icon": "💋",
        "code": "1f48b"
      },
      {
        "icon": "👄",
        "code": "1f444"
      },
      {
        "icon": "🫦",
        "code": "1fae6"
      },
      {
        "icon": "🦷",
        "code": "1f9b7"
      },
      {
        "icon": "👅",
        "code": "1f445"
      },
      {
        "icon": "👂",
        "code": "1f442"
      },
      {
        "icon": "🦻",
        "code": "1f9bb"
      },
      {
        "icon": "👃",
        "code": "1f443"
      },
      {
        "icon": "🫆",
        "code": "1fac6"
      },
      {
        "icon": "👣",
        "code": "1f463"
      },
      {
        "icon": "👁️",
        "code": "1f441"
      },
      {
        "icon": "👀",
        "code": "1f440"
      },
      {
        "icon": "🫀",
        "code": "1fac0"
      },
      {
        "icon": "🫁",
        "code": "1fac1"
      },
      {
        "icon": "🧠",
        "code": "1f9e0"
      },
      {
        "icon": "🗣️",
        "code": "1f5e3"
      },
      {
        "icon": "👤",
        "code": "1f464"
      },
      {
        "icon": "👥",
        "code": "1f465"
      },
      {
        "icon": "🫂",
        "code": "1fac2"
      },
      {
        "icon": "👶",
        "code": "1f476"
      },
      {
        "icon": "👧",
        "code": "1f467"
      },
      {
        "icon": "🧒",
        "code": "1f9d2"
      },
      {
        "icon": "👦",
        "code": "1f466"
      },
      {
        "icon": "👩",
        "code": "1f469"
      },
      {
        "icon": "🧑",
        "code": "1f9d1"
      },
      {
        "icon": "👨",
        "code": "1f468"
      },
      {
        "icon": "👩‍🦱",
        "code": "1f469-200d-1f9b1"
      },
      {
        "icon": "🧑‍🦱",
        "code": "1f9d1-200d-1f9b1"
      },
      {
        "icon": "👨‍🦱",
        "code": "1f468-200d-1f9b1"
      },
      {
        "icon": "👩‍🦰",
        "code": "1f469-200d-1f9b0"
      },
      {
        "icon": "🧑‍🦰",
        "code": "1f9d1-200d-1f9b0"
      },
      {
        "icon": "👨‍🦰",
        "code": "1f468-200d-1f9b0"
      },
      {
        "icon": "👱‍♀️",
        "code": "1f471-200d-2640"
      },
      {
        "icon": "👱",
        "code": "1f471"
      },
      {
        "icon": "👱‍♂️",
        "code": "1f471-200d-2642"
      },
      {
        "icon": "👩‍🦳",
        "code": "1f469-200d-1f9b3"
      },
      {
        "icon": "🧑‍🦳",
        "code": "1f9d1-200d-1f9b3"
      },
      {
        "icon": "👨‍🦳",
        "code": "1f468-200d-1f9b3"
      },
      {
        "icon": "👩‍🦲",
        "code": "1f469-200d-1f9b2"
      },
      {
        "icon": "🧑‍🦲",
        "code": "1f9d1-200d-1f9b2"
      },
      {
        "icon": "👨‍🦲",
        "code": "1f468-200d-1f9b2"
      },
      {
        "icon": "🧔‍♀️",
        "code": "1f9d4-200d-2640"
      },
      {
        "icon": "🧔",
        "code": "1f9d4"
      },
      {
        "icon": "🧔‍♂️",
        "code": "1f9d4-200d-2642"
      },
      {
        "icon": "👵",
        "code": "1f475"
      },
      {
        "icon": "🧓",
        "code": "1f9d3"
      },
      {
        "icon": "👴",
        "code": "1f474"
      },
      {
        "icon": "👲",
        "code": "1f472"
      },
      {
        "icon": "👳‍♀️",
        "code": "1f473-200d-2640"
      },
      {
        "icon": "👳",
        "code": "1f473"
      },
      {
        "icon": "👳‍♂️",
        "code": "1f473-200d-2642"
      },
      {
        "icon": "🧕",
        "code": "1f9d5"
      },
      {
        "icon": "👮‍♀️",
        "code": "1f46e-200d-2640"
      },
      {
        "icon": "👮",
        "code": "1f46e"
      },
      {
        "icon": "👮‍♂️",
        "code": "1f46e-200d-2642"
      },
      {
        "icon": "👷‍♀️",
        "code": "1f477-200d-2640"
      },
      {
        "icon": "👷",
        "code": "1f477"
      },
      {
        "icon": "👷‍♂️",
        "code": "1f477-200d-2642"
      },
      {
        "icon": "💂‍♀️",
        "code": "1f482-200d-2640"
      },
      {
        "icon": "💂",
        "code": "1f482"
      },
      {
        "icon": "💂‍♂️",
        "code": "1f482-200d-2642"
      },
      {
        "icon": "🕵️‍♀️",
        "code": "1f575-200d-2640"
      },
      {
        "icon": "🕵️",
        "code": "1f575"
      },
      {
        "icon": "🕵️‍♂️",
        "code": "1f575-200d-2642"
      },
      {
        "icon": "👩‍⚕️",
        "code": "1f469-200d-2695"
      },
      {
        "icon": "🧑‍⚕️",
        "code": "1f9d1-200d-2695"
      },
      {
        "icon": "👨‍⚕️",
        "code": "1f468-200d-2695"
      },
      {
        "icon": "👩‍🌾",
        "code": "1f469-200d-1f33e"
      },
      {
        "icon": "🧑‍🌾",
        "code": "1f9d1-200d-1f33e"
      },
      {
        "icon": "👨‍🌾",
        "code": "1f468-200d-1f33e"
      },
      {
        "icon": "👩‍🍳",
        "code": "1f469-200d-1f373"
      },
      {
        "icon": "🧑‍🍳",
        "code": "1f9d1-200d-1f373"
      },
      {
        "icon": "👨‍🍳",
        "code": "1f468-200d-1f373"
      },
      {
        "icon": "👩‍🎓",
        "code": "1f469-200d-1f393"
      },
      {
        "icon": "🧑‍🎓",
        "code": "1f9d1-200d-1f393"
      },
      {
        "icon": "👨‍🎓",
        "code": "1f468-200d-1f393"
      },
      {
        "icon": "👩‍🎤",
        "code": "1f469-200d-1f3a4"
      },
      {
        "icon": "🧑‍🎤",
        "code": "1f9d1-200d-1f3a4"
      },
      {
        "icon": "👨‍🎤",
        "code": "1f468-200d-1f3a4"
      },
      {
        "icon": "👩‍🏫",
        "code": "1f469-200d-1f3eb"
      },
      {
        "icon": "🧑‍🏫",
        "code": "1f9d1-200d-1f3eb"
      },
      {
        "icon": "👨‍🏫",
        "code": "1f468-200d-1f3eb"
      },
      {
        "icon": "👩‍🏭",
        "code": "1f469-200d-1f3ed"
      },
      {
        "icon": "🧑‍🏭",
        "code": "1f9d1-200d-1f3ed"
      },
      {
        "icon": "👨‍🏭",
        "code": "1f468-200d-1f3ed"
      },
      {
        "icon": "👩‍💻",
        "code": "1f469-200d-1f4bb"
      },
      {
        "icon": "🧑‍💻",
        "code": "1f9d1-200d-1f4bb"
      },
      {
        "icon": "👨‍💻",
        "code": "1f468-200d-1f4bb"
      },
      {
        "icon": "👩‍💼",
        "code": "1f469-200d-1f4bc"
      },
      {
        "icon": "🧑‍💼",
        "code": "1f9d1-200d-1f4bc"
      },
      {
        "icon": "👨‍💼",
        "code": "1f468-200d-1f4bc"
      },
      {
        "icon": "👩‍🔧",
        "code": "1f469-200d-1f527"
      },
      {
        "icon": "🧑‍🔧",
        "code": "1f9d1-200d-1f527"
      },
      {
        "icon": "👨‍🔧",
        "code": "1f468-200d-1f527"
      },
      {
        "icon": "👩‍🔬",
        "code": "1f469-200d-1f52c"
      },
      {
        "icon": "🧑‍🔬",
        "code": "1f9d1-200d-1f52c"
      },
      {
        "icon": "👨‍🔬",
        "code": "1f468-200d-1f52c"
      },
      {
        "icon": "👩‍🎨",
        "code": "1f469-200d-1f3a8"
      },
      {
        "icon": "🧑‍🎨",
        "code": "1f9d1-200d-1f3a8"
      },
      {
        "icon": "👨‍🎨",
        "code": "1f468-200d-1f3a8"
      },
      {
        "icon": "👩‍🚒",
        "code": "1f469-200d-1f692"
      },
      {
        "icon": "🧑‍🚒",
        "code": "1f9d1-200d-1f692"
      },
      {
        "icon": "👨‍🚒",
        "code": "1f468-200d-1f692"
      },
      {
        "icon": "👩‍✈️",
        "code": "1f469-200d-2708"
      },
      {
        "icon": "🧑‍✈️",
        "code": "1f9d1-200d-2708"
      },
      {
        "icon": "👨‍✈️",
        "code": "1f468-200d-2708"
      },
      {
        "icon": "👩‍🚀",
        "code": "1f469-200d-1f680"
      },
      {
        "icon": "🧑‍🚀",
        "code": "1f9d1-200d-1f680"
      },
      {
        "icon": "👨‍🚀",
        "code": "1f468-200d-1f680"
      },
      {
        "icon": "👩‍⚖️",
        "code": "1f469-200d-2696"
      },
      {
        "icon": "🧑‍⚖️",
        "code": "1f9d1-200d-2696"
      },
      {
        "icon": "👨‍⚖️",
        "code": "1f468-200d-2696"
      },
      {
        "icon": "👰‍♀️",
        "code": "1f470-200d-2640"
      },
      {
        "icon": "👰",
        "code": "1f470"
      },
      {
        "icon": "👰‍♂️",
        "code": "1f470-200d-2642"
      },
      {
        "icon": "🤵‍♀️",
        "code": "1f935-200d-2640"
      },
      {
        "icon": "🤵",
        "code": "1f935"
      },
      {
        "icon": "🤵‍♂️",
        "code": "1f935-200d-2642"
      },
      {
        "icon": "👸",
        "code": "1f478"
      },
      {
        "icon": "🫅",
        "code": "1fac5"
      },
      {
        "icon": "🤴",
        "code": "1f934"
      },
      {
        "icon": "🥷",
        "code": "1f977"
      },
      {
        "icon": "🦸‍♀️",
        "code": "1f9b8-200d-2640"
      },
      {
        "icon": "🦸",
        "code": "1f9b8"
      },
      {
        "icon": "🦸‍♂️",
        "code": "1f9b8-200d-2642"
      },
      {
        "icon": "🦹‍♀️",
        "code": "1f9b9-200d-2640"
      },
      {
        "icon": "🦹",
        "code": "1f9b9"
      },
      {
        "icon": "🦹‍♂️",
        "code": "1f9b9-200d-2642"
      },
      {
        "icon": "🤶",
        "code": "1f936"
      },
      {
        "icon": "🧑‍🎄",
        "code": "1f9d1-200d-1f384"
      },
      {
        "icon": "🎅",
        "code": "1f385"
      },
      {
        "icon": "🧙‍♀️",
        "code": "1f9d9-200d-2640"
      },
      {
        "icon": "🧙",
        "code": "1f9d9"
      },
      {
        "icon": "🧙‍♂️",
        "code": "1f9d9-200d-2642"
      },
      {
        "icon": "🧝‍♀️",
        "code": "1f9dd-200d-2640"
      },
      {
        "icon": "🧝",
        "code": "1f9dd"
      },
      {
        "icon": "🧝‍♂️",
        "code": "1f9dd-200d-2642"
      },
      {
        "icon": "🧌",
        "code": "1f9cc"
      },
      {
        "icon": "🧛‍♀️",
        "code": "1f9db-200d-2640"
      },
      {
        "icon": "🧛",
        "code": "1f9db"
      },
      {
        "icon": "🧛‍♂️",
        "code": "1f9db-200d-2642"
      },
      {
        "icon": "🧟‍♀️",
        "code": "1f9df-200d-2640"
      },
      {
        "icon": "🧟",
        "code": "1f9df"
      },
      {
        "icon": "🧟‍♂️",
        "code": "1f9df-200d-2642"
      },
      {
        "icon": "🧞‍♀️",
        "code": "1f9de-200d-2640"
      },
      {
        "icon": "🧞",
        "code": "1f9de"
      },
      {
        "icon": "🧞‍♂️",
        "code": "1f9de-200d-2642"
      },
      {
        "icon": "🧜‍♀️",
        "code": "1f9dc-200d-2640"
      },
      {
        "icon": "🧜",
        "code": "1f9dc"
      },
      {
        "icon": "🧜‍♂️",
        "code": "1f9dc-200d-2642"
      },
      {
        "icon": "🧚‍♀️",
        "code": "1f9da-200d-2640"
      },
      {
        "icon": "🧚",
        "code": "1f9da"
      },
      {
        "icon": "🧚‍♂️",
        "code": "1f9da-200d-2642"
      },
      {
        "icon": "👼",
        "code": "1f47c"
      },
      {
        "icon": "🤰",
        "code": "1f930"
      },
      {
        "icon": "🫄",
        "code": "1fac4"
      },
      {
        "icon": "🫃",
        "code": "1fac3"
      },
      {
        "icon": "🤱",
        "code": "1f931"
      },
      {
        "icon": "👩‍🍼",
        "code": "1f469-200d-1f37c"
      },
      {
        "icon": "🧑‍🍼",
        "code": "1f9d1-200d-1f37c"
      },
      {
        "icon": "👨‍🍼",
        "code": "1f468-200d-1f37c"
      },
      {
        "icon": "🙇‍♀️",
        "code": "1f647-200d-2640"
      },
      {
        "icon": "🙇",
        "code": "1f647"
      },
      {
        "icon": "🙇‍♂️",
        "code": "1f647-200d-2642"
      },
      {
        "icon": "💁‍♀️",
        "code": "1f481-200d-2640"
      },
      {
        "icon": "💁",
        "code": "1f481"
      },
      {
        "icon": "💁‍♂️",
        "code": "1f481-200d-2642"
      },
      {
        "icon": "🙅‍♀️",
        "code": "1f645-200d-2640"
      },
      {
        "icon": "🙅",
        "code": "1f645"
      },
      {
        "icon": "🙅‍♂️",
        "code": "1f645-200d-2642"
      },
      {
        "icon": "🙆‍♀️",
        "code": "1f646-200d-2640"
      },
      {
        "icon": "🙆",
        "code": "1f646"
      },
      {
        "icon": "🙆‍♂️",
        "code": "1f646-200d-2642"
      },
      {
        "icon": "🙋‍♀️",
        "code": "1f64b-200d-2640"
      },
      {
        "icon": "🙋",
        "code": "1f64b"
      },
      {
        "icon": "🙋‍♂️",
        "code": "1f64b-200d-2642"
      },
      {
        "icon": "🧏‍♀️",
        "code": "1f9cf-200d-2640"
      },
      {
        "icon": "🧏",
        "code": "1f9cf"
      },
      {
        "icon": "🧏‍♂️",
        "code": "1f9cf-200d-2642"
      },
      {
        "icon": "🤦‍♀️",
        "code": "1f926-200d-2640"
      },
      {
        "icon": "🤦",
        "code": "1f926"
      },
      {
        "icon": "🤦‍♂️",
        "code": "1f926-200d-2642"
      },
      {
        "icon": "🤷‍♀️",
        "code": "1f937-200d-2640"
      },
      {
        "icon": "🤷",
        "code": "1f937"
      },
      {
        "icon": "🤷‍♂️",
        "code": "1f937-200d-2642"
      },
      {
        "icon": "🙎‍♀️",
        "code": "1f64e-200d-2640"
      },
      {
        "icon": "🙎",
        "code": "1f64e"
      },
      {
        "icon": "🙎‍♂️",
        "code": "1f64e-200d-2642"
      },
      {
        "icon": "🙍‍♀️",
        "code": "1f64d-200d-2640"
      },
      {
        "icon": "🙍",
        "code": "1f64d"
      },
      {
        "icon": "🙍‍♂️",
        "code": "1f64d-200d-2642"
      },
      {
        "icon": "💇‍♀️",
        "code": "1f487-200d-2640"
      },
      {
        "icon": "💇",
        "code": "1f487"
      },
      {
        "icon": "💇‍♂️",
        "code": "1f487-200d-2642"
      },
      {
        "icon": "💆‍♀️",
        "code": "1f486-200d-2640"
      },
      {
        "icon": "💆",
        "code": "1f486"
      },
      {
        "icon": "💆‍♂️",
        "code": "1f486-200d-2642"
      },
      {
        "icon": "🧖‍♀️",
        "code": "1f9d6-200d-2640"
      },
      {
        "icon": "🧖",
        "code": "1f9d6"
      },
      {
        "icon": "🧖‍♂️",
        "code": "1f9d6-200d-2642"
      },
      {
        "icon": "💅",
        "code": "1f485"
      },
      {
        "icon": "🤳",
        "code": "1f933"
      },
      {
        "icon": "💃",
        "code": "1f483"
      },
      {
        "icon": "🕺",
        "code": "1f57a"
      },
      {
        "icon": "👯‍♀️",
        "code": "1f46f-200d-2640"
      },
      {
        "icon": "👯",
        "code": "1f46f"
      },
      {
        "icon": "👯‍♂️",
        "code": "1f46f-200d-2642"
      },
      {
        "icon": "🕴️",
        "code": "1f574"
      },
      {
        "icon": "👩‍🦽",
        "code": "1f469-200d-1f9bd"
      },
      {
        "icon": "🧑‍🦽",
        "code": "1f9d1-200d-1f9bd"
      },
      {
        "icon": "👨‍🦽",
        "code": "1f468-200d-1f9bd"
      },
      {
        "icon": "👩‍🦽‍➡️",
        "code": "1f469-200d-1f9bd-200d-27a1"
      },
      {
        "icon": "🧑‍🦽‍➡️",
        "code": "1f9d1-200d-1f9bd-200d-27a1"
      },
      {
        "icon": "👨‍🦽‍➡️",
        "code": "1f468-200d-1f9bd-200d-27a1"
      },
      {
        "icon": "👩‍🦼",
        "code": "1f469-200d-1f9bc"
      },
      {
        "icon": "🧑‍🦼",
        "code": "1f9d1-200d-1f9bc"
      },
      {
        "icon": "👨‍🦼",
        "code": "1f468-200d-1f9bc"
      },
      {
        "icon": "👩‍🦼‍➡️",
        "code": "1f469-200d-1f9bc-200d-27a1"
      },
      {
        "icon": "🧑‍🦼‍➡️",
        "code": "1f9d1-200d-1f9bc-200d-27a1"
      },
      {
        "icon": "👨‍🦼‍➡️",
        "code": "1f468-200d-1f9bc-200d-27a1"
      },
      {
        "icon": "🚶‍♀️",
        "code": "1f6b6-200d-2640"
      },
      {
        "icon": "🚶",
        "code": "1f6b6"
      },
      {
        "icon": "🚶‍♂️",
        "code": "1f6b6-200d-2642"
      },
      {
        "icon": "🚶‍♀️‍➡️",
        "code": "1f6b6-200d-2640-200d-27a1"
      },
      {
        "icon": "🚶‍➡️",
        "code": "1f6b6-200d-27a1"
      },
      {
        "icon": "🚶‍♂️‍➡️",
        "code": "1f6b6-200d-2642-200d-27a1"
      },
      {
        "icon": "👩‍🦯",
        "code": "1f469-200d-1f9af"
      },
      {
        "icon": "🧑‍🦯",
        "code": "1f9d1-200d-1f9af"
      },
      {
        "icon": "👨‍🦯",
        "code": "1f468-200d-1f9af"
      },
      {
        "icon": "👩‍🦯‍➡️",
        "code": "1f469-200d-1f9af-200d-27a1"
      },
      {
        "icon": "🧑‍🦯‍➡️",
        "code": "1f9d1-200d-1f9af-200d-27a1"
      },
      {
        "icon": "👨‍🦯‍➡️",
        "code": "1f468-200d-1f9af-200d-27a1"
      },
      {
        "icon": "🧎‍♀️",
        "code": "1f9ce-200d-2640"
      },
      {
        "icon": "🧎",
        "code": "1f9ce"
      },
      {
        "icon": "🧎‍♂️",
        "code": "1f9ce-200d-2642"
      },
      {
        "icon": "🏃‍♀️",
        "code": "1f3c3-200d-2640"
      },
      {
        "icon": "🏃",
        "code": "1f3c3"
      },
      {
        "icon": "🏃‍♂️",
        "code": "1f3c3-200d-2642"
      },
      {
        "icon": "🏃‍♀️‍➡️",
        "code": "1f3c3-200d-2640-200d-27a1"
      },
      {
        "icon": "🏃‍➡️",
        "code": "1f3c3-200d-27a1"
      },
      {
        "icon": "🏃‍♂️‍➡️",
        "code": "1f3c3-200d-2642-200d-27a1"
      },
      {
        "icon": "🧎‍♀️‍➡️",
        "code": "1f9ce-200d-2640-200d-27a1"
      },
      {
        "icon": "🧎‍➡️",
        "code": "1f9ce-200d-27a1"
      },
      {
        "icon": "🧎‍♂️‍➡️",
        "code": "1f9ce-200d-2642-200d-27a1"
      },
      {
        "icon": "🧍‍♀️",
        "code": "1f9cd-200d-2640"
      },
      {
        "icon": "🧍",
        "code": "1f9cd"
      },
      {
        "icon": "🧍‍♂️",
        "code": "1f9cd-200d-2642"
      },
      {
        "icon": "👫",
        "code": "1f46b"
      },
      {
        "icon": "👭",
        "code": "1f46d"
      },
      {
        "icon": "👬",
        "code": "1f46c"
      },
      {
        "icon": "👩‍❤️‍👨",
        "code": "1f469-200d-2764-200d-1f468"
      },
      {
        "icon": "👩‍❤️‍👩",
        "code": "1f469-200d-2764-200d-1f469"
      },
      {
        "icon": "💑",
        "code": "1f491"
      },
      {
        "icon": "👨‍❤️‍👨",
        "code": "1f468-200d-2764-200d-1f468"
      },
      {
        "icon": "👩‍❤️‍💋‍👨",
        "code": "1f469-200d-2764-200d-1f48b-200d-1f468"
      },
      {
        "icon": "👩‍❤️‍💋‍👩",
        "code": "1f469-200d-2764-200d-1f48b-200d-1f469"
      },
      {
        "icon": "💏",
        "code": "1f48f"
      },
      {
        "icon": "👨‍❤️‍💋‍👨",
        "code": "1f468-200d-2764-200d-1f48b-200d-1f468"
      },
      {
        "icon": "🪢",
        "code": "1faa2"
      },
      {
        "icon": "🧶",
        "code": "1f9f6"
      },
      {
        "icon": "🧵",
        "code": "1f9f5"
      },
      {
        "icon": "🪡",
        "code": "1faa1"
      },
      {
        "icon": "🧥",
        "code": "1f9e5"
      },
      {
        "icon": "🥼",
        "code": "1f97c"
      },
      {
        "icon": "🦺",
        "code": "1f9ba"
      },
      {
        "icon": "👚",
        "code": "1f45a"
      },
      {
        "icon": "👕",
        "code": "1f455"
      },
      {
        "icon": "👖",
        "code": "1f456"
      },
      {
        "icon": "🩲",
        "code": "1fa72"
      },
      {
        "icon": "🩳",
        "code": "1fa73"
      },
      {
        "icon": "👔",
        "code": "1f454"
      },
      {
        "icon": "👗",
        "code": "1f457"
      },
      {
        "icon": "👙",
        "code": "1f459"
      },
      {
        "icon": "🩱",
        "code": "1fa71"
      },
      {
        "icon": "👘",
        "code": "1f458"
      },
      {
        "icon": "🥻",
        "code": "1f97b"
      },
      {
        "icon": "🩴",
        "code": "1fa74"
      },
      {
        "icon": "🥿",
        "code": "1f97f"
      },
      {
        "icon": "👠",
        "code": "1f460"
      },
      {
        "icon": "👡",
        "code": "1f461"
      },
      {
        "icon": "👢",
        "code": "1f462"
      },
      {
        "icon": "👞",
        "code": "1f45e"
      },
      {
        "icon": "👟",
        "code": "1f45f"
      },
      {
        "icon": "🥾",
        "code": "1f97e"
      },
      {
        "icon": "🧦",
        "code": "1f9e6"
      },
      {
        "icon": "🧤",
        "code": "1f9e4"
      },
      {
        "icon": "🧣",
        "code": "1f9e3"
      },
      {
        "icon": "🎩",
        "code": "1f3a9"
      },
      {
        "icon": "🧢",
        "code": "1f9e2"
      },
      {
        "icon": "👒",
        "code": "1f452"
      },
      {
        "icon": "🎓",
        "code": "1f393"
      },
      {
        "icon": "⛑️",
        "code": "26d1"
      },
      {
        "icon": "🪖",
        "code": "1fa96"
      },
      {
        "icon": "👑",
        "code": "1f451"
      },
      {
        "icon": "💍",
        "code": "1f48d"
      },
      {
        "icon": "👝",
        "code": "1f45d"
      },
      {
        "icon": "👛",
        "code": "1f45b"
      },
      {
        "icon": "👜",
        "code": "1f45c"
      },
      {
        "icon": "💼",
        "code": "1f4bc"
      },
      {
        "icon": "🎒",
        "code": "1f392"
      },
      {
        "icon": "🧳",
        "code": "1f9f3"
      },
      {
        "icon": "👓",
        "code": "1f453"
      },
      {
        "icon": "🕶️",
        "code": "1f576"
      },
      {
        "icon": "🥽",
        "code": "1f97d"
      },
      {
        "icon": "🌂",
        "code": "1f302"
      }
    ]
  },
  {
    "id": "natureza",
    "title": "Natureza",
    "emojis": [
      {
        "icon": "🐶",
        "code": "1f436"
      },
      {
        "icon": "🐱",
        "code": "1f431"
      },
      {
        "icon": "🐭",
        "code": "1f42d"
      },
      {
        "icon": "🐹",
        "code": "1f439"
      },
      {
        "icon": "🐰",
        "code": "1f430"
      },
      {
        "icon": "🦊",
        "code": "1f98a"
      },
      {
        "icon": "🐻",
        "code": "1f43b"
      },
      {
        "icon": "🐼",
        "code": "1f43c"
      },
      {
        "icon": "🐻‍❄️",
        "code": "1f43b-200d-2744"
      },
      {
        "icon": "🐨",
        "code": "1f428"
      },
      {
        "icon": "🐯",
        "code": "1f42f"
      },
      {
        "icon": "🦁",
        "code": "1f981"
      },
      {
        "icon": "🐮",
        "code": "1f42e"
      },
      {
        "icon": "🐷",
        "code": "1f437"
      },
      {
        "icon": "🐽",
        "code": "1f43d"
      },
      {
        "icon": "🐸",
        "code": "1f438"
      },
      {
        "icon": "🐵",
        "code": "1f435"
      },
      {
        "icon": "🙈",
        "code": "1f648"
      },
      {
        "icon": "🙉",
        "code": "1f649"
      },
      {
        "icon": "🙊",
        "code": "1f64a"
      },
      {
        "icon": "🐒",
        "code": "1f412"
      },
      {
        "icon": "🐔",
        "code": "1f414"
      },
      {
        "icon": "🐧",
        "code": "1f427"
      },
      {
        "icon": "🐦",
        "code": "1f426"
      },
      {
        "icon": "🐤",
        "code": "1f424"
      },
      {
        "icon": "🐣",
        "code": "1f423"
      },
      {
        "icon": "🐥",
        "code": "1f425"
      },
      {
        "icon": "🪿",
        "code": "1fabf"
      },
      {
        "icon": "🦆",
        "code": "1f986"
      },
      {
        "icon": "🐦‍⬛",
        "code": "1f426-200d-2b1b"
      },
      {
        "icon": "🦅",
        "code": "1f985"
      },
      {
        "icon": "🦉",
        "code": "1f989"
      },
      {
        "icon": "🦇",
        "code": "1f987"
      },
      {
        "icon": "🐺",
        "code": "1f43a"
      },
      {
        "icon": "🐗",
        "code": "1f417"
      },
      {
        "icon": "🐴",
        "code": "1f434"
      },
      {
        "icon": "🦄",
        "code": "1f984"
      },
      {
        "icon": "🫎",
        "code": "1face"
      },
      {
        "icon": "🐝",
        "code": "1f41d"
      },
      {
        "icon": "🪱",
        "code": "1fab1"
      },
      {
        "icon": "🐛",
        "code": "1f41b"
      },
      {
        "icon": "🦋",
        "code": "1f98b"
      },
      {
        "icon": "🐌",
        "code": "1f40c"
      },
      {
        "icon": "🐞",
        "code": "1f41e"
      },
      {
        "icon": "🐜",
        "code": "1f41c"
      },
      {
        "icon": "🪰",
        "code": "1fab0"
      },
      {
        "icon": "🪲",
        "code": "1fab2"
      },
      {
        "icon": "🪳",
        "code": "1fab3"
      },
      {
        "icon": "🦟",
        "code": "1f99f"
      },
      {
        "icon": "🦗",
        "code": "1f997"
      },
      {
        "icon": "🕷️",
        "code": "1f577"
      },
      {
        "icon": "🕸️",
        "code": "1f578"
      },
      {
        "icon": "🦂",
        "code": "1f982"
      },
      {
        "icon": "🐢",
        "code": "1f422"
      },
      {
        "icon": "🐍",
        "code": "1f40d"
      },
      {
        "icon": "🦎",
        "code": "1f98e"
      },
      {
        "icon": "🦖",
        "code": "1f996"
      },
      {
        "icon": "🦕",
        "code": "1f995"
      },
      {
        "icon": "🐙",
        "code": "1f419"
      },
      {
        "icon": "🦑",
        "code": "1f991"
      },
      {
        "icon": "🪼",
        "code": "1fabc"
      },
      {
        "icon": "🦐",
        "code": "1f990"
      },
      {
        "icon": "🦞",
        "code": "1f99e"
      },
      {
        "icon": "🦀",
        "code": "1f980"
      },
      {
        "icon": "🐡",
        "code": "1f421"
      },
      {
        "icon": "🐠",
        "code": "1f420"
      },
      {
        "icon": "🐟",
        "code": "1f41f"
      },
      {
        "icon": "🐬",
        "code": "1f42c"
      },
      {
        "icon": "🐳",
        "code": "1f433"
      },
      {
        "icon": "🐋",
        "code": "1f40b"
      },
      {
        "icon": "🦈",
        "code": "1f988"
      },
      {
        "icon": "🦭",
        "code": "1f9ad"
      },
      {
        "icon": "🐊",
        "code": "1f40a"
      },
      {
        "icon": "🐅",
        "code": "1f405"
      },
      {
        "icon": "🐆",
        "code": "1f406"
      },
      {
        "icon": "🦓",
        "code": "1f993"
      },
      {
        "icon": "🦍",
        "code": "1f98d"
      },
      {
        "icon": "🦧",
        "code": "1f9a7"
      },
      {
        "icon": "🦣",
        "code": "1f9a3"
      },
      {
        "icon": "🐘",
        "code": "1f418"
      },
      {
        "icon": "🦛",
        "code": "1f99b"
      },
      {
        "icon": "🦏",
        "code": "1f98f"
      },
      {
        "icon": "🐪",
        "code": "1f42a"
      },
      {
        "icon": "🐫",
        "code": "1f42b"
      },
      {
        "icon": "🦒",
        "code": "1f992"
      },
      {
        "icon": "🦘",
        "code": "1f998"
      },
      {
        "icon": "🦬",
        "code": "1f9ac"
      },
      {
        "icon": "🐃",
        "code": "1f403"
      },
      {
        "icon": "🐂",
        "code": "1f402"
      },
      {
        "icon": "🐄",
        "code": "1f404"
      },
      {
        "icon": "🫏",
        "code": "1facf"
      },
      {
        "icon": "🐎",
        "code": "1f40e"
      },
      {
        "icon": "🐖",
        "code": "1f416"
      },
      {
        "icon": "🐏",
        "code": "1f40f"
      },
      {
        "icon": "🐑",
        "code": "1f411"
      },
      {
        "icon": "🦙",
        "code": "1f999"
      },
      {
        "icon": "🐐",
        "code": "1f410"
      },
      {
        "icon": "🦌",
        "code": "1f98c"
      },
      {
        "icon": "🐕",
        "code": "1f415"
      },
      {
        "icon": "🐩",
        "code": "1f429"
      },
      {
        "icon": "🦮",
        "code": "1f9ae"
      },
      {
        "icon": "🐕‍🦺",
        "code": "1f415-200d-1f9ba"
      },
      {
        "icon": "🐈",
        "code": "1f408"
      },
      {
        "icon": "🐈‍⬛",
        "code": "1f408-200d-2b1b"
      },
      {
        "icon": "🪶",
        "code": "1fab6"
      },
      {
        "icon": "🪽",
        "code": "1fabd"
      },
      {
        "icon": "🐓",
        "code": "1f413"
      },
      {
        "icon": "🦃",
        "code": "1f983"
      },
      {
        "icon": "🦤",
        "code": "1f9a4"
      },
      {
        "icon": "🦚",
        "code": "1f99a"
      },
      {
        "icon": "🦜",
        "code": "1f99c"
      },
      {
        "icon": "🦢",
        "code": "1f9a2"
      },
      {
        "icon": "🦩",
        "code": "1f9a9"
      },
      {
        "icon": "🕊️",
        "code": "1f54a"
      },
      {
        "icon": "🐇",
        "code": "1f407"
      },
      {
        "icon": "🦝",
        "code": "1f99d"
      },
      {
        "icon": "🦨",
        "code": "1f9a8"
      },
      {
        "icon": "🦡",
        "code": "1f9a1"
      },
      {
        "icon": "🦫",
        "code": "1f9ab"
      },
      {
        "icon": "🦦",
        "code": "1f9a6"
      },
      {
        "icon": "🦥",
        "code": "1f9a5"
      },
      {
        "icon": "🐁",
        "code": "1f401"
      },
      {
        "icon": "🐀",
        "code": "1f400"
      },
      {
        "icon": "🐿️",
        "code": "1f43f"
      },
      {
        "icon": "🦔",
        "code": "1f994"
      },
      {
        "icon": "🐾",
        "code": "1f43e"
      },
      {
        "icon": "🐉",
        "code": "1f409"
      },
      {
        "icon": "🐲",
        "code": "1f432"
      },
      {
        "icon": "🐦‍🔥",
        "code": "1f426-200d-1f525"
      },
      {
        "icon": "🌵",
        "code": "1f335"
      },
      {
        "icon": "🎄",
        "code": "1f384"
      },
      {
        "icon": "🌲",
        "code": "1f332"
      },
      {
        "icon": "🌳",
        "code": "1f333"
      },
      {
        "icon": "🌴",
        "code": "1f334"
      },
      {
        "icon": "🪾",
        "code": "1fabe"
      },
      {
        "icon": "🪵",
        "code": "1fab5"
      },
      {
        "icon": "🌱",
        "code": "1f331"
      },
      {
        "icon": "🌿",
        "code": "1f33f"
      },
      {
        "icon": "☘️",
        "code": "2618"
      },
      {
        "icon": "🍀",
        "code": "1f340"
      },
      {
        "icon": "🎍",
        "code": "1f38d"
      },
      {
        "icon": "🪴",
        "code": "1fab4"
      },
      {
        "icon": "🎋",
        "code": "1f38b"
      },
      {
        "icon": "🍃",
        "code": "1f343"
      },
      {
        "icon": "🍂",
        "code": "1f342"
      },
      {
        "icon": "🍁",
        "code": "1f341"
      },
      {
        "icon": "🪺",
        "code": "1faba"
      },
      {
        "icon": "🪹",
        "code": "1fab9"
      },
      {
        "icon": "🍄",
        "code": "1f344"
      },
      {
        "icon": "🍄‍🟫",
        "code": "1f344-200d-1f7eb"
      },
      {
        "icon": "🐚",
        "code": "1f41a"
      },
      {
        "icon": "🪸",
        "code": "1fab8"
      },
      {
        "icon": "🪨",
        "code": "1faa8"
      },
      {
        "icon": "🌾",
        "code": "1f33e"
      },
      {
        "icon": "💐",
        "code": "1f490"
      },
      {
        "icon": "🌷",
        "code": "1f337"
      },
      {
        "icon": "🌹",
        "code": "1f339"
      },
      {
        "icon": "🥀",
        "code": "1f940"
      },
      {
        "icon": "🪻",
        "code": "1fabb"
      },
      {
        "icon": "🪷",
        "code": "1fab7"
      },
      {
        "icon": "🌺",
        "code": "1f33a"
      },
      {
        "icon": "🌸",
        "code": "1f338"
      },
      {
        "icon": "🌼",
        "code": "1f33c"
      },
      {
        "icon": "🌻",
        "code": "1f33b"
      },
      {
        "icon": "🌞",
        "code": "1f31e"
      },
      {
        "icon": "🌝",
        "code": "1f31d"
      },
      {
        "icon": "🌛",
        "code": "1f31b"
      },
      {
        "icon": "🌜",
        "code": "1f31c"
      },
      {
        "icon": "🌚",
        "code": "1f31a"
      },
      {
        "icon": "🌕",
        "code": "1f315"
      },
      {
        "icon": "🌖",
        "code": "1f316"
      },
      {
        "icon": "🌗",
        "code": "1f317"
      },
      {
        "icon": "🌘",
        "code": "1f318"
      },
      {
        "icon": "🌑",
        "code": "1f311"
      },
      {
        "icon": "🌒",
        "code": "1f312"
      },
      {
        "icon": "🌓",
        "code": "1f313"
      },
      {
        "icon": "🌔",
        "code": "1f314"
      },
      {
        "icon": "🌙",
        "code": "1f319"
      },
      {
        "icon": "🌎",
        "code": "1f30e"
      },
      {
        "icon": "🌍",
        "code": "1f30d"
      },
      {
        "icon": "🌏",
        "code": "1f30f"
      },
      {
        "icon": "🪐",
        "code": "1fa90"
      },
      {
        "icon": "💫",
        "code": "1f4ab"
      },
      {
        "icon": "⭐️",
        "code": "2b50"
      },
      {
        "icon": "🌟",
        "code": "1f31f"
      },
      {
        "icon": "✨",
        "code": "2728"
      },
      {
        "icon": "⚡️",
        "code": "26a1"
      },
      {
        "icon": "☄️",
        "code": "2604"
      },
      {
        "icon": "💥",
        "code": "1f4a5"
      },
      {
        "icon": "🔥",
        "code": "1f525"
      },
      {
        "icon": "🌪️",
        "code": "1f32a"
      },
      {
        "icon": "🌈",
        "code": "1f308"
      },
      {
        "icon": "☀️",
        "code": "2600"
      },
      {
        "icon": "🌤️",
        "code": "1f324"
      },
      {
        "icon": "⛅️",
        "code": "26c5"
      },
      {
        "icon": "🌥️",
        "code": "1f325"
      },
      {
        "icon": "☁️",
        "code": "2601"
      },
      {
        "icon": "🌦️",
        "code": "1f326"
      },
      {
        "icon": "🌧️",
        "code": "1f327"
      },
      {
        "icon": "⛈️",
        "code": "26c8"
      },
      {
        "icon": "🌩️",
        "code": "1f329"
      },
      {
        "icon": "🌨️",
        "code": "1f328"
      },
      {
        "icon": "❄️",
        "code": "2744"
      },
      {
        "icon": "☃️",
        "code": "2603"
      },
      {
        "icon": "⛄️",
        "code": "26c4"
      },
      {
        "icon": "🌬️",
        "code": "1f32c"
      },
      {
        "icon": "💨",
        "code": "1f4a8"
      },
      {
        "icon": "💧",
        "code": "1f4a7"
      },
      {
        "icon": "💦",
        "code": "1f4a6"
      },
      {
        "icon": "🫧",
        "code": "1fae7"
      },
      {
        "icon": "☔️",
        "code": "2614"
      },
      {
        "icon": "☂️",
        "code": "2602"
      },
      {
        "icon": "🌊",
        "code": "1f30a"
      },
      {
        "icon": "🌫️",
        "code": "1f32b"
      }
    ]
  },
  {
    "id": "comidas",
    "title": "Comidas",
    "emojis": [
      {
        "icon": "🍏",
        "code": "1f34f"
      },
      {
        "icon": "🍎",
        "code": "1f34e"
      },
      {
        "icon": "🍐",
        "code": "1f350"
      },
      {
        "icon": "🍊",
        "code": "1f34a"
      },
      {
        "icon": "🍋",
        "code": "1f34b"
      },
      {
        "icon": "🍋‍🟩",
        "code": "1f34b-200d-1f7e9"
      },
      {
        "icon": "🍌",
        "code": "1f34c"
      },
      {
        "icon": "🍉",
        "code": "1f349"
      },
      {
        "icon": "🍇",
        "code": "1f347"
      },
      {
        "icon": "🍓",
        "code": "1f353"
      },
      {
        "icon": "🫐",
        "code": "1fad0"
      },
      {
        "icon": "🍈",
        "code": "1f348"
      },
      {
        "icon": "🍒",
        "code": "1f352"
      },
      {
        "icon": "🍑",
        "code": "1f351"
      },
      {
        "icon": "🥭",
        "code": "1f96d"
      },
      {
        "icon": "🍍",
        "code": "1f34d"
      },
      {
        "icon": "🥥",
        "code": "1f965"
      },
      {
        "icon": "🥝",
        "code": "1f95d"
      },
      {
        "icon": "🍅",
        "code": "1f345"
      },
      {
        "icon": "🍆",
        "code": "1f346"
      },
      {
        "icon": "🥑",
        "code": "1f951"
      },
      {
        "icon": "🫛",
        "code": "1fadb"
      },
      {
        "icon": "🥦",
        "code": "1f966"
      },
      {
        "icon": "🥬",
        "code": "1f96c"
      },
      {
        "icon": "🥒",
        "code": "1f952"
      },
      {
        "icon": "🌶️",
        "code": "1f336"
      },
      {
        "icon": "🫑",
        "code": "1fad1"
      },
      {
        "icon": "🌽",
        "code": "1f33d"
      },
      {
        "icon": "🥕",
        "code": "1f955"
      },
      {
        "icon": "🫒",
        "code": "1fad2"
      },
      {
        "icon": "🧄",
        "code": "1f9c4"
      },
      {
        "icon": "🧅",
        "code": "1f9c5"
      },
      {
        "icon": "🥔",
        "code": "1f954"
      },
      {
        "icon": "🫜",
        "code": "1fadc"
      },
      {
        "icon": "🍠",
        "code": "1f360"
      },
      {
        "icon": "🫚",
        "code": "1fada"
      },
      {
        "icon": "🥐",
        "code": "1f950"
      },
      {
        "icon": "🥯",
        "code": "1f96f"
      },
      {
        "icon": "🍞",
        "code": "1f35e"
      },
      {
        "icon": "🥖",
        "code": "1f956"
      },
      {
        "icon": "🥨",
        "code": "1f968"
      },
      {
        "icon": "🧀",
        "code": "1f9c0"
      },
      {
        "icon": "🥚",
        "code": "1f95a"
      },
      {
        "icon": "🍳",
        "code": "1f373"
      },
      {
        "icon": "🧈",
        "code": "1f9c8"
      },
      {
        "icon": "🥞",
        "code": "1f95e"
      },
      {
        "icon": "🧇",
        "code": "1f9c7"
      },
      {
        "icon": "🥓",
        "code": "1f953"
      },
      {
        "icon": "🥩",
        "code": "1f969"
      },
      {
        "icon": "🍗",
        "code": "1f357"
      },
      {
        "icon": "🍖",
        "code": "1f356"
      },
      {
        "icon": "🦴",
        "code": "1f9b4"
      },
      {
        "icon": "🌭",
        "code": "1f32d"
      },
      {
        "icon": "🍔",
        "code": "1f354"
      },
      {
        "icon": "🍟",
        "code": "1f35f"
      },
      {
        "icon": "🍕",
        "code": "1f355"
      },
      {
        "icon": "🫓",
        "code": "1fad3"
      },
      {
        "icon": "🥪",
        "code": "1f96a"
      },
      {
        "icon": "🥙",
        "code": "1f959"
      },
      {
        "icon": "🧆",
        "code": "1f9c6"
      },
      {
        "icon": "🌮",
        "code": "1f32e"
      },
      {
        "icon": "🌯",
        "code": "1f32f"
      },
      {
        "icon": "🫔",
        "code": "1fad4"
      },
      {
        "icon": "🥗",
        "code": "1f957"
      },
      {
        "icon": "🥘",
        "code": "1f958"
      },
      {
        "icon": "🫕",
        "code": "1fad5"
      },
      {
        "icon": "🥫",
        "code": "1f96b"
      },
      {
        "icon": "🫙",
        "code": "1fad9"
      },
      {
        "icon": "🍝",
        "code": "1f35d"
      },
      {
        "icon": "🍜",
        "code": "1f35c"
      },
      {
        "icon": "🍲",
        "code": "1f372"
      },
      {
        "icon": "🍛",
        "code": "1f35b"
      },
      {
        "icon": "🍣",
        "code": "1f363"
      },
      {
        "icon": "🍱",
        "code": "1f371"
      },
      {
        "icon": "🥟",
        "code": "1f95f"
      },
      {
        "icon": "🦪",
        "code": "1f9aa"
      },
      {
        "icon": "🍤",
        "code": "1f364"
      },
      {
        "icon": "🍙",
        "code": "1f359"
      },
      {
        "icon": "🍚",
        "code": "1f35a"
      },
      {
        "icon": "🍘",
        "code": "1f358"
      },
      {
        "icon": "🍥",
        "code": "1f365"
      },
      {
        "icon": "🥠",
        "code": "1f960"
      },
      {
        "icon": "🥮",
        "code": "1f96e"
      },
      {
        "icon": "🍢",
        "code": "1f362"
      },
      {
        "icon": "🍡",
        "code": "1f361"
      },
      {
        "icon": "🍧",
        "code": "1f367"
      },
      {
        "icon": "🍨",
        "code": "1f368"
      },
      {
        "icon": "🍦",
        "code": "1f366"
      },
      {
        "icon": "🥧",
        "code": "1f967"
      },
      {
        "icon": "🧁",
        "code": "1f9c1"
      },
      {
        "icon": "🍰",
        "code": "1f370"
      },
      {
        "icon": "🎂",
        "code": "1f382"
      },
      {
        "icon": "🍮",
        "code": "1f36e"
      },
      {
        "icon": "🍭",
        "code": "1f36d"
      },
      {
        "icon": "🍬",
        "code": "1f36c"
      },
      {
        "icon": "🍫",
        "code": "1f36b"
      },
      {
        "icon": "🍿",
        "code": "1f37f"
      },
      {
        "icon": "🍩",
        "code": "1f369"
      },
      {
        "icon": "🍪",
        "code": "1f36a"
      },
      {
        "icon": "🌰",
        "code": "1f330"
      },
      {
        "icon": "🥜",
        "code": "1f95c"
      },
      {
        "icon": "🫘",
        "code": "1fad8"
      },
      {
        "icon": "🍯",
        "code": "1f36f"
      },
      {
        "icon": "🥛",
        "code": "1f95b"
      },
      {
        "icon": "🫗",
        "code": "1fad7"
      },
      {
        "icon": "🍼",
        "code": "1f37c"
      },
      {
        "icon": "🫖",
        "code": "1fad6"
      },
      {
        "icon": "☕️",
        "code": "2615"
      },
      {
        "icon": "🍵",
        "code": "1f375"
      },
      {
        "icon": "🧃",
        "code": "1f9c3"
      },
      {
        "icon": "🥤",
        "code": "1f964"
      },
      {
        "icon": "🧋",
        "code": "1f9cb"
      },
      {
        "icon": "🍶",
        "code": "1f376"
      },
      {
        "icon": "🍺",
        "code": "1f37a"
      },
      {
        "icon": "🍻",
        "code": "1f37b"
      },
      {
        "icon": "🥂",
        "code": "1f942"
      },
      {
        "icon": "🍷",
        "code": "1f377"
      },
      {
        "icon": "🥃",
        "code": "1f943"
      },
      {
        "icon": "🍸",
        "code": "1f378"
      },
      {
        "icon": "🍹",
        "code": "1f379"
      },
      {
        "icon": "🧉",
        "code": "1f9c9"
      },
      {
        "icon": "🍾",
        "code": "1f37e"
      },
      {
        "icon": "🧊",
        "code": "1f9ca"
      },
      {
        "icon": "🥄",
        "code": "1f944"
      },
      {
        "icon": "🍴",
        "code": "1f374"
      },
      {
        "icon": "🍽️",
        "code": "1f37d"
      },
      {
        "icon": "🥣",
        "code": "1f963"
      },
      {
        "icon": "🥡",
        "code": "1f961"
      },
      {
        "icon": "🥢",
        "code": "1f962"
      },
      {
        "icon": "🧂",
        "code": "1f9c2"
      }
    ]
  },
  {
    "id": "atividades",
    "title": "Atividades",
    "emojis": [
      {
        "icon": "⚽️",
        "code": "26bd"
      },
      {
        "icon": "🏀",
        "code": "1f3c0"
      },
      {
        "icon": "🏈",
        "code": "1f3c8"
      },
      {
        "icon": "⚾️",
        "code": "26be"
      },
      {
        "icon": "🥎",
        "code": "1f94e"
      },
      {
        "icon": "🎾",
        "code": "1f3be"
      },
      {
        "icon": "🏐",
        "code": "1f3d0"
      },
      {
        "icon": "🏉",
        "code": "1f3c9"
      },
      {
        "icon": "🥏",
        "code": "1f94f"
      },
      {
        "icon": "🎱",
        "code": "1f3b1"
      },
      {
        "icon": "🪀",
        "code": "1fa80"
      },
      {
        "icon": "🏓",
        "code": "1f3d3"
      },
      {
        "icon": "🏸",
        "code": "1f3f8"
      },
      {
        "icon": "🏒",
        "code": "1f3d2"
      },
      {
        "icon": "🏑",
        "code": "1f3d1"
      },
      {
        "icon": "🥍",
        "code": "1f94d"
      },
      {
        "icon": "🏏",
        "code": "1f3cf"
      },
      {
        "icon": "🪃",
        "code": "1fa83"
      },
      {
        "icon": "🥅",
        "code": "1f945"
      },
      {
        "icon": "⛳️",
        "code": "26f3"
      },
      {
        "icon": "🪁",
        "code": "1fa81"
      },
      {
        "icon": "🛝",
        "code": "1f6dd"
      },
      {
        "icon": "🏹",
        "code": "1f3f9"
      },
      {
        "icon": "🎣",
        "code": "1f3a3"
      },
      {
        "icon": "🤿",
        "code": "1f93f"
      },
      {
        "icon": "🥊",
        "code": "1f94a"
      },
      {
        "icon": "🥋",
        "code": "1f94b"
      },
      {
        "icon": "🎽",
        "code": "1f3bd"
      },
      {
        "icon": "🛹",
        "code": "1f6f9"
      },
      {
        "icon": "🛼",
        "code": "1f6fc"
      },
      {
        "icon": "🛷",
        "code": "1f6f7"
      },
      {
        "icon": "⛸️",
        "code": "26f8"
      },
      {
        "icon": "🥌",
        "code": "1f94c"
      },
      {
        "icon": "🎿",
        "code": "1f3bf"
      },
      {
        "icon": "⛷️",
        "code": "26f7"
      },
      {
        "icon": "🏂",
        "code": "1f3c2"
      },
      {
        "icon": "🪂",
        "code": "1fa82"
      },
      {
        "icon": "🏋️‍♀️",
        "code": "1f3cb-200d-2640"
      },
      {
        "icon": "🏋️",
        "code": "1f3cb"
      },
      {
        "icon": "🏋️‍♂️",
        "code": "1f3cb-200d-2642"
      },
      {
        "icon": "🤼‍♀️",
        "code": "1f93c-200d-2640"
      },
      {
        "icon": "🤼",
        "code": "1f93c"
      },
      {
        "icon": "🤼‍♂️",
        "code": "1f93c-200d-2642"
      },
      {
        "icon": "🤸‍♀️",
        "code": "1f938-200d-2640"
      },
      {
        "icon": "🤸",
        "code": "1f938"
      },
      {
        "icon": "🤸‍♂️",
        "code": "1f938-200d-2642"
      },
      {
        "icon": "⛹️‍♀️",
        "code": "26f9-200d-2640"
      },
      {
        "icon": "⛹️",
        "code": "26f9"
      },
      {
        "icon": "⛹️‍♂️",
        "code": "26f9-200d-2642"
      },
      {
        "icon": "🤺",
        "code": "1f93a"
      },
      {
        "icon": "🤾‍♀️",
        "code": "1f93e-200d-2640"
      },
      {
        "icon": "🤾",
        "code": "1f93e"
      },
      {
        "icon": "🤾‍♂️",
        "code": "1f93e-200d-2642"
      },
      {
        "icon": "🏌️‍♀️",
        "code": "1f3cc-200d-2640"
      },
      {
        "icon": "🏌️",
        "code": "1f3cc"
      },
      {
        "icon": "🏌️‍♂️",
        "code": "1f3cc-200d-2642"
      },
      {
        "icon": "🏇",
        "code": "1f3c7"
      },
      {
        "icon": "🧘‍♀️",
        "code": "1f9d8-200d-2640"
      },
      {
        "icon": "🧘",
        "code": "1f9d8"
      },
      {
        "icon": "🧘‍♂️",
        "code": "1f9d8-200d-2642"
      },
      {
        "icon": "🏄‍♀️",
        "code": "1f3c4-200d-2640"
      },
      {
        "icon": "🏄",
        "code": "1f3c4"
      },
      {
        "icon": "🏄‍♂️",
        "code": "1f3c4-200d-2642"
      },
      {
        "icon": "🏊‍♀️",
        "code": "1f3ca-200d-2640"
      },
      {
        "icon": "🏊",
        "code": "1f3ca"
      },
      {
        "icon": "🏊‍♂️",
        "code": "1f3ca-200d-2642"
      },
      {
        "icon": "🤽‍♀️",
        "code": "1f93d-200d-2640"
      },
      {
        "icon": "🤽",
        "code": "1f93d"
      },
      {
        "icon": "🤽‍♂️",
        "code": "1f93d-200d-2642"
      },
      {
        "icon": "🚣‍♀️",
        "code": "1f6a3-200d-2640"
      },
      {
        "icon": "🚣",
        "code": "1f6a3"
      },
      {
        "icon": "🚣‍♂️",
        "code": "1f6a3-200d-2642"
      },
      {
        "icon": "🧗‍♀️",
        "code": "1f9d7-200d-2640"
      },
      {
        "icon": "🧗",
        "code": "1f9d7"
      },
      {
        "icon": "🧗‍♂️",
        "code": "1f9d7-200d-2642"
      },
      {
        "icon": "🚵‍♀️",
        "code": "1f6b5-200d-2640"
      },
      {
        "icon": "🚵",
        "code": "1f6b5"
      },
      {
        "icon": "🚵‍♂️",
        "code": "1f6b5-200d-2642"
      },
      {
        "icon": "🚴‍♀️",
        "code": "1f6b4-200d-2640"
      },
      {
        "icon": "🚴",
        "code": "1f6b4"
      },
      {
        "icon": "🚴‍♂️",
        "code": "1f6b4-200d-2642"
      },
      {
        "icon": "🏆",
        "code": "1f3c6"
      },
      {
        "icon": "🥇",
        "code": "1f947"
      },
      {
        "icon": "🥈",
        "code": "1f948"
      },
      {
        "icon": "🥉",
        "code": "1f949"
      },
      {
        "icon": "🏅",
        "code": "1f3c5"
      },
      {
        "icon": "🎖️",
        "code": "1f396"
      },
      {
        "icon": "🏵️",
        "code": "1f3f5"
      },
      {
        "icon": "🎗️",
        "code": "1f397"
      },
      {
        "icon": "🎫",
        "code": "1f3ab"
      },
      {
        "icon": "🎟️",
        "code": "1f39f"
      },
      {
        "icon": "🎪",
        "code": "1f3aa"
      },
      {
        "icon": "🤹‍♀️",
        "code": "1f939-200d-2640"
      },
      {
        "icon": "🤹",
        "code": "1f939"
      },
      {
        "icon": "🤹‍♂️",
        "code": "1f939-200d-2642"
      },
      {
        "icon": "🎭",
        "code": "1f3ad"
      },
      {
        "icon": "🩰",
        "code": "1fa70"
      },
      {
        "icon": "🎨",
        "code": "1f3a8"
      },
      {
        "icon": "🫟",
        "code": "1fadf"
      },
      {
        "icon": "🎬",
        "code": "1f3ac"
      },
      {
        "icon": "🎤",
        "code": "1f3a4"
      },
      {
        "icon": "🎧",
        "code": "1f3a7"
      },
      {
        "icon": "🎼",
        "code": "1f3bc"
      },
      {
        "icon": "🎹",
        "code": "1f3b9"
      },
      {
        "icon": "🪇",
        "code": "1fa87"
      },
      {
        "icon": "🥁",
        "code": "1f941"
      },
      {
        "icon": "🪘",
        "code": "1fa98"
      },
      {
        "icon": "🎷",
        "code": "1f3b7"
      },
      {
        "icon": "🎺",
        "code": "1f3ba"
      },
      {
        "icon": "🪗",
        "code": "1fa97"
      },
      {
        "icon": "🎸",
        "code": "1f3b8"
      },
      {
        "icon": "🪕",
        "code": "1fa95"
      },
      {
        "icon": "🪉",
        "code": "1fa89"
      },
      {
        "icon": "🎻",
        "code": "1f3bb"
      },
      {
        "icon": "🪈",
        "code": "1fa88"
      },
      {
        "icon": "🎲",
        "code": "1f3b2"
      },
      {
        "icon": "♟️",
        "code": "265f"
      },
      {
        "icon": "🎯",
        "code": "1f3af"
      },
      {
        "icon": "🎳",
        "code": "1f3b3"
      },
      {
        "icon": "🎮",
        "code": "1f3ae"
      },
      {
        "icon": "🎰",
        "code": "1f3b0"
      },
      {
        "icon": "🧩",
        "code": "1f9e9"
      }
    ]
  },
  {
    "id": "viagens",
    "title": "Viagens",
    "emojis": [
      {
        "icon": "🚗",
        "code": "1f697"
      },
      {
        "icon": "🚕",
        "code": "1f695"
      },
      {
        "icon": "🚙",
        "code": "1f699"
      },
      {
        "icon": "🚌",
        "code": "1f68c"
      },
      {
        "icon": "🚎",
        "code": "1f68e"
      },
      {
        "icon": "🏎️",
        "code": "1f3ce"
      },
      {
        "icon": "🚓",
        "code": "1f693"
      },
      {
        "icon": "🚑",
        "code": "1f691"
      },
      {
        "icon": "🚒",
        "code": "1f692"
      },
      {
        "icon": "🚐",
        "code": "1f690"
      },
      {
        "icon": "🛻",
        "code": "1f6fb"
      },
      {
        "icon": "🚚",
        "code": "1f69a"
      },
      {
        "icon": "🚛",
        "code": "1f69b"
      },
      {
        "icon": "🚜",
        "code": "1f69c"
      },
      {
        "icon": "🦯",
        "code": "1f9af"
      },
      {
        "icon": "🦽",
        "code": "1f9bd"
      },
      {
        "icon": "🦼",
        "code": "1f9bc"
      },
      {
        "icon": "🩼",
        "code": "1fa7c"
      },
      {
        "icon": "🛴",
        "code": "1f6f4"
      },
      {
        "icon": "🚲",
        "code": "1f6b2"
      },
      {
        "icon": "🛵",
        "code": "1f6f5"
      },
      {
        "icon": "🏍️",
        "code": "1f3cd"
      },
      {
        "icon": "🛺",
        "code": "1f6fa"
      },
      {
        "icon": "🛞",
        "code": "1f6de"
      },
      {
        "icon": "🚨",
        "code": "1f6a8"
      },
      {
        "icon": "🚔",
        "code": "1f694"
      },
      {
        "icon": "🚍",
        "code": "1f68d"
      },
      {
        "icon": "🚘",
        "code": "1f698"
      },
      {
        "icon": "🚖",
        "code": "1f696"
      },
      {
        "icon": "🚡",
        "code": "1f6a1"
      },
      {
        "icon": "🚠",
        "code": "1f6a0"
      },
      {
        "icon": "🚟",
        "code": "1f69f"
      },
      {
        "icon": "🚃",
        "code": "1f683"
      },
      {
        "icon": "🚋",
        "code": "1f68b"
      },
      {
        "icon": "🚞",
        "code": "1f69e"
      },
      {
        "icon": "🚝",
        "code": "1f69d"
      },
      {
        "icon": "🚄",
        "code": "1f684"
      },
      {
        "icon": "🚅",
        "code": "1f685"
      },
      {
        "icon": "🚈",
        "code": "1f688"
      },
      {
        "icon": "🚂",
        "code": "1f682"
      },
      {
        "icon": "🚆",
        "code": "1f686"
      },
      {
        "icon": "🚇",
        "code": "1f687"
      },
      {
        "icon": "🚊",
        "code": "1f68a"
      },
      {
        "icon": "🚉",
        "code": "1f689"
      },
      {
        "icon": "✈️",
        "code": "2708"
      },
      {
        "icon": "🛫",
        "code": "1f6eb"
      },
      {
        "icon": "🛬",
        "code": "1f6ec"
      },
      {
        "icon": "🛩️",
        "code": "1f6e9"
      },
      {
        "icon": "💺",
        "code": "1f4ba"
      },
      {
        "icon": "🛰️",
        "code": "1f6f0"
      },
      {
        "icon": "🚀",
        "code": "1f680"
      },
      {
        "icon": "🛸",
        "code": "1f6f8"
      },
      {
        "icon": "🚁",
        "code": "1f681"
      },
      {
        "icon": "🛶",
        "code": "1f6f6"
      },
      {
        "icon": "⛵️",
        "code": "26f5"
      },
      {
        "icon": "🚤",
        "code": "1f6a4"
      },
      {
        "icon": "🛥️",
        "code": "1f6e5"
      },
      {
        "icon": "🛳️",
        "code": "1f6f3"
      },
      {
        "icon": "⛴️",
        "code": "26f4"
      },
      {
        "icon": "🚢",
        "code": "1f6a2"
      },
      {
        "icon": "🛟",
        "code": "1f6df"
      },
      {
        "icon": "⚓️",
        "code": "2693"
      },
      {
        "icon": "🪝",
        "code": "1fa9d"
      },
      {
        "icon": "⛽️",
        "code": "26fd"
      },
      {
        "icon": "🚧",
        "code": "1f6a7"
      },
      {
        "icon": "🚦",
        "code": "1f6a6"
      },
      {
        "icon": "🚥",
        "code": "1f6a5"
      },
      {
        "icon": "🚏",
        "code": "1f68f"
      },
      {
        "icon": "🗺️",
        "code": "1f5fa"
      },
      {
        "icon": "🗿",
        "code": "1f5ff"
      },
      {
        "icon": "🗽",
        "code": "1f5fd"
      },
      {
        "icon": "🗼",
        "code": "1f5fc"
      },
      {
        "icon": "🏰",
        "code": "1f3f0"
      },
      {
        "icon": "🏯",
        "code": "1f3ef"
      },
      {
        "icon": "🏟️",
        "code": "1f3df"
      },
      {
        "icon": "🎡",
        "code": "1f3a1"
      },
      {
        "icon": "🎢",
        "code": "1f3a2"
      },
      {
        "icon": "🎠",
        "code": "1f3a0"
      },
      {
        "icon": "⛲️",
        "code": "26f2"
      },
      {
        "icon": "⛱️",
        "code": "26f1"
      },
      {
        "icon": "🏖️",
        "code": "1f3d6"
      },
      {
        "icon": "🏝️",
        "code": "1f3dd"
      },
      {
        "icon": "🏜️",
        "code": "1f3dc"
      },
      {
        "icon": "🌋",
        "code": "1f30b"
      },
      {
        "icon": "⛰️",
        "code": "26f0"
      },
      {
        "icon": "🏔️",
        "code": "1f3d4"
      },
      {
        "icon": "🗻",
        "code": "1f5fb"
      },
      {
        "icon": "🏕️",
        "code": "1f3d5"
      },
      {
        "icon": "⛺️",
        "code": "26fa"
      },
      {
        "icon": "🛖",
        "code": "1f6d6"
      },
      {
        "icon": "🏠",
        "code": "1f3e0"
      },
      {
        "icon": "🏡",
        "code": "1f3e1"
      },
      {
        "icon": "🏘️",
        "code": "1f3d8"
      },
      {
        "icon": "🏚️",
        "code": "1f3da"
      },
      {
        "icon": "🏗️",
        "code": "1f3d7"
      },
      {
        "icon": "🏭",
        "code": "1f3ed"
      },
      {
        "icon": "🏢",
        "code": "1f3e2"
      },
      {
        "icon": "🏬",
        "code": "1f3ec"
      },
      {
        "icon": "🏣",
        "code": "1f3e3"
      },
      {
        "icon": "🏤",
        "code": "1f3e4"
      },
      {
        "icon": "🏥",
        "code": "1f3e5"
      },
      {
        "icon": "🏦",
        "code": "1f3e6"
      },
      {
        "icon": "🏨",
        "code": "1f3e8"
      },
      {
        "icon": "🏪",
        "code": "1f3ea"
      },
      {
        "icon": "🏫",
        "code": "1f3eb"
      },
      {
        "icon": "🏩",
        "code": "1f3e9"
      },
      {
        "icon": "💒",
        "code": "1f492"
      },
      {
        "icon": "🏛️",
        "code": "1f3db"
      },
      {
        "icon": "⛪️",
        "code": "26ea"
      },
      {
        "icon": "🕌",
        "code": "1f54c"
      },
      {
        "icon": "🕍",
        "code": "1f54d"
      },
      {
        "icon": "🛕",
        "code": "1f6d5"
      },
      {
        "icon": "🕋",
        "code": "1f54b"
      },
      {
        "icon": "⛩️",
        "code": "26e9"
      },
      {
        "icon": "🛤️",
        "code": "1f6e4"
      },
      {
        "icon": "🛣️",
        "code": "1f6e3"
      },
      {
        "icon": "🗾",
        "code": "1f5fe"
      },
      {
        "icon": "🎑",
        "code": "1f391"
      },
      {
        "icon": "🏞️",
        "code": "1f3de"
      },
      {
        "icon": "🌅",
        "code": "1f305"
      },
      {
        "icon": "🌄",
        "code": "1f304"
      },
      {
        "icon": "🌠",
        "code": "1f320"
      },
      {
        "icon": "🎇",
        "code": "1f387"
      },
      {
        "icon": "🎆",
        "code": "1f386"
      },
      {
        "icon": "🌇",
        "code": "1f307"
      },
      {
        "icon": "🌆",
        "code": "1f306"
      },
      {
        "icon": "🏙️",
        "code": "1f3d9"
      },
      {
        "icon": "🌃",
        "code": "1f303"
      },
      {
        "icon": "🌌",
        "code": "1f30c"
      },
      {
        "icon": "🌉",
        "code": "1f309"
      },
      {
        "icon": "🌁",
        "code": "1f301"
      }
    ]
  },
  {
    "id": "objetos",
    "title": "Objetos",
    "emojis": [
      {
        "icon": "⌚️",
        "code": "231a"
      },
      {
        "icon": "📱",
        "code": "1f4f1"
      },
      {
        "icon": "📲",
        "code": "1f4f2"
      },
      {
        "icon": "💻",
        "code": "1f4bb"
      },
      {
        "icon": "⌨️",
        "code": "2328"
      },
      {
        "icon": "🖥️",
        "code": "1f5a5"
      },
      {
        "icon": "🖨️",
        "code": "1f5a8"
      },
      {
        "icon": "🖱️",
        "code": "1f5b1"
      },
      {
        "icon": "🖲️",
        "code": "1f5b2"
      },
      {
        "icon": "🕹️",
        "code": "1f579"
      },
      {
        "icon": "🗜️",
        "code": "1f5dc"
      },
      {
        "icon": "💽",
        "code": "1f4bd"
      },
      {
        "icon": "💾",
        "code": "1f4be"
      },
      {
        "icon": "💿",
        "code": "1f4bf"
      },
      {
        "icon": "📀",
        "code": "1f4c0"
      },
      {
        "icon": "📼",
        "code": "1f4fc"
      },
      {
        "icon": "📷",
        "code": "1f4f7"
      },
      {
        "icon": "📸",
        "code": "1f4f8"
      },
      {
        "icon": "📹",
        "code": "1f4f9"
      },
      {
        "icon": "🎥",
        "code": "1f3a5"
      },
      {
        "icon": "📽️",
        "code": "1f4fd"
      },
      {
        "icon": "🎞️",
        "code": "1f39e"
      },
      {
        "icon": "📞",
        "code": "1f4de"
      },
      {
        "icon": "☎️",
        "code": "260e"
      },
      {
        "icon": "📟",
        "code": "1f4df"
      },
      {
        "icon": "📠",
        "code": "1f4e0"
      },
      {
        "icon": "📺",
        "code": "1f4fa"
      },
      {
        "icon": "📻",
        "code": "1f4fb"
      },
      {
        "icon": "🎙️",
        "code": "1f399"
      },
      {
        "icon": "🎚️",
        "code": "1f39a"
      },
      {
        "icon": "🎛️",
        "code": "1f39b"
      },
      {
        "icon": "🧭",
        "code": "1f9ed"
      },
      {
        "icon": "⏱️",
        "code": "23f1"
      },
      {
        "icon": "⏲️",
        "code": "23f2"
      },
      {
        "icon": "⏰",
        "code": "23f0"
      },
      {
        "icon": "🕰️",
        "code": "1f570"
      },
      {
        "icon": "⌛️",
        "code": "231b"
      },
      {
        "icon": "⏳",
        "code": "23f3"
      },
      {
        "icon": "📡",
        "code": "1f4e1"
      },
      {
        "icon": "🔋",
        "code": "1f50b"
      },
      {
        "icon": "🪫",
        "code": "1faab"
      },
      {
        "icon": "🔌",
        "code": "1f50c"
      },
      {
        "icon": "💡",
        "code": "1f4a1"
      },
      {
        "icon": "🔦",
        "code": "1f526"
      },
      {
        "icon": "🕯️",
        "code": "1f56f"
      },
      {
        "icon": "🪔",
        "code": "1fa94"
      },
      {
        "icon": "🧯",
        "code": "1f9ef"
      },
      {
        "icon": "🛢️",
        "code": "1f6e2"
      },
      {
        "icon": "💸",
        "code": "1f4b8"
      },
      {
        "icon": "💵",
        "code": "1f4b5"
      },
      {
        "icon": "💴",
        "code": "1f4b4"
      },
      {
        "icon": "💶",
        "code": "1f4b6"
      },
      {
        "icon": "💷",
        "code": "1f4b7"
      },
      {
        "icon": "🪙",
        "code": "1fa99"
      },
      {
        "icon": "💰",
        "code": "1f4b0"
      },
      {
        "icon": "💳",
        "code": "1f4b3"
      },
      {
        "icon": "🪪",
        "code": "1faaa"
      },
      {
        "icon": "💎",
        "code": "1f48e"
      },
      {
        "icon": "⚖️",
        "code": "2696"
      },
      {
        "icon": "🪜",
        "code": "1fa9c"
      },
      {
        "icon": "🧰",
        "code": "1f9f0"
      },
      {
        "icon": "🪛",
        "code": "1fa9b"
      },
      {
        "icon": "🔧",
        "code": "1f527"
      },
      {
        "icon": "🔨",
        "code": "1f528"
      },
      {
        "icon": "⚒️",
        "code": "2692"
      },
      {
        "icon": "🛠️",
        "code": "1f6e0"
      },
      {
        "icon": "⛏️",
        "code": "26cf"
      },
      {
        "icon": "🪏",
        "code": "1fa8f"
      },
      {
        "icon": "🪚",
        "code": "1fa9a"
      },
      {
        "icon": "🔩",
        "code": "1f529"
      },
      {
        "icon": "⚙️",
        "code": "2699"
      },
      {
        "icon": "🪤",
        "code": "1faa4"
      },
      {
        "icon": "🧱",
        "code": "1f9f1"
      },
      {
        "icon": "⛓️",
        "code": "26d3"
      },
      {
        "icon": "⛓️‍💥",
        "code": "26d3-200d-1f4a5"
      },
      {
        "icon": "🧲",
        "code": "1f9f2"
      },
      {
        "icon": "🔫",
        "code": "1f52b"
      },
      {
        "icon": "💣",
        "code": "1f4a3"
      },
      {
        "icon": "🧨",
        "code": "1f9e8"
      },
      {
        "icon": "🪓",
        "code": "1fa93"
      },
      {
        "icon": "🔪",
        "code": "1f52a"
      },
      {
        "icon": "🗡️",
        "code": "1f5e1"
      },
      {
        "icon": "⚔️",
        "code": "2694"
      },
      {
        "icon": "🛡️",
        "code": "1f6e1"
      },
      {
        "icon": "🚬",
        "code": "1f6ac"
      },
      {
        "icon": "⚰️",
        "code": "26b0"
      },
      {
        "icon": "🪦",
        "code": "1faa6"
      },
      {
        "icon": "⚱️",
        "code": "26b1"
      },
      {
        "icon": "🏺",
        "code": "1f3fa"
      },
      {
        "icon": "🔮",
        "code": "1f52e"
      },
      {
        "icon": "📿",
        "code": "1f4ff"
      },
      {
        "icon": "🧿",
        "code": "1f9ff"
      },
      {
        "icon": "🪬",
        "code": "1faac"
      },
      {
        "icon": "💈",
        "code": "1f488"
      },
      {
        "icon": "⚗️",
        "code": "2697"
      },
      {
        "icon": "🔭",
        "code": "1f52d"
      },
      {
        "icon": "🔬",
        "code": "1f52c"
      },
      {
        "icon": "🕳️",
        "code": "1f573"
      },
      {
        "icon": "🩻",
        "code": "1fa7b"
      },
      {
        "icon": "🩹",
        "code": "1fa79"
      },
      {
        "icon": "🩺",
        "code": "1fa7a"
      },
      {
        "icon": "💊",
        "code": "1f48a"
      },
      {
        "icon": "💉",
        "code": "1f489"
      },
      {
        "icon": "🩸",
        "code": "1fa78"
      },
      {
        "icon": "🧬",
        "code": "1f9ec"
      },
      {
        "icon": "🦠",
        "code": "1f9a0"
      },
      {
        "icon": "🧫",
        "code": "1f9eb"
      },
      {
        "icon": "🧪",
        "code": "1f9ea"
      },
      {
        "icon": "🌡️",
        "code": "1f321"
      },
      {
        "icon": "🧹",
        "code": "1f9f9"
      },
      {
        "icon": "🪠",
        "code": "1faa0"
      },
      {
        "icon": "🧺",
        "code": "1f9fa"
      },
      {
        "icon": "🧻",
        "code": "1f9fb"
      },
      {
        "icon": "🚽",
        "code": "1f6bd"
      },
      {
        "icon": "🚰",
        "code": "1f6b0"
      },
      {
        "icon": "🚿",
        "code": "1f6bf"
      },
      {
        "icon": "🛁",
        "code": "1f6c1"
      },
      {
        "icon": "🛀",
        "code": "1f6c0"
      },
      {
        "icon": "🧼",
        "code": "1f9fc"
      },
      {
        "icon": "🪥",
        "code": "1faa5"
      },
      {
        "icon": "🪒",
        "code": "1fa92"
      },
      {
        "icon": "🪮",
        "code": "1faae"
      },
      {
        "icon": "🧽",
        "code": "1f9fd"
      },
      {
        "icon": "🪣",
        "code": "1faa3"
      },
      {
        "icon": "🧴",
        "code": "1f9f4"
      },
      {
        "icon": "🛎️",
        "code": "1f6ce"
      },
      {
        "icon": "🔑",
        "code": "1f511"
      },
      {
        "icon": "🗝️",
        "code": "1f5dd"
      },
      {
        "icon": "🚪",
        "code": "1f6aa"
      },
      {
        "icon": "🪑",
        "code": "1fa91"
      },
      {
        "icon": "🛋️",
        "code": "1f6cb"
      },
      {
        "icon": "🛏️",
        "code": "1f6cf"
      },
      {
        "icon": "🛌",
        "code": "1f6cc"
      },
      {
        "icon": "🧸",
        "code": "1f9f8"
      },
      {
        "icon": "🪆",
        "code": "1fa86"
      },
      {
        "icon": "🖼️",
        "code": "1f5bc"
      },
      {
        "icon": "🪞",
        "code": "1fa9e"
      },
      {
        "icon": "🪟",
        "code": "1fa9f"
      },
      {
        "icon": "🛍️",
        "code": "1f6cd"
      },
      {
        "icon": "🛒",
        "code": "1f6d2"
      },
      {
        "icon": "🎁",
        "code": "1f381"
      },
      {
        "icon": "🎈",
        "code": "1f388"
      },
      {
        "icon": "🎏",
        "code": "1f38f"
      },
      {
        "icon": "🎀",
        "code": "1f380"
      },
      {
        "icon": "🪄",
        "code": "1fa84"
      },
      {
        "icon": "🪅",
        "code": "1fa85"
      },
      {
        "icon": "🎊",
        "code": "1f38a"
      },
      {
        "icon": "🎉",
        "code": "1f389"
      },
      {
        "icon": "🎎",
        "code": "1f38e"
      },
      {
        "icon": "🪭",
        "code": "1faad"
      },
      {
        "icon": "🏮",
        "code": "1f3ee"
      },
      {
        "icon": "🎐",
        "code": "1f390"
      },
      {
        "icon": "🪩",
        "code": "1faa9"
      },
      {
        "icon": "🧧",
        "code": "1f9e7"
      },
      {
        "icon": "✉️",
        "code": "2709"
      },
      {
        "icon": "📩",
        "code": "1f4e9"
      },
      {
        "icon": "📨",
        "code": "1f4e8"
      },
      {
        "icon": "📧",
        "code": "1f4e7"
      },
      {
        "icon": "💌",
        "code": "1f48c"
      },
      {
        "icon": "📥",
        "code": "1f4e5"
      },
      {
        "icon": "📤",
        "code": "1f4e4"
      },
      {
        "icon": "📦",
        "code": "1f4e6"
      },
      {
        "icon": "🏷️",
        "code": "1f3f7"
      },
      {
        "icon": "🪧",
        "code": "1faa7"
      },
      {
        "icon": "📪",
        "code": "1f4ea"
      },
      {
        "icon": "📫",
        "code": "1f4eb"
      },
      {
        "icon": "📬",
        "code": "1f4ec"
      },
      {
        "icon": "📭",
        "code": "1f4ed"
      },
      {
        "icon": "📮",
        "code": "1f4ee"
      },
      {
        "icon": "📯",
        "code": "1f4ef"
      },
      {
        "icon": "📜",
        "code": "1f4dc"
      },
      {
        "icon": "📃",
        "code": "1f4c3"
      },
      {
        "icon": "📄",
        "code": "1f4c4"
      },
      {
        "icon": "📑",
        "code": "1f4d1"
      },
      {
        "icon": "🧾",
        "code": "1f9fe"
      },
      {
        "icon": "📊",
        "code": "1f4ca"
      },
      {
        "icon": "📈",
        "code": "1f4c8"
      },
      {
        "icon": "📉",
        "code": "1f4c9"
      },
      {
        "icon": "🗒️",
        "code": "1f5d2"
      },
      {
        "icon": "🗓️",
        "code": "1f5d3"
      },
      {
        "icon": "📆",
        "code": "1f4c6"
      },
      {
        "icon": "📅",
        "code": "1f4c5"
      },
      {
        "icon": "🗑️",
        "code": "1f5d1"
      },
      {
        "icon": "📇",
        "code": "1f4c7"
      },
      {
        "icon": "🗃️",
        "code": "1f5c3"
      },
      {
        "icon": "🗳️",
        "code": "1f5f3"
      },
      {
        "icon": "🗄️",
        "code": "1f5c4"
      },
      {
        "icon": "📋",
        "code": "1f4cb"
      },
      {
        "icon": "📁",
        "code": "1f4c1"
      },
      {
        "icon": "📂",
        "code": "1f4c2"
      },
      {
        "icon": "🗂️",
        "code": "1f5c2"
      },
      {
        "icon": "🗞️",
        "code": "1f5de"
      },
      {
        "icon": "📰",
        "code": "1f4f0"
      },
      {
        "icon": "📓",
        "code": "1f4d3"
      },
      {
        "icon": "📔",
        "code": "1f4d4"
      },
      {
        "icon": "📒",
        "code": "1f4d2"
      },
      {
        "icon": "📕",
        "code": "1f4d5"
      },
      {
        "icon": "📗",
        "code": "1f4d7"
      },
      {
        "icon": "📘",
        "code": "1f4d8"
      },
      {
        "icon": "📙",
        "code": "1f4d9"
      },
      {
        "icon": "📚",
        "code": "1f4da"
      },
      {
        "icon": "📖",
        "code": "1f4d6"
      },
      {
        "icon": "🔖",
        "code": "1f516"
      },
      {
        "icon": "🧷",
        "code": "1f9f7"
      },
      {
        "icon": "🔗",
        "code": "1f517"
      },
      {
        "icon": "📎",
        "code": "1f4ce"
      },
      {
        "icon": "🖇️",
        "code": "1f587"
      },
      {
        "icon": "📐",
        "code": "1f4d0"
      },
      {
        "icon": "📏",
        "code": "1f4cf"
      },
      {
        "icon": "🧮",
        "code": "1f9ee"
      },
      {
        "icon": "📌",
        "code": "1f4cc"
      },
      {
        "icon": "📍",
        "code": "1f4cd"
      },
      {
        "icon": "✂️",
        "code": "2702"
      },
      {
        "icon": "🖊️",
        "code": "1f58a"
      },
      {
        "icon": "🖋️",
        "code": "1f58b"
      },
      {
        "icon": "✒️",
        "code": "2712"
      },
      {
        "icon": "🖌️",
        "code": "1f58c"
      },
      {
        "icon": "🖍️",
        "code": "1f58d"
      },
      {
        "icon": "📝",
        "code": "1f4dd"
      },
      {
        "icon": "✏️",
        "code": "270f"
      },
      {
        "icon": "🔍",
        "code": "1f50d"
      },
      {
        "icon": "🔎",
        "code": "1f50e"
      },
      {
        "icon": "🔏",
        "code": "1f50f"
      },
      {
        "icon": "🔐",
        "code": "1f510"
      },
      {
        "icon": "🔒",
        "code": "1f512"
      },
      {
        "icon": "🔓",
        "code": "1f513"
      }
    ]
  },
  {
    "id": "simbolos",
    "title": "Símbolos",
    "emojis": [
      {
        "icon": "🩷",
        "code": "1fa77"
      },
      {
        "icon": "❤️",
        "code": "2764"
      },
      {
        "icon": "🧡",
        "code": "1f9e1"
      },
      {
        "icon": "💛",
        "code": "1f49b"
      },
      {
        "icon": "💚",
        "code": "1f49a"
      },
      {
        "icon": "🩵",
        "code": "1fa75"
      },
      {
        "icon": "💙",
        "code": "1f499"
      },
      {
        "icon": "💜",
        "code": "1f49c"
      },
      {
        "icon": "🖤",
        "code": "1f5a4"
      },
      {
        "icon": "🩶",
        "code": "1fa76"
      },
      {
        "icon": "🤍",
        "code": "1f90d"
      },
      {
        "icon": "🤎",
        "code": "1f90e"
      },
      {
        "icon": "💔",
        "code": "1f494"
      },
      {
        "icon": "❤️‍🔥",
        "code": "2764-200d-1f525"
      },
      {
        "icon": "❤️‍🩹",
        "code": "2764-200d-1fa79"
      },
      {
        "icon": "❣️",
        "code": "2763"
      },
      {
        "icon": "💕",
        "code": "1f495"
      },
      {
        "icon": "💞",
        "code": "1f49e"
      },
      {
        "icon": "💓",
        "code": "1f493"
      },
      {
        "icon": "💗",
        "code": "1f497"
      },
      {
        "icon": "💖",
        "code": "1f496"
      },
      {
        "icon": "💘",
        "code": "1f498"
      },
      {
        "icon": "💝",
        "code": "1f49d"
      },
      {
        "icon": "💟",
        "code": "1f49f"
      },
      {
        "icon": "☮️",
        "code": "262e"
      },
      {
        "icon": "✝️",
        "code": "271d"
      },
      {
        "icon": "☪️",
        "code": "262a"
      },
      {
        "icon": "🕉️",
        "code": "1f549"
      },
      {
        "icon": "☸️",
        "code": "2638"
      },
      {
        "icon": "🪯",
        "code": "1faaf"
      },
      {
        "icon": "✡️",
        "code": "2721"
      },
      {
        "icon": "🔯",
        "code": "1f52f"
      },
      {
        "icon": "🕎",
        "code": "1f54e"
      },
      {
        "icon": "☯️",
        "code": "262f"
      },
      {
        "icon": "☦️",
        "code": "2626"
      },
      {
        "icon": "🛐",
        "code": "1f6d0"
      },
      {
        "icon": "⛎",
        "code": "26ce"
      },
      {
        "icon": "♈️",
        "code": "2648"
      },
      {
        "icon": "♉️",
        "code": "2649"
      },
      {
        "icon": "♊️",
        "code": "264a"
      },
      {
        "icon": "♋️",
        "code": "264b"
      },
      {
        "icon": "♌️",
        "code": "264c"
      },
      {
        "icon": "♍️",
        "code": "264d"
      },
      {
        "icon": "♎️",
        "code": "264e"
      },
      {
        "icon": "♏️",
        "code": "264f"
      },
      {
        "icon": "♐️",
        "code": "2650"
      },
      {
        "icon": "♑️",
        "code": "2651"
      },
      {
        "icon": "♒️",
        "code": "2652"
      },
      {
        "icon": "♓️",
        "code": "2653"
      },
      {
        "icon": "🆔",
        "code": "1f194"
      },
      {
        "icon": "⚛️",
        "code": "269b"
      },
      {
        "icon": "🉑",
        "code": "1f251"
      },
      {
        "icon": "☢️",
        "code": "2622"
      },
      {
        "icon": "☣️",
        "code": "2623"
      },
      {
        "icon": "📴",
        "code": "1f4f4"
      },
      {
        "icon": "📳",
        "code": "1f4f3"
      },
      {
        "icon": "🈶",
        "code": "1f236"
      },
      {
        "icon": "🈚️",
        "code": "1f21a"
      },
      {
        "icon": "🈸",
        "code": "1f238"
      },
      {
        "icon": "🈺",
        "code": "1f23a"
      },
      {
        "icon": "🈷️",
        "code": "1f237"
      },
      {
        "icon": "✴️",
        "code": "2734"
      },
      {
        "icon": "🆚",
        "code": "1f19a"
      },
      {
        "icon": "💮",
        "code": "1f4ae"
      },
      {
        "icon": "🉐",
        "code": "1f250"
      },
      {
        "icon": "㊙️",
        "code": "3299"
      },
      {
        "icon": "㊗️",
        "code": "3297"
      },
      {
        "icon": "🈴",
        "code": "1f234"
      },
      {
        "icon": "🈵",
        "code": "1f235"
      },
      {
        "icon": "🈹",
        "code": "1f239"
      },
      {
        "icon": "🈲",
        "code": "1f232"
      },
      {
        "icon": "🅰️",
        "code": "1f170"
      },
      {
        "icon": "🅱️",
        "code": "1f171"
      },
      {
        "icon": "🆎",
        "code": "1f18e"
      },
      {
        "icon": "🆑",
        "code": "1f191"
      },
      {
        "icon": "🅾️",
        "code": "1f17e"
      },
      {
        "icon": "🆘",
        "code": "1f198"
      },
      {
        "icon": "❌",
        "code": "274c"
      },
      {
        "icon": "⭕️",
        "code": "2b55"
      },
      {
        "icon": "🛑",
        "code": "1f6d1"
      },
      {
        "icon": "⛔️",
        "code": "26d4"
      },
      {
        "icon": "📛",
        "code": "1f4db"
      },
      {
        "icon": "🚫",
        "code": "1f6ab"
      },
      {
        "icon": "💯",
        "code": "1f4af"
      },
      {
        "icon": "💢",
        "code": "1f4a2"
      },
      {
        "icon": "♨️",
        "code": "2668"
      },
      {
        "icon": "🚷",
        "code": "1f6b7"
      },
      {
        "icon": "🚯",
        "code": "1f6af"
      },
      {
        "icon": "🚳",
        "code": "1f6b3"
      },
      {
        "icon": "🚱",
        "code": "1f6b1"
      },
      {
        "icon": "🔞",
        "code": "1f51e"
      },
      {
        "icon": "📵",
        "code": "1f4f5"
      },
      {
        "icon": "🚭",
        "code": "1f6ad"
      },
      {
        "icon": "❗️",
        "code": "2757"
      },
      {
        "icon": "❕",
        "code": "2755"
      },
      {
        "icon": "❓",
        "code": "2753"
      },
      {
        "icon": "❔",
        "code": "2754"
      },
      {
        "icon": "‼️",
        "code": "203c"
      },
      {
        "icon": "⁉️",
        "code": "2049"
      },
      {
        "icon": "🔅",
        "code": "1f505"
      },
      {
        "icon": "🔆",
        "code": "1f506"
      },
      {
        "icon": "〽️",
        "code": "303d"
      },
      {
        "icon": "⚠️",
        "code": "26a0"
      },
      {
        "icon": "🚸",
        "code": "1f6b8"
      },
      {
        "icon": "🔱",
        "code": "1f531"
      },
      {
        "icon": "⚜️",
        "code": "269c"
      },
      {
        "icon": "🔰",
        "code": "1f530"
      },
      {
        "icon": "♻️",
        "code": "267b"
      },
      {
        "icon": "✅",
        "code": "2705"
      },
      {
        "icon": "🈯️",
        "code": "1f22f"
      },
      {
        "icon": "💹",
        "code": "1f4b9"
      },
      {
        "icon": "❇️",
        "code": "2747"
      },
      {
        "icon": "✳️",
        "code": "2733"
      },
      {
        "icon": "❎",
        "code": "274e"
      },
      {
        "icon": "🌐",
        "code": "1f310"
      },
      {
        "icon": "💠",
        "code": "1f4a0"
      },
      {
        "icon": "Ⓜ️",
        "code": "24c2"
      },
      {
        "icon": "🌀",
        "code": "1f300"
      },
      {
        "icon": "💤",
        "code": "1f4a4"
      },
      {
        "icon": "🏧",
        "code": "1f3e7"
      },
      {
        "icon": "🚾",
        "code": "1f6be"
      },
      {
        "icon": "♿️",
        "code": "267f"
      },
      {
        "icon": "🅿️",
        "code": "1f17f"
      },
      {
        "icon": "🛗",
        "code": "1f6d7"
      },
      {
        "icon": "🈳",
        "code": "1f233"
      },
      {
        "icon": "🈂️",
        "code": "1f202"
      },
      {
        "icon": "🛂",
        "code": "1f6c2"
      },
      {
        "icon": "🛃",
        "code": "1f6c3"
      },
      {
        "icon": "🛄",
        "code": "1f6c4"
      },
      {
        "icon": "🛅",
        "code": "1f6c5"
      },
      {
        "icon": "🛜",
        "code": "1f6dc"
      },
      {
        "icon": "🚹",
        "code": "1f6b9"
      },
      {
        "icon": "🚺",
        "code": "1f6ba"
      },
      {
        "icon": "🚼",
        "code": "1f6bc"
      },
      {
        "icon": "🧑‍🧑‍🧒",
        "code": "1f9d1-200d-1f9d1-200d-1f9d2"
      },
      {
        "icon": "🧑‍🧑‍🧒‍🧒",
        "code": "1f9d1-200d-1f9d1-200d-1f9d2-200d-1f9d2"
      },
      {
        "icon": "🧑‍🧒",
        "code": "1f9d1-200d-1f9d2"
      },
      {
        "icon": "🧑‍🧒‍🧒",
        "code": "1f9d1-200d-1f9d2-200d-1f9d2"
      },
      {
        "icon": "⚧️",
        "code": "26a7"
      },
      {
        "icon": "🚻",
        "code": "1f6bb"
      },
      {
        "icon": "🚮",
        "code": "1f6ae"
      },
      {
        "icon": "🎦",
        "code": "1f3a6"
      },
      {
        "icon": "📶",
        "code": "1f4f6"
      },
      {
        "icon": "🈁",
        "code": "1f201"
      },
      {
        "icon": "🔣",
        "code": "1f523"
      },
      {
        "icon": "ℹ️",
        "code": "2139"
      },
      {
        "icon": "🔤",
        "code": "1f524"
      },
      {
        "icon": "🔡",
        "code": "1f521"
      },
      {
        "icon": "🔠",
        "code": "1f520"
      },
      {
        "icon": "🆖",
        "code": "1f196"
      },
      {
        "icon": "🆗",
        "code": "1f197"
      },
      {
        "icon": "🆙",
        "code": "1f199"
      },
      {
        "icon": "🆒",
        "code": "1f192"
      },
      {
        "icon": "🆕",
        "code": "1f195"
      },
      {
        "icon": "🆓",
        "code": "1f193"
      },
      {
        "icon": "0️⃣",
        "code": "30-20e3"
      },
      {
        "icon": "1️⃣",
        "code": "31-20e3"
      },
      {
        "icon": "2️⃣",
        "code": "32-20e3"
      },
      {
        "icon": "3️⃣",
        "code": "33-20e3"
      },
      {
        "icon": "4️⃣",
        "code": "34-20e3"
      },
      {
        "icon": "5️⃣",
        "code": "35-20e3"
      },
      {
        "icon": "6️⃣",
        "code": "36-20e3"
      },
      {
        "icon": "7️⃣",
        "code": "37-20e3"
      },
      {
        "icon": "8️⃣",
        "code": "38-20e3"
      },
      {
        "icon": "9️⃣",
        "code": "39-20e3"
      },
      {
        "icon": "🔟",
        "code": "1f51f"
      },
      {
        "icon": "🔢",
        "code": "1f522"
      },
      {
        "icon": "#️⃣",
        "code": "23-20e3"
      },
      {
        "icon": "*️⃣",
        "code": "2a-20e3"
      },
      {
        "icon": "⏏️",
        "code": "23cf"
      },
      {
        "icon": "▶️",
        "code": "25b6"
      },
      {
        "icon": "⏸️",
        "code": "23f8"
      },
      {
        "icon": "⏯️",
        "code": "23ef"
      },
      {
        "icon": "⏹️",
        "code": "23f9"
      },
      {
        "icon": "⏺️",
        "code": "23fa"
      },
      {
        "icon": "⏭️",
        "code": "23ed"
      },
      {
        "icon": "⏮️",
        "code": "23ee"
      },
      {
        "icon": "⏩️",
        "code": "23e9"
      },
      {
        "icon": "⏪️",
        "code": "23ea"
      },
      {
        "icon": "⏫️",
        "code": "23eb"
      },
      {
        "icon": "⏬️",
        "code": "23ec"
      },
      {
        "icon": "◀️",
        "code": "25c0"
      },
      {
        "icon": "🔼",
        "code": "1f53c"
      },
      {
        "icon": "🔽",
        "code": "1f53d"
      },
      {
        "icon": "➡️",
        "code": "27a1"
      },
      {
        "icon": "⬅️",
        "code": "2b05"
      },
      {
        "icon": "⬆️",
        "code": "2b06"
      },
      {
        "icon": "⬇️",
        "code": "2b07"
      },
      {
        "icon": "↗️",
        "code": "2197"
      },
      {
        "icon": "↘️",
        "code": "2198"
      },
      {
        "icon": "↙️",
        "code": "2199"
      },
      {
        "icon": "↖️",
        "code": "2196"
      },
      {
        "icon": "↕️",
        "code": "2195"
      },
      {
        "icon": "↔️",
        "code": "2194"
      },
      {
        "icon": "↪️",
        "code": "21aa"
      },
      {
        "icon": "↩️",
        "code": "21a9"
      },
      {
        "icon": "⤴️",
        "code": "2934"
      },
      {
        "icon": "⤵️",
        "code": "2935"
      },
      {
        "icon": "🔀",
        "code": "1f500"
      },
      {
        "icon": "🔁",
        "code": "1f501"
      },
      {
        "icon": "🔂",
        "code": "1f502"
      },
      {
        "icon": "🔄",
        "code": "1f504"
      },
      {
        "icon": "🔃",
        "code": "1f503"
      },
      {
        "icon": "🎵",
        "code": "1f3b5"
      },
      {
        "icon": "🎶",
        "code": "1f3b6"
      },
      {
        "icon": "➕",
        "code": "2795"
      },
      {
        "icon": "➖",
        "code": "2796"
      },
      {
        "icon": "➗",
        "code": "2797"
      },
      {
        "icon": "✖️",
        "code": "2716"
      },
      {
        "icon": "🟰",
        "code": "1f7f0"
      },
      {
        "icon": "♾️",
        "code": "267e"
      },
      {
        "icon": "💲",
        "code": "1f4b2"
      },
      {
        "icon": "💱",
        "code": "1f4b1"
      },
      {
        "icon": "™️",
        "code": "2122"
      },
      {
        "icon": "©️",
        "code": "a9"
      },
      {
        "icon": "®️",
        "code": "ae"
      },
      {
        "icon": "👁️‍🗨️",
        "code": "1f441-200d-1f5e8"
      },
      {
        "icon": "🔚",
        "code": "1f51a"
      },
      {
        "icon": "🔙",
        "code": "1f519"
      },
      {
        "icon": "🔛",
        "code": "1f51b"
      },
      {
        "icon": "🔝",
        "code": "1f51d"
      },
      {
        "icon": "🔜",
        "code": "1f51c"
      },
      {
        "icon": "〰️",
        "code": "3030"
      },
      {
        "icon": "➰",
        "code": "27b0"
      },
      {
        "icon": "➿",
        "code": "27bf"
      },
      {
        "icon": "✔️",
        "code": "2714"
      },
      {
        "icon": "☑️",
        "code": "2611"
      },
      {
        "icon": "🔘",
        "code": "1f518"
      },
      {
        "icon": "🔴",
        "code": "1f534"
      },
      {
        "icon": "🟠",
        "code": "1f7e0"
      },
      {
        "icon": "🟡",
        "code": "1f7e1"
      },
      {
        "icon": "🟢",
        "code": "1f7e2"
      },
      {
        "icon": "🔵",
        "code": "1f535"
      },
      {
        "icon": "🟣",
        "code": "1f7e3"
      },
      {
        "icon": "⚫️",
        "code": "26ab"
      },
      {
        "icon": "⚪️",
        "code": "26aa"
      },
      {
        "icon": "🟤",
        "code": "1f7e4"
      },
      {
        "icon": "🔺",
        "code": "1f53a"
      },
      {
        "icon": "🔻",
        "code": "1f53b"
      },
      {
        "icon": "🔸",
        "code": "1f538"
      },
      {
        "icon": "🔹",
        "code": "1f539"
      },
      {
        "icon": "🔶",
        "code": "1f536"
      },
      {
        "icon": "🔷",
        "code": "1f537"
      },
      {
        "icon": "🔳",
        "code": "1f533"
      },
      {
        "icon": "🔲",
        "code": "1f532"
      },
      {
        "icon": "▪️",
        "code": "25aa"
      },
      {
        "icon": "▫️",
        "code": "25ab"
      },
      {
        "icon": "◾️",
        "code": "25fe"
      },
      {
        "icon": "◽️",
        "code": "25fd"
      },
      {
        "icon": "◼️",
        "code": "25fc"
      },
      {
        "icon": "◻️",
        "code": "25fb"
      },
      {
        "icon": "🟥",
        "code": "1f7e5"
      },
      {
        "icon": "🟧",
        "code": "1f7e7"
      },
      {
        "icon": "🟨",
        "code": "1f7e8"
      },
      {
        "icon": "🟩",
        "code": "1f7e9"
      },
      {
        "icon": "🟦",
        "code": "1f7e6"
      },
      {
        "icon": "🟪",
        "code": "1f7ea"
      },
      {
        "icon": "⬛️",
        "code": "2b1b"
      },
      {
        "icon": "⬜️",
        "code": "2b1c"
      },
      {
        "icon": "🟫",
        "code": "1f7eb"
      },
      {
        "icon": "🔈",
        "code": "1f508"
      },
      {
        "icon": "🔇",
        "code": "1f507"
      },
      {
        "icon": "🔉",
        "code": "1f509"
      },
      {
        "icon": "🔊",
        "code": "1f50a"
      },
      {
        "icon": "🔔",
        "code": "1f514"
      },
      {
        "icon": "🔕",
        "code": "1f515"
      },
      {
        "icon": "📣",
        "code": "1f4e3"
      },
      {
        "icon": "📢",
        "code": "1f4e2"
      },
      {
        "icon": "💬",
        "code": "1f4ac"
      },
      {
        "icon": "💭",
        "code": "1f4ad"
      },
      {
        "icon": "🗯️",
        "code": "1f5ef"
      },
      {
        "icon": "♠️",
        "code": "2660"
      },
      {
        "icon": "♣️",
        "code": "2663"
      },
      {
        "icon": "♥️",
        "code": "2665"
      },
      {
        "icon": "♦️",
        "code": "2666"
      },
      {
        "icon": "🃏",
        "code": "1f0cf"
      },
      {
        "icon": "🎴",
        "code": "1f3b4"
      },
      {
        "icon": "🀄️",
        "code": "1f004"
      },
      {
        "icon": "🕐",
        "code": "1f550"
      },
      {
        "icon": "🕑",
        "code": "1f551"
      },
      {
        "icon": "🕒",
        "code": "1f552"
      },
      {
        "icon": "🕓",
        "code": "1f553"
      },
      {
        "icon": "🕔",
        "code": "1f554"
      },
      {
        "icon": "🕕",
        "code": "1f555"
      },
      {
        "icon": "🕖",
        "code": "1f556"
      },
      {
        "icon": "🕗",
        "code": "1f557"
      },
      {
        "icon": "🕘",
        "code": "1f558"
      },
      {
        "icon": "🕙",
        "code": "1f559"
      },
      {
        "icon": "🕚",
        "code": "1f55a"
      },
      {
        "icon": "🕛",
        "code": "1f55b"
      },
      {
        "icon": "🕜",
        "code": "1f55c"
      },
      {
        "icon": "🕝",
        "code": "1f55d"
      },
      {
        "icon": "🕞",
        "code": "1f55e"
      },
      {
        "icon": "🕟",
        "code": "1f55f"
      },
      {
        "icon": "🕠",
        "code": "1f560"
      },
      {
        "icon": "🕡",
        "code": "1f561"
      },
      {
        "icon": "🕢",
        "code": "1f562"
      },
      {
        "icon": "🕣",
        "code": "1f563"
      },
      {
        "icon": "🕤",
        "code": "1f564"
      },
      {
        "icon": "🕥",
        "code": "1f565"
      },
      {
        "icon": "🕦",
        "code": "1f566"
      },
      {
        "icon": "🕧",
        "code": "1f567"
      }
    ]
  },
  {
    "id": "bandeiras",
    "title": "Bandeiras",
    "emojis": [
      {
        "icon": "🏳️",
        "code": "1f3f3"
      },
      {
        "icon": "🏴",
        "code": "1f3f4"
      },
      {
        "icon": "🏴‍☠️",
        "code": "1f3f4-200d-2620"
      },
      {
        "icon": "🏁",
        "code": "1f3c1"
      },
      {
        "icon": "🚩",
        "code": "1f6a9"
      },
      {
        "icon": "🏳️‍🌈",
        "code": "1f3f3-200d-1f308"
      },
      {
        "icon": "🏳️‍⚧️",
        "code": "1f3f3-200d-26a7"
      },
      {
        "icon": "🇺🇳",
        "code": "1f1fa-1f1f3"
      },
      {
        "icon": "🇦🇫",
        "code": "1f1e6-1f1eb"
      },
      {
        "icon": "🇦🇽",
        "code": "1f1e6-1f1fd"
      },
      {
        "icon": "🇦🇱",
        "code": "1f1e6-1f1f1"
      },
      {
        "icon": "🇩🇿",
        "code": "1f1e9-1f1ff"
      },
      {
        "icon": "🇦🇸",
        "code": "1f1e6-1f1f8"
      },
      {
        "icon": "🇦🇩",
        "code": "1f1e6-1f1e9"
      },
      {
        "icon": "🇦🇴",
        "code": "1f1e6-1f1f4"
      },
      {
        "icon": "🇦🇮",
        "code": "1f1e6-1f1ee"
      },
      {
        "icon": "🇦🇶",
        "code": "1f1e6-1f1f6"
      },
      {
        "icon": "🇦🇬",
        "code": "1f1e6-1f1ec"
      },
      {
        "icon": "🇦🇷",
        "code": "1f1e6-1f1f7"
      },
      {
        "icon": "🇦🇲",
        "code": "1f1e6-1f1f2"
      },
      {
        "icon": "🇦🇼",
        "code": "1f1e6-1f1fc"
      },
      {
        "icon": "🇦🇺",
        "code": "1f1e6-1f1fa"
      },
      {
        "icon": "🇦🇹",
        "code": "1f1e6-1f1f9"
      },
      {
        "icon": "🇦🇿",
        "code": "1f1e6-1f1ff"
      },
      {
        "icon": "🇧🇸",
        "code": "1f1e7-1f1f8"
      },
      {
        "icon": "🇧🇭",
        "code": "1f1e7-1f1ed"
      },
      {
        "icon": "🇧🇩",
        "code": "1f1e7-1f1e9"
      },
      {
        "icon": "🇧🇧",
        "code": "1f1e7-1f1e7"
      },
      {
        "icon": "🇧🇾",
        "code": "1f1e7-1f1fe"
      },
      {
        "icon": "🇧🇪",
        "code": "1f1e7-1f1ea"
      },
      {
        "icon": "🇧🇿",
        "code": "1f1e7-1f1ff"
      },
      {
        "icon": "🇧🇯",
        "code": "1f1e7-1f1ef"
      },
      {
        "icon": "🇧🇲",
        "code": "1f1e7-1f1f2"
      },
      {
        "icon": "🇧🇹",
        "code": "1f1e7-1f1f9"
      },
      {
        "icon": "🇧🇴",
        "code": "1f1e7-1f1f4"
      },
      {
        "icon": "🇧🇦",
        "code": "1f1e7-1f1e6"
      },
      {
        "icon": "🇧🇼",
        "code": "1f1e7-1f1fc"
      },
      {
        "icon": "🇧🇷",
        "code": "1f1e7-1f1f7"
      },
      {
        "icon": "🇻🇬",
        "code": "1f1fb-1f1ec"
      },
      {
        "icon": "🇧🇳",
        "code": "1f1e7-1f1f3"
      },
      {
        "icon": "🇧🇬",
        "code": "1f1e7-1f1ec"
      },
      {
        "icon": "🇧🇫",
        "code": "1f1e7-1f1eb"
      },
      {
        "icon": "🇧🇮",
        "code": "1f1e7-1f1ee"
      },
      {
        "icon": "🇰🇭",
        "code": "1f1f0-1f1ed"
      },
      {
        "icon": "🇨🇲",
        "code": "1f1e8-1f1f2"
      },
      {
        "icon": "🇨🇦",
        "code": "1f1e8-1f1e6"
      },
      {
        "icon": "🇮🇨",
        "code": "1f1ee-1f1e8"
      },
      {
        "icon": "🇨🇻",
        "code": "1f1e8-1f1fb"
      },
      {
        "icon": "🇧🇶",
        "code": "1f1e7-1f1f6"
      },
      {
        "icon": "🇰🇾",
        "code": "1f1f0-1f1fe"
      },
      {
        "icon": "🇨🇫",
        "code": "1f1e8-1f1eb"
      },
      {
        "icon": "🇹🇩",
        "code": "1f1f9-1f1e9"
      },
      {
        "icon": "🇮🇴",
        "code": "1f1ee-1f1f4"
      },
      {
        "icon": "🇨🇱",
        "code": "1f1e8-1f1f1"
      },
      {
        "icon": "🇨🇳",
        "code": "1f1e8-1f1f3"
      },
      {
        "icon": "🇨🇽",
        "code": "1f1e8-1f1fd"
      },
      {
        "icon": "🇨🇨",
        "code": "1f1e8-1f1e8"
      },
      {
        "icon": "🇨🇴",
        "code": "1f1e8-1f1f4"
      },
      {
        "icon": "🇰🇲",
        "code": "1f1f0-1f1f2"
      },
      {
        "icon": "🇨🇬",
        "code": "1f1e8-1f1ec"
      },
      {
        "icon": "🇨🇩",
        "code": "1f1e8-1f1e9"
      },
      {
        "icon": "🇨🇰",
        "code": "1f1e8-1f1f0"
      },
      {
        "icon": "🇨🇷",
        "code": "1f1e8-1f1f7"
      },
      {
        "icon": "🇨🇮",
        "code": "1f1e8-1f1ee"
      },
      {
        "icon": "🇭🇷",
        "code": "1f1ed-1f1f7"
      },
      {
        "icon": "🇨🇺",
        "code": "1f1e8-1f1fa"
      },
      {
        "icon": "🇨🇼",
        "code": "1f1e8-1f1fc"
      },
      {
        "icon": "🇨🇾",
        "code": "1f1e8-1f1fe"
      },
      {
        "icon": "🇨🇿",
        "code": "1f1e8-1f1ff"
      },
      {
        "icon": "🇩🇰",
        "code": "1f1e9-1f1f0"
      },
      {
        "icon": "🇩🇯",
        "code": "1f1e9-1f1ef"
      },
      {
        "icon": "🇩🇲",
        "code": "1f1e9-1f1f2"
      },
      {
        "icon": "🇩🇴",
        "code": "1f1e9-1f1f4"
      },
      {
        "icon": "🇪🇨",
        "code": "1f1ea-1f1e8"
      },
      {
        "icon": "🇪🇬",
        "code": "1f1ea-1f1ec"
      },
      {
        "icon": "🇸🇻",
        "code": "1f1f8-1f1fb"
      },
      {
        "icon": "🇬🇶",
        "code": "1f1ec-1f1f6"
      },
      {
        "icon": "🇪🇷",
        "code": "1f1ea-1f1f7"
      },
      {
        "icon": "🇪🇪",
        "code": "1f1ea-1f1ea"
      },
      {
        "icon": "🇸🇿",
        "code": "1f1f8-1f1ff"
      },
      {
        "icon": "🇪🇹",
        "code": "1f1ea-1f1f9"
      },
      {
        "icon": "🇪🇺",
        "code": "1f1ea-1f1fa"
      },
      {
        "icon": "🇫🇰",
        "code": "1f1eb-1f1f0"
      },
      {
        "icon": "🇫🇴",
        "code": "1f1eb-1f1f4"
      },
      {
        "icon": "🇫🇯",
        "code": "1f1eb-1f1ef"
      },
      {
        "icon": "🇫🇮",
        "code": "1f1eb-1f1ee"
      },
      {
        "icon": "🇫🇷",
        "code": "1f1eb-1f1f7"
      },
      {
        "icon": "🇬🇫",
        "code": "1f1ec-1f1eb"
      },
      {
        "icon": "🇵🇫",
        "code": "1f1f5-1f1eb"
      },
      {
        "icon": "🇹🇫",
        "code": "1f1f9-1f1eb"
      },
      {
        "icon": "🇬🇦",
        "code": "1f1ec-1f1e6"
      },
      {
        "icon": "🇬🇲",
        "code": "1f1ec-1f1f2"
      },
      {
        "icon": "🇬🇪",
        "code": "1f1ec-1f1ea"
      },
      {
        "icon": "🇩🇪",
        "code": "1f1e9-1f1ea"
      },
      {
        "icon": "🇬🇭",
        "code": "1f1ec-1f1ed"
      },
      {
        "icon": "🇬🇮",
        "code": "1f1ec-1f1ee"
      },
      {
        "icon": "🇬🇷",
        "code": "1f1ec-1f1f7"
      },
      {
        "icon": "🇬🇱",
        "code": "1f1ec-1f1f1"
      },
      {
        "icon": "🇬🇩",
        "code": "1f1ec-1f1e9"
      },
      {
        "icon": "🇬🇵",
        "code": "1f1ec-1f1f5"
      },
      {
        "icon": "🇬🇺",
        "code": "1f1ec-1f1fa"
      },
      {
        "icon": "🇬🇹",
        "code": "1f1ec-1f1f9"
      },
      {
        "icon": "🇬🇬",
        "code": "1f1ec-1f1ec"
      },
      {
        "icon": "🇬🇳",
        "code": "1f1ec-1f1f3"
      },
      {
        "icon": "🇬🇼",
        "code": "1f1ec-1f1fc"
      },
      {
        "icon": "🇬🇾",
        "code": "1f1ec-1f1fe"
      },
      {
        "icon": "🇭🇹",
        "code": "1f1ed-1f1f9"
      },
      {
        "icon": "🇭🇳",
        "code": "1f1ed-1f1f3"
      },
      {
        "icon": "🇭🇰",
        "code": "1f1ed-1f1f0"
      },
      {
        "icon": "🇭🇺",
        "code": "1f1ed-1f1fa"
      },
      {
        "icon": "🇮🇸",
        "code": "1f1ee-1f1f8"
      },
      {
        "icon": "🇮🇳",
        "code": "1f1ee-1f1f3"
      },
      {
        "icon": "🇮🇩",
        "code": "1f1ee-1f1e9"
      },
      {
        "icon": "🇮🇷",
        "code": "1f1ee-1f1f7"
      },
      {
        "icon": "🇮🇶",
        "code": "1f1ee-1f1f6"
      },
      {
        "icon": "🇮🇪",
        "code": "1f1ee-1f1ea"
      },
      {
        "icon": "🇮🇲",
        "code": "1f1ee-1f1f2"
      },
      {
        "icon": "🇮🇱",
        "code": "1f1ee-1f1f1"
      },
      {
        "icon": "🇮🇹",
        "code": "1f1ee-1f1f9"
      },
      {
        "icon": "🇯🇲",
        "code": "1f1ef-1f1f2"
      },
      {
        "icon": "🇯🇵",
        "code": "1f1ef-1f1f5"
      },
      {
        "icon": "🎌",
        "code": "1f38c"
      },
      {
        "icon": "🇯🇪",
        "code": "1f1ef-1f1ea"
      },
      {
        "icon": "🇯🇴",
        "code": "1f1ef-1f1f4"
      },
      {
        "icon": "🇰🇿",
        "code": "1f1f0-1f1ff"
      },
      {
        "icon": "🇰🇪",
        "code": "1f1f0-1f1ea"
      },
      {
        "icon": "🇰🇮",
        "code": "1f1f0-1f1ee"
      },
      {
        "icon": "🇽🇰",
        "code": "1f1fd-1f1f0"
      },
      {
        "icon": "🇰🇼",
        "code": "1f1f0-1f1fc"
      },
      {
        "icon": "🇰🇬",
        "code": "1f1f0-1f1ec"
      },
      {
        "icon": "🇱🇦",
        "code": "1f1f1-1f1e6"
      },
      {
        "icon": "🇱🇻",
        "code": "1f1f1-1f1fb"
      },
      {
        "icon": "🇱🇧",
        "code": "1f1f1-1f1e7"
      },
      {
        "icon": "🇱🇸",
        "code": "1f1f1-1f1f8"
      },
      {
        "icon": "🇱🇷",
        "code": "1f1f1-1f1f7"
      },
      {
        "icon": "🇱🇾",
        "code": "1f1f1-1f1fe"
      },
      {
        "icon": "🇱🇮",
        "code": "1f1f1-1f1ee"
      },
      {
        "icon": "🇱🇹",
        "code": "1f1f1-1f1f9"
      },
      {
        "icon": "🇱🇺",
        "code": "1f1f1-1f1fa"
      },
      {
        "icon": "🇲🇴",
        "code": "1f1f2-1f1f4"
      },
      {
        "icon": "🇲🇬",
        "code": "1f1f2-1f1ec"
      },
      {
        "icon": "🇲🇼",
        "code": "1f1f2-1f1fc"
      },
      {
        "icon": "🇲🇾",
        "code": "1f1f2-1f1fe"
      },
      {
        "icon": "🇲🇻",
        "code": "1f1f2-1f1fb"
      },
      {
        "icon": "🇲🇱",
        "code": "1f1f2-1f1f1"
      },
      {
        "icon": "🇲🇹",
        "code": "1f1f2-1f1f9"
      },
      {
        "icon": "🇲🇭",
        "code": "1f1f2-1f1ed"
      },
      {
        "icon": "🇲🇶",
        "code": "1f1f2-1f1f6"
      },
      {
        "icon": "🇲🇷",
        "code": "1f1f2-1f1f7"
      },
      {
        "icon": "🇲🇺",
        "code": "1f1f2-1f1fa"
      },
      {
        "icon": "🇾🇹",
        "code": "1f1fe-1f1f9"
      },
      {
        "icon": "🇲🇽",
        "code": "1f1f2-1f1fd"
      },
      {
        "icon": "🇫🇲",
        "code": "1f1eb-1f1f2"
      },
      {
        "icon": "🇲🇩",
        "code": "1f1f2-1f1e9"
      },
      {
        "icon": "🇲🇨",
        "code": "1f1f2-1f1e8"
      },
      {
        "icon": "🇲🇳",
        "code": "1f1f2-1f1f3"
      },
      {
        "icon": "🇲🇪",
        "code": "1f1f2-1f1ea"
      },
      {
        "icon": "🇲🇸",
        "code": "1f1f2-1f1f8"
      },
      {
        "icon": "🇲🇦",
        "code": "1f1f2-1f1e6"
      },
      {
        "icon": "🇲🇿",
        "code": "1f1f2-1f1ff"
      },
      {
        "icon": "🇲🇲",
        "code": "1f1f2-1f1f2"
      },
      {
        "icon": "🇳🇦",
        "code": "1f1f3-1f1e6"
      },
      {
        "icon": "🇳🇷",
        "code": "1f1f3-1f1f7"
      },
      {
        "icon": "🇳🇵",
        "code": "1f1f3-1f1f5"
      },
      {
        "icon": "🇳🇱",
        "code": "1f1f3-1f1f1"
      },
      {
        "icon": "🇳🇨",
        "code": "1f1f3-1f1e8"
      },
      {
        "icon": "🇳🇿",
        "code": "1f1f3-1f1ff"
      },
      {
        "icon": "🇳🇮",
        "code": "1f1f3-1f1ee"
      },
      {
        "icon": "🇳🇪",
        "code": "1f1f3-1f1ea"
      },
      {
        "icon": "🇳🇬",
        "code": "1f1f3-1f1ec"
      },
      {
        "icon": "🇳🇺",
        "code": "1f1f3-1f1fa"
      },
      {
        "icon": "🇳🇫",
        "code": "1f1f3-1f1eb"
      },
      {
        "icon": "🇰🇵",
        "code": "1f1f0-1f1f5"
      },
      {
        "icon": "🇲🇰",
        "code": "1f1f2-1f1f0"
      },
      {
        "icon": "🇲🇵",
        "code": "1f1f2-1f1f5"
      },
      {
        "icon": "🇳🇴",
        "code": "1f1f3-1f1f4"
      },
      {
        "icon": "🇴🇲",
        "code": "1f1f4-1f1f2"
      },
      {
        "icon": "🇵🇰",
        "code": "1f1f5-1f1f0"
      },
      {
        "icon": "🇵🇼",
        "code": "1f1f5-1f1fc"
      },
      {
        "icon": "🇵🇸",
        "code": "1f1f5-1f1f8"
      },
      {
        "icon": "🇵🇦",
        "code": "1f1f5-1f1e6"
      },
      {
        "icon": "🇵🇬",
        "code": "1f1f5-1f1ec"
      },
      {
        "icon": "🇵🇾",
        "code": "1f1f5-1f1fe"
      },
      {
        "icon": "🇵🇪",
        "code": "1f1f5-1f1ea"
      },
      {
        "icon": "🇵🇭",
        "code": "1f1f5-1f1ed"
      },
      {
        "icon": "🇵🇳",
        "code": "1f1f5-1f1f3"
      },
      {
        "icon": "🇵🇱",
        "code": "1f1f5-1f1f1"
      },
      {
        "icon": "🇵🇹",
        "code": "1f1f5-1f1f9"
      },
      {
        "icon": "🇵🇷",
        "code": "1f1f5-1f1f7"
      },
      {
        "icon": "🇶🇦",
        "code": "1f1f6-1f1e6"
      },
      {
        "icon": "🇷🇪",
        "code": "1f1f7-1f1ea"
      },
      {
        "icon": "🇷🇴",
        "code": "1f1f7-1f1f4"
      },
      {
        "icon": "🇷🇺",
        "code": "1f1f7-1f1fa"
      },
      {
        "icon": "🇷🇼",
        "code": "1f1f7-1f1fc"
      },
      {
        "icon": "🇼🇸",
        "code": "1f1fc-1f1f8"
      },
      {
        "icon": "🇸🇲",
        "code": "1f1f8-1f1f2"
      },
      {
        "icon": "🇸🇹",
        "code": "1f1f8-1f1f9"
      },
      {
        "icon": "🇨🇶",
        "code": "1f1e8-1f1f6"
      },
      {
        "icon": "🇸🇦",
        "code": "1f1f8-1f1e6"
      },
      {
        "icon": "🇸🇳",
        "code": "1f1f8-1f1f3"
      },
      {
        "icon": "🇷🇸",
        "code": "1f1f7-1f1f8"
      },
      {
        "icon": "🇸🇨",
        "code": "1f1f8-1f1e8"
      },
      {
        "icon": "🇸🇱",
        "code": "1f1f8-1f1f1"
      },
      {
        "icon": "🇸🇬",
        "code": "1f1f8-1f1ec"
      },
      {
        "icon": "🇸🇽",
        "code": "1f1f8-1f1fd"
      },
      {
        "icon": "🇸🇰",
        "code": "1f1f8-1f1f0"
      },
      {
        "icon": "🇸🇮",
        "code": "1f1f8-1f1ee"
      },
      {
        "icon": "🇬🇸",
        "code": "1f1ec-1f1f8"
      },
      {
        "icon": "🇸🇧",
        "code": "1f1f8-1f1e7"
      },
      {
        "icon": "🇸🇴",
        "code": "1f1f8-1f1f4"
      },
      {
        "icon": "🇿🇦",
        "code": "1f1ff-1f1e6"
      },
      {
        "icon": "🇰🇷",
        "code": "1f1f0-1f1f7"
      },
      {
        "icon": "🇸🇸",
        "code": "1f1f8-1f1f8"
      },
      {
        "icon": "🇪🇸",
        "code": "1f1ea-1f1f8"
      },
      {
        "icon": "🇱🇰",
        "code": "1f1f1-1f1f0"
      },
      {
        "icon": "🇧🇱",
        "code": "1f1e7-1f1f1"
      },
      {
        "icon": "🇸🇭",
        "code": "1f1f8-1f1ed"
      },
      {
        "icon": "🇰🇳",
        "code": "1f1f0-1f1f3"
      },
      {
        "icon": "🇱🇨",
        "code": "1f1f1-1f1e8"
      },
      {
        "icon": "🇵🇲",
        "code": "1f1f5-1f1f2"
      },
      {
        "icon": "🇻🇨",
        "code": "1f1fb-1f1e8"
      },
      {
        "icon": "🇸🇩",
        "code": "1f1f8-1f1e9"
      },
      {
        "icon": "🇸🇷",
        "code": "1f1f8-1f1f7"
      },
      {
        "icon": "🇸🇪",
        "code": "1f1f8-1f1ea"
      },
      {
        "icon": "🇨🇭",
        "code": "1f1e8-1f1ed"
      },
      {
        "icon": "🇸🇾",
        "code": "1f1f8-1f1fe"
      },
      {
        "icon": "🇹🇼",
        "code": "1f1f9-1f1fc"
      },
      {
        "icon": "🇹🇯",
        "code": "1f1f9-1f1ef"
      },
      {
        "icon": "🇹🇿",
        "code": "1f1f9-1f1ff"
      },
      {
        "icon": "🇹🇭",
        "code": "1f1f9-1f1ed"
      },
      {
        "icon": "🇹🇱",
        "code": "1f1f9-1f1f1"
      },
      {
        "icon": "🇹🇬",
        "code": "1f1f9-1f1ec"
      },
      {
        "icon": "🇹🇰",
        "code": "1f1f9-1f1f0"
      },
      {
        "icon": "🇹🇴",
        "code": "1f1f9-1f1f4"
      },
      {
        "icon": "🇹🇹",
        "code": "1f1f9-1f1f9"
      },
      {
        "icon": "🇹🇳",
        "code": "1f1f9-1f1f3"
      },
      {
        "icon": "🇹🇷",
        "code": "1f1f9-1f1f7"
      },
      {
        "icon": "🇹🇲",
        "code": "1f1f9-1f1f2"
      },
      {
        "icon": "🇹🇨",
        "code": "1f1f9-1f1e8"
      },
      {
        "icon": "🇹🇻",
        "code": "1f1f9-1f1fb"
      },
      {
        "icon": "🇻🇮",
        "code": "1f1fb-1f1ee"
      },
      {
        "icon": "🇺🇬",
        "code": "1f1fa-1f1ec"
      },
      {
        "icon": "🇺🇦",
        "code": "1f1fa-1f1e6"
      },
      {
        "icon": "🇦🇪",
        "code": "1f1e6-1f1ea"
      },
      {
        "icon": "🇬🇧",
        "code": "1f1ec-1f1e7"
      },
      {
        "icon": "🏴󠁧󠁢󠁥󠁮󠁧󠁿",
        "code": "1f3f4-e0067-e0062-e0065-e006e-e0067-e007f"
      },
      {
        "icon": "🏴󠁧󠁢󠁳󠁣󠁴󠁿",
        "code": "1f3f4-e0067-e0062-e0073-e0063-e0074-e007f"
      },
      {
        "icon": "🏴󠁧󠁢󠁷󠁬󠁳󠁿",
        "code": "1f3f4-e0067-e0062-e0077-e006c-e0073-e007f"
      },
      {
        "icon": "🇺🇸",
        "code": "1f1fa-1f1f8"
      },
      {
        "icon": "🇺🇾",
        "code": "1f1fa-1f1fe"
      },
      {
        "icon": "🇺🇿",
        "code": "1f1fa-1f1ff"
      },
      {
        "icon": "🇻🇺",
        "code": "1f1fb-1f1fa"
      },
      {
        "icon": "🇻🇦",
        "code": "1f1fb-1f1e6"
      },
      {
        "icon": "🇻🇪",
        "code": "1f1fb-1f1ea"
      },
      {
        "icon": "🇻🇳",
        "code": "1f1fb-1f1f3"
      },
      {
        "icon": "🇼🇫",
        "code": "1f1fc-1f1eb"
      },
      {
        "icon": "🇪🇭",
        "code": "1f1ea-1f1ed"
      },
      {
        "icon": "🇾🇪",
        "code": "1f1fe-1f1ea"
      },
      {
        "icon": "🇿🇲",
        "code": "1f1ff-1f1f2"
      },
      {
        "icon": "🇿🇼",
        "code": "1f1ff-1f1fc"
      }
    ]
  }
]

const whatsAppEmojiMap = {
  "😀": {
    "code": "1f600"
  },
  "😃": {
    "code": "1f603"
  },
  "😄": {
    "code": "1f604"
  },
  "😁": {
    "code": "1f601"
  },
  "😆": {
    "code": "1f606"
  },
  "🥹": {
    "code": "1f979"
  },
  "😅": {
    "code": "1f605"
  },
  "😂": {
    "code": "1f602"
  },
  "🤣": {
    "code": "1f923"
  },
  "🥲": {
    "code": "1f972"
  },
  "☺️": {
    "code": "263a"
  },
  "😊": {
    "code": "1f60a"
  },
  "😇": {
    "code": "1f607"
  },
  "🙂": {
    "code": "1f642"
  },
  "🙃": {
    "code": "1f643"
  },
  "😉": {
    "code": "1f609"
  },
  "😌": {
    "code": "1f60c"
  },
  "😍": {
    "code": "1f60d"
  },
  "🥰": {
    "code": "1f970"
  },
  "😘": {
    "code": "1f618"
  },
  "😗": {
    "code": "1f617"
  },
  "😙": {
    "code": "1f619"
  },
  "😚": {
    "code": "1f61a"
  },
  "😋": {
    "code": "1f60b"
  },
  "😛": {
    "code": "1f61b"
  },
  "😝": {
    "code": "1f61d"
  },
  "😜": {
    "code": "1f61c"
  },
  "🤪": {
    "code": "1f92a"
  },
  "🤨": {
    "code": "1f928"
  },
  "🧐": {
    "code": "1f9d0"
  },
  "🤓": {
    "code": "1f913"
  },
  "😎": {
    "code": "1f60e"
  },
  "🥸": {
    "code": "1f978"
  },
  "🤩": {
    "code": "1f929"
  },
  "🥳": {
    "code": "1f973"
  },
  "🙂‍↕️": {
    "code": "1f642-200d-2195"
  },
  "😏": {
    "code": "1f60f"
  },
  "😒": {
    "code": "1f612"
  },
  "🙂‍↔️": {
    "code": "1f642-200d-2194"
  },
  "😞": {
    "code": "1f61e"
  },
  "😔": {
    "code": "1f614"
  },
  "😟": {
    "code": "1f61f"
  },
  "😕": {
    "code": "1f615"
  },
  "🙁": {
    "code": "1f641"
  },
  "☹️": {
    "code": "2639"
  },
  "😣": {
    "code": "1f623"
  },
  "😖": {
    "code": "1f616"
  },
  "😫": {
    "code": "1f62b"
  },
  "😩": {
    "code": "1f629"
  },
  "🥺": {
    "code": "1f97a"
  },
  "😢": {
    "code": "1f622"
  },
  "😭": {
    "code": "1f62d"
  },
  "😤": {
    "code": "1f624"
  },
  "😠": {
    "code": "1f620"
  },
  "😡": {
    "code": "1f621"
  },
  "🤬": {
    "code": "1f92c"
  },
  "🤯": {
    "code": "1f92f"
  },
  "😳": {
    "code": "1f633"
  },
  "🥵": {
    "code": "1f975"
  },
  "🥶": {
    "code": "1f976"
  },
  "😶‍🌫️": {
    "code": "1f636-200d-1f32b"
  },
  "😱": {
    "code": "1f631"
  },
  "😨": {
    "code": "1f628"
  },
  "😰": {
    "code": "1f630"
  },
  "😥": {
    "code": "1f625"
  },
  "😓": {
    "code": "1f613"
  },
  "🤗": {
    "code": "1f917"
  },
  "🤔": {
    "code": "1f914"
  },
  "🫣": {
    "code": "1fae3"
  },
  "🤭": {
    "code": "1f92d"
  },
  "🫢": {
    "code": "1fae2"
  },
  "🫡": {
    "code": "1fae1"
  },
  "🤫": {
    "code": "1f92b"
  },
  "🫠": {
    "code": "1fae0"
  },
  "🤥": {
    "code": "1f925"
  },
  "😶": {
    "code": "1f636"
  },
  "🫥": {
    "code": "1fae5"
  },
  "😐": {
    "code": "1f610"
  },
  "🫤": {
    "code": "1fae4"
  },
  "😑": {
    "code": "1f611"
  },
  "🫨": {
    "code": "1fae8"
  },
  "😬": {
    "code": "1f62c"
  },
  "🙄": {
    "code": "1f644"
  },
  "😯": {
    "code": "1f62f"
  },
  "😦": {
    "code": "1f626"
  },
  "😧": {
    "code": "1f627"
  },
  "😮": {
    "code": "1f62e"
  },
  "😲": {
    "code": "1f632"
  },
  "🥱": {
    "code": "1f971"
  },
  "🫩": {
    "code": "1fae9"
  },
  "😴": {
    "code": "1f634"
  },
  "🤤": {
    "code": "1f924"
  },
  "😪": {
    "code": "1f62a"
  },
  "😮‍💨": {
    "code": "1f62e-200d-1f4a8"
  },
  "😵": {
    "code": "1f635"
  },
  "😵‍💫": {
    "code": "1f635-200d-1f4ab"
  },
  "🤐": {
    "code": "1f910"
  },
  "🥴": {
    "code": "1f974"
  },
  "🤢": {
    "code": "1f922"
  },
  "🤮": {
    "code": "1f92e"
  },
  "🤧": {
    "code": "1f927"
  },
  "😷": {
    "code": "1f637"
  },
  "🤒": {
    "code": "1f912"
  },
  "🤕": {
    "code": "1f915"
  },
  "🤑": {
    "code": "1f911"
  },
  "🤠": {
    "code": "1f920"
  },
  "😈": {
    "code": "1f608"
  },
  "👿": {
    "code": "1f47f"
  },
  "👹": {
    "code": "1f479"
  },
  "👺": {
    "code": "1f47a"
  },
  "🤡": {
    "code": "1f921"
  },
  "💩": {
    "code": "1f4a9"
  },
  "👻": {
    "code": "1f47b"
  },
  "💀": {
    "code": "1f480"
  },
  "☠️": {
    "code": "2620"
  },
  "👽": {
    "code": "1f47d"
  },
  "👾": {
    "code": "1f47e"
  },
  "🤖": {
    "code": "1f916"
  },
  "🎃": {
    "code": "1f383"
  },
  "😺": {
    "code": "1f63a"
  },
  "😸": {
    "code": "1f638"
  },
  "😹": {
    "code": "1f639"
  },
  "😻": {
    "code": "1f63b"
  },
  "😼": {
    "code": "1f63c"
  },
  "😽": {
    "code": "1f63d"
  },
  "🙀": {
    "code": "1f640"
  },
  "😿": {
    "code": "1f63f"
  },
  "😾": {
    "code": "1f63e"
  },
  "🫶": {
    "code": "1faf6"
  },
  "🤲": {
    "code": "1f932"
  },
  "👐": {
    "code": "1f450"
  },
  "🙌": {
    "code": "1f64c"
  },
  "👏": {
    "code": "1f44f"
  },
  "🤝": {
    "code": "1f91d"
  },
  "👍": {
    "code": "1f44d"
  },
  "👎": {
    "code": "1f44e"
  },
  "👊": {
    "code": "1f44a"
  },
  "✊": {
    "code": "270a"
  },
  "🤛": {
    "code": "1f91b"
  },
  "🤜": {
    "code": "1f91c"
  },
  "🫷": {
    "code": "1faf7"
  },
  "🫸": {
    "code": "1faf8"
  },
  "🤞": {
    "code": "1f91e"
  },
  "✌️": {
    "code": "270c"
  },
  "🫰": {
    "code": "1faf0"
  },
  "🤟": {
    "code": "1f91f"
  },
  "🤘": {
    "code": "1f918"
  },
  "👌": {
    "code": "1f44c"
  },
  "🤌": {
    "code": "1f90c"
  },
  "🤏": {
    "code": "1f90f"
  },
  "🫳": {
    "code": "1faf3"
  },
  "🫴": {
    "code": "1faf4"
  },
  "👈": {
    "code": "1f448"
  },
  "👉": {
    "code": "1f449"
  },
  "👆": {
    "code": "1f446"
  },
  "👇": {
    "code": "1f447"
  },
  "☝️": {
    "code": "261d"
  },
  "✋": {
    "code": "270b"
  },
  "🤚": {
    "code": "1f91a"
  },
  "🖐️": {
    "code": "1f590"
  },
  "🖖": {
    "code": "1f596"
  },
  "👋": {
    "code": "1f44b"
  },
  "🤙": {
    "code": "1f919"
  },
  "🫲": {
    "code": "1faf2"
  },
  "🫱": {
    "code": "1faf1"
  },
  "💪": {
    "code": "1f4aa"
  },
  "🦾": {
    "code": "1f9be"
  },
  "🖕": {
    "code": "1f595"
  },
  "✍️": {
    "code": "270d"
  },
  "🙏": {
    "code": "1f64f"
  },
  "🫵": {
    "code": "1faf5"
  },
  "🦶": {
    "code": "1f9b6"
  },
  "🦵": {
    "code": "1f9b5"
  },
  "🦿": {
    "code": "1f9bf"
  },
  "💄": {
    "code": "1f484"
  },
  "💋": {
    "code": "1f48b"
  },
  "👄": {
    "code": "1f444"
  },
  "🫦": {
    "code": "1fae6"
  },
  "🦷": {
    "code": "1f9b7"
  },
  "👅": {
    "code": "1f445"
  },
  "👂": {
    "code": "1f442"
  },
  "🦻": {
    "code": "1f9bb"
  },
  "👃": {
    "code": "1f443"
  },
  "🫆": {
    "code": "1fac6"
  },
  "👣": {
    "code": "1f463"
  },
  "👁️": {
    "code": "1f441"
  },
  "👀": {
    "code": "1f440"
  },
  "🫀": {
    "code": "1fac0"
  },
  "🫁": {
    "code": "1fac1"
  },
  "🧠": {
    "code": "1f9e0"
  },
  "🗣️": {
    "code": "1f5e3"
  },
  "👤": {
    "code": "1f464"
  },
  "👥": {
    "code": "1f465"
  },
  "🫂": {
    "code": "1fac2"
  },
  "👶": {
    "code": "1f476"
  },
  "👧": {
    "code": "1f467"
  },
  "🧒": {
    "code": "1f9d2"
  },
  "👦": {
    "code": "1f466"
  },
  "👩": {
    "code": "1f469"
  },
  "🧑": {
    "code": "1f9d1"
  },
  "👨": {
    "code": "1f468"
  },
  "👩‍🦱": {
    "code": "1f469-200d-1f9b1"
  },
  "🧑‍🦱": {
    "code": "1f9d1-200d-1f9b1"
  },
  "👨‍🦱": {
    "code": "1f468-200d-1f9b1"
  },
  "👩‍🦰": {
    "code": "1f469-200d-1f9b0"
  },
  "🧑‍🦰": {
    "code": "1f9d1-200d-1f9b0"
  },
  "👨‍🦰": {
    "code": "1f468-200d-1f9b0"
  },
  "👱‍♀️": {
    "code": "1f471-200d-2640"
  },
  "👱": {
    "code": "1f471"
  },
  "👱‍♂️": {
    "code": "1f471-200d-2642"
  },
  "👩‍🦳": {
    "code": "1f469-200d-1f9b3"
  },
  "🧑‍🦳": {
    "code": "1f9d1-200d-1f9b3"
  },
  "👨‍🦳": {
    "code": "1f468-200d-1f9b3"
  },
  "👩‍🦲": {
    "code": "1f469-200d-1f9b2"
  },
  "🧑‍🦲": {
    "code": "1f9d1-200d-1f9b2"
  },
  "👨‍🦲": {
    "code": "1f468-200d-1f9b2"
  },
  "🧔‍♀️": {
    "code": "1f9d4-200d-2640"
  },
  "🧔": {
    "code": "1f9d4"
  },
  "🧔‍♂️": {
    "code": "1f9d4-200d-2642"
  },
  "👵": {
    "code": "1f475"
  },
  "🧓": {
    "code": "1f9d3"
  },
  "👴": {
    "code": "1f474"
  },
  "👲": {
    "code": "1f472"
  },
  "👳‍♀️": {
    "code": "1f473-200d-2640"
  },
  "👳": {
    "code": "1f473"
  },
  "👳‍♂️": {
    "code": "1f473-200d-2642"
  },
  "🧕": {
    "code": "1f9d5"
  },
  "👮‍♀️": {
    "code": "1f46e-200d-2640"
  },
  "👮": {
    "code": "1f46e"
  },
  "👮‍♂️": {
    "code": "1f46e-200d-2642"
  },
  "👷‍♀️": {
    "code": "1f477-200d-2640"
  },
  "👷": {
    "code": "1f477"
  },
  "👷‍♂️": {
    "code": "1f477-200d-2642"
  },
  "💂‍♀️": {
    "code": "1f482-200d-2640"
  },
  "💂": {
    "code": "1f482"
  },
  "💂‍♂️": {
    "code": "1f482-200d-2642"
  },
  "🕵️‍♀️": {
    "code": "1f575-200d-2640"
  },
  "🕵️": {
    "code": "1f575"
  },
  "🕵️‍♂️": {
    "code": "1f575-200d-2642"
  },
  "👩‍⚕️": {
    "code": "1f469-200d-2695"
  },
  "🧑‍⚕️": {
    "code": "1f9d1-200d-2695"
  },
  "👨‍⚕️": {
    "code": "1f468-200d-2695"
  },
  "👩‍🌾": {
    "code": "1f469-200d-1f33e"
  },
  "🧑‍🌾": {
    "code": "1f9d1-200d-1f33e"
  },
  "👨‍🌾": {
    "code": "1f468-200d-1f33e"
  },
  "👩‍🍳": {
    "code": "1f469-200d-1f373"
  },
  "🧑‍🍳": {
    "code": "1f9d1-200d-1f373"
  },
  "👨‍🍳": {
    "code": "1f468-200d-1f373"
  },
  "👩‍🎓": {
    "code": "1f469-200d-1f393"
  },
  "🧑‍🎓": {
    "code": "1f9d1-200d-1f393"
  },
  "👨‍🎓": {
    "code": "1f468-200d-1f393"
  },
  "👩‍🎤": {
    "code": "1f469-200d-1f3a4"
  },
  "🧑‍🎤": {
    "code": "1f9d1-200d-1f3a4"
  },
  "👨‍🎤": {
    "code": "1f468-200d-1f3a4"
  },
  "👩‍🏫": {
    "code": "1f469-200d-1f3eb"
  },
  "🧑‍🏫": {
    "code": "1f9d1-200d-1f3eb"
  },
  "👨‍🏫": {
    "code": "1f468-200d-1f3eb"
  },
  "👩‍🏭": {
    "code": "1f469-200d-1f3ed"
  },
  "🧑‍🏭": {
    "code": "1f9d1-200d-1f3ed"
  },
  "👨‍🏭": {
    "code": "1f468-200d-1f3ed"
  },
  "👩‍💻": {
    "code": "1f469-200d-1f4bb"
  },
  "🧑‍💻": {
    "code": "1f9d1-200d-1f4bb"
  },
  "👨‍💻": {
    "code": "1f468-200d-1f4bb"
  },
  "👩‍💼": {
    "code": "1f469-200d-1f4bc"
  },
  "🧑‍💼": {
    "code": "1f9d1-200d-1f4bc"
  },
  "👨‍💼": {
    "code": "1f468-200d-1f4bc"
  },
  "👩‍🔧": {
    "code": "1f469-200d-1f527"
  },
  "🧑‍🔧": {
    "code": "1f9d1-200d-1f527"
  },
  "👨‍🔧": {
    "code": "1f468-200d-1f527"
  },
  "👩‍🔬": {
    "code": "1f469-200d-1f52c"
  },
  "🧑‍🔬": {
    "code": "1f9d1-200d-1f52c"
  },
  "👨‍🔬": {
    "code": "1f468-200d-1f52c"
  },
  "👩‍🎨": {
    "code": "1f469-200d-1f3a8"
  },
  "🧑‍🎨": {
    "code": "1f9d1-200d-1f3a8"
  },
  "👨‍🎨": {
    "code": "1f468-200d-1f3a8"
  },
  "👩‍🚒": {
    "code": "1f469-200d-1f692"
  },
  "🧑‍🚒": {
    "code": "1f9d1-200d-1f692"
  },
  "👨‍🚒": {
    "code": "1f468-200d-1f692"
  },
  "👩‍✈️": {
    "code": "1f469-200d-2708"
  },
  "🧑‍✈️": {
    "code": "1f9d1-200d-2708"
  },
  "👨‍✈️": {
    "code": "1f468-200d-2708"
  },
  "👩‍🚀": {
    "code": "1f469-200d-1f680"
  },
  "🧑‍🚀": {
    "code": "1f9d1-200d-1f680"
  },
  "👨‍🚀": {
    "code": "1f468-200d-1f680"
  },
  "👩‍⚖️": {
    "code": "1f469-200d-2696"
  },
  "🧑‍⚖️": {
    "code": "1f9d1-200d-2696"
  },
  "👨‍⚖️": {
    "code": "1f468-200d-2696"
  },
  "👰‍♀️": {
    "code": "1f470-200d-2640"
  },
  "👰": {
    "code": "1f470"
  },
  "👰‍♂️": {
    "code": "1f470-200d-2642"
  },
  "🤵‍♀️": {
    "code": "1f935-200d-2640"
  },
  "🤵": {
    "code": "1f935"
  },
  "🤵‍♂️": {
    "code": "1f935-200d-2642"
  },
  "👸": {
    "code": "1f478"
  },
  "🫅": {
    "code": "1fac5"
  },
  "🤴": {
    "code": "1f934"
  },
  "🥷": {
    "code": "1f977"
  },
  "🦸‍♀️": {
    "code": "1f9b8-200d-2640"
  },
  "🦸": {
    "code": "1f9b8"
  },
  "🦸‍♂️": {
    "code": "1f9b8-200d-2642"
  },
  "🦹‍♀️": {
    "code": "1f9b9-200d-2640"
  },
  "🦹": {
    "code": "1f9b9"
  },
  "🦹‍♂️": {
    "code": "1f9b9-200d-2642"
  },
  "🤶": {
    "code": "1f936"
  },
  "🧑‍🎄": {
    "code": "1f9d1-200d-1f384"
  },
  "🎅": {
    "code": "1f385"
  },
  "🧙‍♀️": {
    "code": "1f9d9-200d-2640"
  },
  "🧙": {
    "code": "1f9d9"
  },
  "🧙‍♂️": {
    "code": "1f9d9-200d-2642"
  },
  "🧝‍♀️": {
    "code": "1f9dd-200d-2640"
  },
  "🧝": {
    "code": "1f9dd"
  },
  "🧝‍♂️": {
    "code": "1f9dd-200d-2642"
  },
  "🧌": {
    "code": "1f9cc"
  },
  "🧛‍♀️": {
    "code": "1f9db-200d-2640"
  },
  "🧛": {
    "code": "1f9db"
  },
  "🧛‍♂️": {
    "code": "1f9db-200d-2642"
  },
  "🧟‍♀️": {
    "code": "1f9df-200d-2640"
  },
  "🧟": {
    "code": "1f9df"
  },
  "🧟‍♂️": {
    "code": "1f9df-200d-2642"
  },
  "🧞‍♀️": {
    "code": "1f9de-200d-2640"
  },
  "🧞": {
    "code": "1f9de"
  },
  "🧞‍♂️": {
    "code": "1f9de-200d-2642"
  },
  "🧜‍♀️": {
    "code": "1f9dc-200d-2640"
  },
  "🧜": {
    "code": "1f9dc"
  },
  "🧜‍♂️": {
    "code": "1f9dc-200d-2642"
  },
  "🧚‍♀️": {
    "code": "1f9da-200d-2640"
  },
  "🧚": {
    "code": "1f9da"
  },
  "🧚‍♂️": {
    "code": "1f9da-200d-2642"
  },
  "👼": {
    "code": "1f47c"
  },
  "🤰": {
    "code": "1f930"
  },
  "🫄": {
    "code": "1fac4"
  },
  "🫃": {
    "code": "1fac3"
  },
  "🤱": {
    "code": "1f931"
  },
  "👩‍🍼": {
    "code": "1f469-200d-1f37c"
  },
  "🧑‍🍼": {
    "code": "1f9d1-200d-1f37c"
  },
  "👨‍🍼": {
    "code": "1f468-200d-1f37c"
  },
  "🙇‍♀️": {
    "code": "1f647-200d-2640"
  },
  "🙇": {
    "code": "1f647"
  },
  "🙇‍♂️": {
    "code": "1f647-200d-2642"
  },
  "💁‍♀️": {
    "code": "1f481-200d-2640"
  },
  "💁": {
    "code": "1f481"
  },
  "💁‍♂️": {
    "code": "1f481-200d-2642"
  },
  "🙅‍♀️": {
    "code": "1f645-200d-2640"
  },
  "🙅": {
    "code": "1f645"
  },
  "🙅‍♂️": {
    "code": "1f645-200d-2642"
  },
  "🙆‍♀️": {
    "code": "1f646-200d-2640"
  },
  "🙆": {
    "code": "1f646"
  },
  "🙆‍♂️": {
    "code": "1f646-200d-2642"
  },
  "🙋‍♀️": {
    "code": "1f64b-200d-2640"
  },
  "🙋": {
    "code": "1f64b"
  },
  "🙋‍♂️": {
    "code": "1f64b-200d-2642"
  },
  "🧏‍♀️": {
    "code": "1f9cf-200d-2640"
  },
  "🧏": {
    "code": "1f9cf"
  },
  "🧏‍♂️": {
    "code": "1f9cf-200d-2642"
  },
  "🤦‍♀️": {
    "code": "1f926-200d-2640"
  },
  "🤦": {
    "code": "1f926"
  },
  "🤦‍♂️": {
    "code": "1f926-200d-2642"
  },
  "🤷‍♀️": {
    "code": "1f937-200d-2640"
  },
  "🤷": {
    "code": "1f937"
  },
  "🤷‍♂️": {
    "code": "1f937-200d-2642"
  },
  "🙎‍♀️": {
    "code": "1f64e-200d-2640"
  },
  "🙎": {
    "code": "1f64e"
  },
  "🙎‍♂️": {
    "code": "1f64e-200d-2642"
  },
  "🙍‍♀️": {
    "code": "1f64d-200d-2640"
  },
  "🙍": {
    "code": "1f64d"
  },
  "🙍‍♂️": {
    "code": "1f64d-200d-2642"
  },
  "💇‍♀️": {
    "code": "1f487-200d-2640"
  },
  "💇": {
    "code": "1f487"
  },
  "💇‍♂️": {
    "code": "1f487-200d-2642"
  },
  "💆‍♀️": {
    "code": "1f486-200d-2640"
  },
  "💆": {
    "code": "1f486"
  },
  "💆‍♂️": {
    "code": "1f486-200d-2642"
  },
  "🧖‍♀️": {
    "code": "1f9d6-200d-2640"
  },
  "🧖": {
    "code": "1f9d6"
  },
  "🧖‍♂️": {
    "code": "1f9d6-200d-2642"
  },
  "💅": {
    "code": "1f485"
  },
  "🤳": {
    "code": "1f933"
  },
  "💃": {
    "code": "1f483"
  },
  "🕺": {
    "code": "1f57a"
  },
  "👯‍♀️": {
    "code": "1f46f-200d-2640"
  },
  "👯": {
    "code": "1f46f"
  },
  "👯‍♂️": {
    "code": "1f46f-200d-2642"
  },
  "🕴️": {
    "code": "1f574"
  },
  "👩‍🦽": {
    "code": "1f469-200d-1f9bd"
  },
  "🧑‍🦽": {
    "code": "1f9d1-200d-1f9bd"
  },
  "👨‍🦽": {
    "code": "1f468-200d-1f9bd"
  },
  "👩‍🦽‍➡️": {
    "code": "1f469-200d-1f9bd-200d-27a1"
  },
  "🧑‍🦽‍➡️": {
    "code": "1f9d1-200d-1f9bd-200d-27a1"
  },
  "👨‍🦽‍➡️": {
    "code": "1f468-200d-1f9bd-200d-27a1"
  },
  "👩‍🦼": {
    "code": "1f469-200d-1f9bc"
  },
  "🧑‍🦼": {
    "code": "1f9d1-200d-1f9bc"
  },
  "👨‍🦼": {
    "code": "1f468-200d-1f9bc"
  },
  "👩‍🦼‍➡️": {
    "code": "1f469-200d-1f9bc-200d-27a1"
  },
  "🧑‍🦼‍➡️": {
    "code": "1f9d1-200d-1f9bc-200d-27a1"
  },
  "👨‍🦼‍➡️": {
    "code": "1f468-200d-1f9bc-200d-27a1"
  },
  "🚶‍♀️": {
    "code": "1f6b6-200d-2640"
  },
  "🚶": {
    "code": "1f6b6"
  },
  "🚶‍♂️": {
    "code": "1f6b6-200d-2642"
  },
  "🚶‍♀️‍➡️": {
    "code": "1f6b6-200d-2640-200d-27a1"
  },
  "🚶‍➡️": {
    "code": "1f6b6-200d-27a1"
  },
  "🚶‍♂️‍➡️": {
    "code": "1f6b6-200d-2642-200d-27a1"
  },
  "👩‍🦯": {
    "code": "1f469-200d-1f9af"
  },
  "🧑‍🦯": {
    "code": "1f9d1-200d-1f9af"
  },
  "👨‍🦯": {
    "code": "1f468-200d-1f9af"
  },
  "👩‍🦯‍➡️": {
    "code": "1f469-200d-1f9af-200d-27a1"
  },
  "🧑‍🦯‍➡️": {
    "code": "1f9d1-200d-1f9af-200d-27a1"
  },
  "👨‍🦯‍➡️": {
    "code": "1f468-200d-1f9af-200d-27a1"
  },
  "🧎‍♀️": {
    "code": "1f9ce-200d-2640"
  },
  "🧎": {
    "code": "1f9ce"
  },
  "🧎‍♂️": {
    "code": "1f9ce-200d-2642"
  },
  "🏃‍♀️": {
    "code": "1f3c3-200d-2640"
  },
  "🏃": {
    "code": "1f3c3"
  },
  "🏃‍♂️": {
    "code": "1f3c3-200d-2642"
  },
  "🏃‍♀️‍➡️": {
    "code": "1f3c3-200d-2640-200d-27a1"
  },
  "🏃‍➡️": {
    "code": "1f3c3-200d-27a1"
  },
  "🏃‍♂️‍➡️": {
    "code": "1f3c3-200d-2642-200d-27a1"
  },
  "🧎‍♀️‍➡️": {
    "code": "1f9ce-200d-2640-200d-27a1"
  },
  "🧎‍➡️": {
    "code": "1f9ce-200d-27a1"
  },
  "🧎‍♂️‍➡️": {
    "code": "1f9ce-200d-2642-200d-27a1"
  },
  "🧍‍♀️": {
    "code": "1f9cd-200d-2640"
  },
  "🧍": {
    "code": "1f9cd"
  },
  "🧍‍♂️": {
    "code": "1f9cd-200d-2642"
  },
  "👫": {
    "code": "1f46b"
  },
  "👭": {
    "code": "1f46d"
  },
  "👬": {
    "code": "1f46c"
  },
  "👩‍❤️‍👨": {
    "code": "1f469-200d-2764-200d-1f468"
  },
  "👩‍❤️‍👩": {
    "code": "1f469-200d-2764-200d-1f469"
  },
  "💑": {
    "code": "1f491"
  },
  "👨‍❤️‍👨": {
    "code": "1f468-200d-2764-200d-1f468"
  },
  "👩‍❤️‍💋‍👨": {
    "code": "1f469-200d-2764-200d-1f48b-200d-1f468"
  },
  "👩‍❤️‍💋‍👩": {
    "code": "1f469-200d-2764-200d-1f48b-200d-1f469"
  },
  "💏": {
    "code": "1f48f"
  },
  "👨‍❤️‍💋‍👨": {
    "code": "1f468-200d-2764-200d-1f48b-200d-1f468"
  },
  "🪢": {
    "code": "1faa2"
  },
  "🧶": {
    "code": "1f9f6"
  },
  "🧵": {
    "code": "1f9f5"
  },
  "🪡": {
    "code": "1faa1"
  },
  "🧥": {
    "code": "1f9e5"
  },
  "🥼": {
    "code": "1f97c"
  },
  "🦺": {
    "code": "1f9ba"
  },
  "👚": {
    "code": "1f45a"
  },
  "👕": {
    "code": "1f455"
  },
  "👖": {
    "code": "1f456"
  },
  "🩲": {
    "code": "1fa72"
  },
  "🩳": {
    "code": "1fa73"
  },
  "👔": {
    "code": "1f454"
  },
  "👗": {
    "code": "1f457"
  },
  "👙": {
    "code": "1f459"
  },
  "🩱": {
    "code": "1fa71"
  },
  "👘": {
    "code": "1f458"
  },
  "🥻": {
    "code": "1f97b"
  },
  "🩴": {
    "code": "1fa74"
  },
  "🥿": {
    "code": "1f97f"
  },
  "👠": {
    "code": "1f460"
  },
  "👡": {
    "code": "1f461"
  },
  "👢": {
    "code": "1f462"
  },
  "👞": {
    "code": "1f45e"
  },
  "👟": {
    "code": "1f45f"
  },
  "🥾": {
    "code": "1f97e"
  },
  "🧦": {
    "code": "1f9e6"
  },
  "🧤": {
    "code": "1f9e4"
  },
  "🧣": {
    "code": "1f9e3"
  },
  "🎩": {
    "code": "1f3a9"
  },
  "🧢": {
    "code": "1f9e2"
  },
  "👒": {
    "code": "1f452"
  },
  "🎓": {
    "code": "1f393"
  },
  "⛑️": {
    "code": "26d1"
  },
  "🪖": {
    "code": "1fa96"
  },
  "👑": {
    "code": "1f451"
  },
  "💍": {
    "code": "1f48d"
  },
  "👝": {
    "code": "1f45d"
  },
  "👛": {
    "code": "1f45b"
  },
  "👜": {
    "code": "1f45c"
  },
  "💼": {
    "code": "1f4bc"
  },
  "🎒": {
    "code": "1f392"
  },
  "🧳": {
    "code": "1f9f3"
  },
  "👓": {
    "code": "1f453"
  },
  "🕶️": {
    "code": "1f576"
  },
  "🥽": {
    "code": "1f97d"
  },
  "🌂": {
    "code": "1f302"
  },
  "🐶": {
    "code": "1f436"
  },
  "🐱": {
    "code": "1f431"
  },
  "🐭": {
    "code": "1f42d"
  },
  "🐹": {
    "code": "1f439"
  },
  "🐰": {
    "code": "1f430"
  },
  "🦊": {
    "code": "1f98a"
  },
  "🐻": {
    "code": "1f43b"
  },
  "🐼": {
    "code": "1f43c"
  },
  "🐻‍❄️": {
    "code": "1f43b-200d-2744"
  },
  "🐨": {
    "code": "1f428"
  },
  "🐯": {
    "code": "1f42f"
  },
  "🦁": {
    "code": "1f981"
  },
  "🐮": {
    "code": "1f42e"
  },
  "🐷": {
    "code": "1f437"
  },
  "🐽": {
    "code": "1f43d"
  },
  "🐸": {
    "code": "1f438"
  },
  "🐵": {
    "code": "1f435"
  },
  "🙈": {
    "code": "1f648"
  },
  "🙉": {
    "code": "1f649"
  },
  "🙊": {
    "code": "1f64a"
  },
  "🐒": {
    "code": "1f412"
  },
  "🐔": {
    "code": "1f414"
  },
  "🐧": {
    "code": "1f427"
  },
  "🐦": {
    "code": "1f426"
  },
  "🐤": {
    "code": "1f424"
  },
  "🐣": {
    "code": "1f423"
  },
  "🐥": {
    "code": "1f425"
  },
  "🪿": {
    "code": "1fabf"
  },
  "🦆": {
    "code": "1f986"
  },
  "🐦‍⬛": {
    "code": "1f426-200d-2b1b"
  },
  "🦅": {
    "code": "1f985"
  },
  "🦉": {
    "code": "1f989"
  },
  "🦇": {
    "code": "1f987"
  },
  "🐺": {
    "code": "1f43a"
  },
  "🐗": {
    "code": "1f417"
  },
  "🐴": {
    "code": "1f434"
  },
  "🦄": {
    "code": "1f984"
  },
  "🫎": {
    "code": "1face"
  },
  "🐝": {
    "code": "1f41d"
  },
  "🪱": {
    "code": "1fab1"
  },
  "🐛": {
    "code": "1f41b"
  },
  "🦋": {
    "code": "1f98b"
  },
  "🐌": {
    "code": "1f40c"
  },
  "🐞": {
    "code": "1f41e"
  },
  "🐜": {
    "code": "1f41c"
  },
  "🪰": {
    "code": "1fab0"
  },
  "🪲": {
    "code": "1fab2"
  },
  "🪳": {
    "code": "1fab3"
  },
  "🦟": {
    "code": "1f99f"
  },
  "🦗": {
    "code": "1f997"
  },
  "🕷️": {
    "code": "1f577"
  },
  "🕸️": {
    "code": "1f578"
  },
  "🦂": {
    "code": "1f982"
  },
  "🐢": {
    "code": "1f422"
  },
  "🐍": {
    "code": "1f40d"
  },
  "🦎": {
    "code": "1f98e"
  },
  "🦖": {
    "code": "1f996"
  },
  "🦕": {
    "code": "1f995"
  },
  "🐙": {
    "code": "1f419"
  },
  "🦑": {
    "code": "1f991"
  },
  "🪼": {
    "code": "1fabc"
  },
  "🦐": {
    "code": "1f990"
  },
  "🦞": {
    "code": "1f99e"
  },
  "🦀": {
    "code": "1f980"
  },
  "🐡": {
    "code": "1f421"
  },
  "🐠": {
    "code": "1f420"
  },
  "🐟": {
    "code": "1f41f"
  },
  "🐬": {
    "code": "1f42c"
  },
  "🐳": {
    "code": "1f433"
  },
  "🐋": {
    "code": "1f40b"
  },
  "🦈": {
    "code": "1f988"
  },
  "🦭": {
    "code": "1f9ad"
  },
  "🐊": {
    "code": "1f40a"
  },
  "🐅": {
    "code": "1f405"
  },
  "🐆": {
    "code": "1f406"
  },
  "🦓": {
    "code": "1f993"
  },
  "🦍": {
    "code": "1f98d"
  },
  "🦧": {
    "code": "1f9a7"
  },
  "🦣": {
    "code": "1f9a3"
  },
  "🐘": {
    "code": "1f418"
  },
  "🦛": {
    "code": "1f99b"
  },
  "🦏": {
    "code": "1f98f"
  },
  "🐪": {
    "code": "1f42a"
  },
  "🐫": {
    "code": "1f42b"
  },
  "🦒": {
    "code": "1f992"
  },
  "🦘": {
    "code": "1f998"
  },
  "🦬": {
    "code": "1f9ac"
  },
  "🐃": {
    "code": "1f403"
  },
  "🐂": {
    "code": "1f402"
  },
  "🐄": {
    "code": "1f404"
  },
  "🫏": {
    "code": "1facf"
  },
  "🐎": {
    "code": "1f40e"
  },
  "🐖": {
    "code": "1f416"
  },
  "🐏": {
    "code": "1f40f"
  },
  "🐑": {
    "code": "1f411"
  },
  "🦙": {
    "code": "1f999"
  },
  "🐐": {
    "code": "1f410"
  },
  "🦌": {
    "code": "1f98c"
  },
  "🐕": {
    "code": "1f415"
  },
  "🐩": {
    "code": "1f429"
  },
  "🦮": {
    "code": "1f9ae"
  },
  "🐕‍🦺": {
    "code": "1f415-200d-1f9ba"
  },
  "🐈": {
    "code": "1f408"
  },
  "🐈‍⬛": {
    "code": "1f408-200d-2b1b"
  },
  "🪶": {
    "code": "1fab6"
  },
  "🪽": {
    "code": "1fabd"
  },
  "🐓": {
    "code": "1f413"
  },
  "🦃": {
    "code": "1f983"
  },
  "🦤": {
    "code": "1f9a4"
  },
  "🦚": {
    "code": "1f99a"
  },
  "🦜": {
    "code": "1f99c"
  },
  "🦢": {
    "code": "1f9a2"
  },
  "🦩": {
    "code": "1f9a9"
  },
  "🕊️": {
    "code": "1f54a"
  },
  "🐇": {
    "code": "1f407"
  },
  "🦝": {
    "code": "1f99d"
  },
  "🦨": {
    "code": "1f9a8"
  },
  "🦡": {
    "code": "1f9a1"
  },
  "🦫": {
    "code": "1f9ab"
  },
  "🦦": {
    "code": "1f9a6"
  },
  "🦥": {
    "code": "1f9a5"
  },
  "🐁": {
    "code": "1f401"
  },
  "🐀": {
    "code": "1f400"
  },
  "🐿️": {
    "code": "1f43f"
  },
  "🦔": {
    "code": "1f994"
  },
  "🐾": {
    "code": "1f43e"
  },
  "🐉": {
    "code": "1f409"
  },
  "🐲": {
    "code": "1f432"
  },
  "🐦‍🔥": {
    "code": "1f426-200d-1f525"
  },
  "🌵": {
    "code": "1f335"
  },
  "🎄": {
    "code": "1f384"
  },
  "🌲": {
    "code": "1f332"
  },
  "🌳": {
    "code": "1f333"
  },
  "🌴": {
    "code": "1f334"
  },
  "🪾": {
    "code": "1fabe"
  },
  "🪵": {
    "code": "1fab5"
  },
  "🌱": {
    "code": "1f331"
  },
  "🌿": {
    "code": "1f33f"
  },
  "☘️": {
    "code": "2618"
  },
  "🍀": {
    "code": "1f340"
  },
  "🎍": {
    "code": "1f38d"
  },
  "🪴": {
    "code": "1fab4"
  },
  "🎋": {
    "code": "1f38b"
  },
  "🍃": {
    "code": "1f343"
  },
  "🍂": {
    "code": "1f342"
  },
  "🍁": {
    "code": "1f341"
  },
  "🪺": {
    "code": "1faba"
  },
  "🪹": {
    "code": "1fab9"
  },
  "🍄": {
    "code": "1f344"
  },
  "🍄‍🟫": {
    "code": "1f344-200d-1f7eb"
  },
  "🐚": {
    "code": "1f41a"
  },
  "🪸": {
    "code": "1fab8"
  },
  "🪨": {
    "code": "1faa8"
  },
  "🌾": {
    "code": "1f33e"
  },
  "💐": {
    "code": "1f490"
  },
  "🌷": {
    "code": "1f337"
  },
  "🌹": {
    "code": "1f339"
  },
  "🥀": {
    "code": "1f940"
  },
  "🪻": {
    "code": "1fabb"
  },
  "🪷": {
    "code": "1fab7"
  },
  "🌺": {
    "code": "1f33a"
  },
  "🌸": {
    "code": "1f338"
  },
  "🌼": {
    "code": "1f33c"
  },
  "🌻": {
    "code": "1f33b"
  },
  "🌞": {
    "code": "1f31e"
  },
  "🌝": {
    "code": "1f31d"
  },
  "🌛": {
    "code": "1f31b"
  },
  "🌜": {
    "code": "1f31c"
  },
  "🌚": {
    "code": "1f31a"
  },
  "🌕": {
    "code": "1f315"
  },
  "🌖": {
    "code": "1f316"
  },
  "🌗": {
    "code": "1f317"
  },
  "🌘": {
    "code": "1f318"
  },
  "🌑": {
    "code": "1f311"
  },
  "🌒": {
    "code": "1f312"
  },
  "🌓": {
    "code": "1f313"
  },
  "🌔": {
    "code": "1f314"
  },
  "🌙": {
    "code": "1f319"
  },
  "🌎": {
    "code": "1f30e"
  },
  "🌍": {
    "code": "1f30d"
  },
  "🌏": {
    "code": "1f30f"
  },
  "🪐": {
    "code": "1fa90"
  },
  "💫": {
    "code": "1f4ab"
  },
  "⭐️": {
    "code": "2b50"
  },
  "🌟": {
    "code": "1f31f"
  },
  "✨": {
    "code": "2728"
  },
  "⚡️": {
    "code": "26a1"
  },
  "☄️": {
    "code": "2604"
  },
  "💥": {
    "code": "1f4a5"
  },
  "🔥": {
    "code": "1f525"
  },
  "🌪️": {
    "code": "1f32a"
  },
  "🌈": {
    "code": "1f308"
  },
  "☀️": {
    "code": "2600"
  },
  "🌤️": {
    "code": "1f324"
  },
  "⛅️": {
    "code": "26c5"
  },
  "🌥️": {
    "code": "1f325"
  },
  "☁️": {
    "code": "2601"
  },
  "🌦️": {
    "code": "1f326"
  },
  "🌧️": {
    "code": "1f327"
  },
  "⛈️": {
    "code": "26c8"
  },
  "🌩️": {
    "code": "1f329"
  },
  "🌨️": {
    "code": "1f328"
  },
  "❄️": {
    "code": "2744"
  },
  "☃️": {
    "code": "2603"
  },
  "⛄️": {
    "code": "26c4"
  },
  "🌬️": {
    "code": "1f32c"
  },
  "💨": {
    "code": "1f4a8"
  },
  "💧": {
    "code": "1f4a7"
  },
  "💦": {
    "code": "1f4a6"
  },
  "🫧": {
    "code": "1fae7"
  },
  "☔️": {
    "code": "2614"
  },
  "☂️": {
    "code": "2602"
  },
  "🌊": {
    "code": "1f30a"
  },
  "🌫️": {
    "code": "1f32b"
  },
  "🍏": {
    "code": "1f34f"
  },
  "🍎": {
    "code": "1f34e"
  },
  "🍐": {
    "code": "1f350"
  },
  "🍊": {
    "code": "1f34a"
  },
  "🍋": {
    "code": "1f34b"
  },
  "🍋‍🟩": {
    "code": "1f34b-200d-1f7e9"
  },
  "🍌": {
    "code": "1f34c"
  },
  "🍉": {
    "code": "1f349"
  },
  "🍇": {
    "code": "1f347"
  },
  "🍓": {
    "code": "1f353"
  },
  "🫐": {
    "code": "1fad0"
  },
  "🍈": {
    "code": "1f348"
  },
  "🍒": {
    "code": "1f352"
  },
  "🍑": {
    "code": "1f351"
  },
  "🥭": {
    "code": "1f96d"
  },
  "🍍": {
    "code": "1f34d"
  },
  "🥥": {
    "code": "1f965"
  },
  "🥝": {
    "code": "1f95d"
  },
  "🍅": {
    "code": "1f345"
  },
  "🍆": {
    "code": "1f346"
  },
  "🥑": {
    "code": "1f951"
  },
  "🫛": {
    "code": "1fadb"
  },
  "🥦": {
    "code": "1f966"
  },
  "🥬": {
    "code": "1f96c"
  },
  "🥒": {
    "code": "1f952"
  },
  "🌶️": {
    "code": "1f336"
  },
  "🫑": {
    "code": "1fad1"
  },
  "🌽": {
    "code": "1f33d"
  },
  "🥕": {
    "code": "1f955"
  },
  "🫒": {
    "code": "1fad2"
  },
  "🧄": {
    "code": "1f9c4"
  },
  "🧅": {
    "code": "1f9c5"
  },
  "🥔": {
    "code": "1f954"
  },
  "🫜": {
    "code": "1fadc"
  },
  "🍠": {
    "code": "1f360"
  },
  "🫚": {
    "code": "1fada"
  },
  "🥐": {
    "code": "1f950"
  },
  "🥯": {
    "code": "1f96f"
  },
  "🍞": {
    "code": "1f35e"
  },
  "🥖": {
    "code": "1f956"
  },
  "🥨": {
    "code": "1f968"
  },
  "🧀": {
    "code": "1f9c0"
  },
  "🥚": {
    "code": "1f95a"
  },
  "🍳": {
    "code": "1f373"
  },
  "🧈": {
    "code": "1f9c8"
  },
  "🥞": {
    "code": "1f95e"
  },
  "🧇": {
    "code": "1f9c7"
  },
  "🥓": {
    "code": "1f953"
  },
  "🥩": {
    "code": "1f969"
  },
  "🍗": {
    "code": "1f357"
  },
  "🍖": {
    "code": "1f356"
  },
  "🦴": {
    "code": "1f9b4"
  },
  "🌭": {
    "code": "1f32d"
  },
  "🍔": {
    "code": "1f354"
  },
  "🍟": {
    "code": "1f35f"
  },
  "🍕": {
    "code": "1f355"
  },
  "🫓": {
    "code": "1fad3"
  },
  "🥪": {
    "code": "1f96a"
  },
  "🥙": {
    "code": "1f959"
  },
  "🧆": {
    "code": "1f9c6"
  },
  "🌮": {
    "code": "1f32e"
  },
  "🌯": {
    "code": "1f32f"
  },
  "🫔": {
    "code": "1fad4"
  },
  "🥗": {
    "code": "1f957"
  },
  "🥘": {
    "code": "1f958"
  },
  "🫕": {
    "code": "1fad5"
  },
  "🥫": {
    "code": "1f96b"
  },
  "🫙": {
    "code": "1fad9"
  },
  "🍝": {
    "code": "1f35d"
  },
  "🍜": {
    "code": "1f35c"
  },
  "🍲": {
    "code": "1f372"
  },
  "🍛": {
    "code": "1f35b"
  },
  "🍣": {
    "code": "1f363"
  },
  "🍱": {
    "code": "1f371"
  },
  "🥟": {
    "code": "1f95f"
  },
  "🦪": {
    "code": "1f9aa"
  },
  "🍤": {
    "code": "1f364"
  },
  "🍙": {
    "code": "1f359"
  },
  "🍚": {
    "code": "1f35a"
  },
  "🍘": {
    "code": "1f358"
  },
  "🍥": {
    "code": "1f365"
  },
  "🥠": {
    "code": "1f960"
  },
  "🥮": {
    "code": "1f96e"
  },
  "🍢": {
    "code": "1f362"
  },
  "🍡": {
    "code": "1f361"
  },
  "🍧": {
    "code": "1f367"
  },
  "🍨": {
    "code": "1f368"
  },
  "🍦": {
    "code": "1f366"
  },
  "🥧": {
    "code": "1f967"
  },
  "🧁": {
    "code": "1f9c1"
  },
  "🍰": {
    "code": "1f370"
  },
  "🎂": {
    "code": "1f382"
  },
  "🍮": {
    "code": "1f36e"
  },
  "🍭": {
    "code": "1f36d"
  },
  "🍬": {
    "code": "1f36c"
  },
  "🍫": {
    "code": "1f36b"
  },
  "🍿": {
    "code": "1f37f"
  },
  "🍩": {
    "code": "1f369"
  },
  "🍪": {
    "code": "1f36a"
  },
  "🌰": {
    "code": "1f330"
  },
  "🥜": {
    "code": "1f95c"
  },
  "🫘": {
    "code": "1fad8"
  },
  "🍯": {
    "code": "1f36f"
  },
  "🥛": {
    "code": "1f95b"
  },
  "🫗": {
    "code": "1fad7"
  },
  "🍼": {
    "code": "1f37c"
  },
  "🫖": {
    "code": "1fad6"
  },
  "☕️": {
    "code": "2615"
  },
  "🍵": {
    "code": "1f375"
  },
  "🧃": {
    "code": "1f9c3"
  },
  "🥤": {
    "code": "1f964"
  },
  "🧋": {
    "code": "1f9cb"
  },
  "🍶": {
    "code": "1f376"
  },
  "🍺": {
    "code": "1f37a"
  },
  "🍻": {
    "code": "1f37b"
  },
  "🥂": {
    "code": "1f942"
  },
  "🍷": {
    "code": "1f377"
  },
  "🥃": {
    "code": "1f943"
  },
  "🍸": {
    "code": "1f378"
  },
  "🍹": {
    "code": "1f379"
  },
  "🧉": {
    "code": "1f9c9"
  },
  "🍾": {
    "code": "1f37e"
  },
  "🧊": {
    "code": "1f9ca"
  },
  "🥄": {
    "code": "1f944"
  },
  "🍴": {
    "code": "1f374"
  },
  "🍽️": {
    "code": "1f37d"
  },
  "🥣": {
    "code": "1f963"
  },
  "🥡": {
    "code": "1f961"
  },
  "🥢": {
    "code": "1f962"
  },
  "🧂": {
    "code": "1f9c2"
  },
  "⚽️": {
    "code": "26bd"
  },
  "🏀": {
    "code": "1f3c0"
  },
  "🏈": {
    "code": "1f3c8"
  },
  "⚾️": {
    "code": "26be"
  },
  "🥎": {
    "code": "1f94e"
  },
  "🎾": {
    "code": "1f3be"
  },
  "🏐": {
    "code": "1f3d0"
  },
  "🏉": {
    "code": "1f3c9"
  },
  "🥏": {
    "code": "1f94f"
  },
  "🎱": {
    "code": "1f3b1"
  },
  "🪀": {
    "code": "1fa80"
  },
  "🏓": {
    "code": "1f3d3"
  },
  "🏸": {
    "code": "1f3f8"
  },
  "🏒": {
    "code": "1f3d2"
  },
  "🏑": {
    "code": "1f3d1"
  },
  "🥍": {
    "code": "1f94d"
  },
  "🏏": {
    "code": "1f3cf"
  },
  "🪃": {
    "code": "1fa83"
  },
  "🥅": {
    "code": "1f945"
  },
  "⛳️": {
    "code": "26f3"
  },
  "🪁": {
    "code": "1fa81"
  },
  "🛝": {
    "code": "1f6dd"
  },
  "🏹": {
    "code": "1f3f9"
  },
  "🎣": {
    "code": "1f3a3"
  },
  "🤿": {
    "code": "1f93f"
  },
  "🥊": {
    "code": "1f94a"
  },
  "🥋": {
    "code": "1f94b"
  },
  "🎽": {
    "code": "1f3bd"
  },
  "🛹": {
    "code": "1f6f9"
  },
  "🛼": {
    "code": "1f6fc"
  },
  "🛷": {
    "code": "1f6f7"
  },
  "⛸️": {
    "code": "26f8"
  },
  "🥌": {
    "code": "1f94c"
  },
  "🎿": {
    "code": "1f3bf"
  },
  "⛷️": {
    "code": "26f7"
  },
  "🏂": {
    "code": "1f3c2"
  },
  "🪂": {
    "code": "1fa82"
  },
  "🏋️‍♀️": {
    "code": "1f3cb-200d-2640"
  },
  "🏋️": {
    "code": "1f3cb"
  },
  "🏋️‍♂️": {
    "code": "1f3cb-200d-2642"
  },
  "🤼‍♀️": {
    "code": "1f93c-200d-2640"
  },
  "🤼": {
    "code": "1f93c"
  },
  "🤼‍♂️": {
    "code": "1f93c-200d-2642"
  },
  "🤸‍♀️": {
    "code": "1f938-200d-2640"
  },
  "🤸": {
    "code": "1f938"
  },
  "🤸‍♂️": {
    "code": "1f938-200d-2642"
  },
  "⛹️‍♀️": {
    "code": "26f9-200d-2640"
  },
  "⛹️": {
    "code": "26f9"
  },
  "⛹️‍♂️": {
    "code": "26f9-200d-2642"
  },
  "🤺": {
    "code": "1f93a"
  },
  "🤾‍♀️": {
    "code": "1f93e-200d-2640"
  },
  "🤾": {
    "code": "1f93e"
  },
  "🤾‍♂️": {
    "code": "1f93e-200d-2642"
  },
  "🏌️‍♀️": {
    "code": "1f3cc-200d-2640"
  },
  "🏌️": {
    "code": "1f3cc"
  },
  "🏌️‍♂️": {
    "code": "1f3cc-200d-2642"
  },
  "🏇": {
    "code": "1f3c7"
  },
  "🧘‍♀️": {
    "code": "1f9d8-200d-2640"
  },
  "🧘": {
    "code": "1f9d8"
  },
  "🧘‍♂️": {
    "code": "1f9d8-200d-2642"
  },
  "🏄‍♀️": {
    "code": "1f3c4-200d-2640"
  },
  "🏄": {
    "code": "1f3c4"
  },
  "🏄‍♂️": {
    "code": "1f3c4-200d-2642"
  },
  "🏊‍♀️": {
    "code": "1f3ca-200d-2640"
  },
  "🏊": {
    "code": "1f3ca"
  },
  "🏊‍♂️": {
    "code": "1f3ca-200d-2642"
  },
  "🤽‍♀️": {
    "code": "1f93d-200d-2640"
  },
  "🤽": {
    "code": "1f93d"
  },
  "🤽‍♂️": {
    "code": "1f93d-200d-2642"
  },
  "🚣‍♀️": {
    "code": "1f6a3-200d-2640"
  },
  "🚣": {
    "code": "1f6a3"
  },
  "🚣‍♂️": {
    "code": "1f6a3-200d-2642"
  },
  "🧗‍♀️": {
    "code": "1f9d7-200d-2640"
  },
  "🧗": {
    "code": "1f9d7"
  },
  "🧗‍♂️": {
    "code": "1f9d7-200d-2642"
  },
  "🚵‍♀️": {
    "code": "1f6b5-200d-2640"
  },
  "🚵": {
    "code": "1f6b5"
  },
  "🚵‍♂️": {
    "code": "1f6b5-200d-2642"
  },
  "🚴‍♀️": {
    "code": "1f6b4-200d-2640"
  },
  "🚴": {
    "code": "1f6b4"
  },
  "🚴‍♂️": {
    "code": "1f6b4-200d-2642"
  },
  "🏆": {
    "code": "1f3c6"
  },
  "🥇": {
    "code": "1f947"
  },
  "🥈": {
    "code": "1f948"
  },
  "🥉": {
    "code": "1f949"
  },
  "🏅": {
    "code": "1f3c5"
  },
  "🎖️": {
    "code": "1f396"
  },
  "🏵️": {
    "code": "1f3f5"
  },
  "🎗️": {
    "code": "1f397"
  },
  "🎫": {
    "code": "1f3ab"
  },
  "🎟️": {
    "code": "1f39f"
  },
  "🎪": {
    "code": "1f3aa"
  },
  "🤹‍♀️": {
    "code": "1f939-200d-2640"
  },
  "🤹": {
    "code": "1f939"
  },
  "🤹‍♂️": {
    "code": "1f939-200d-2642"
  },
  "🎭": {
    "code": "1f3ad"
  },
  "🩰": {
    "code": "1fa70"
  },
  "🎨": {
    "code": "1f3a8"
  },
  "🫟": {
    "code": "1fadf"
  },
  "🎬": {
    "code": "1f3ac"
  },
  "🎤": {
    "code": "1f3a4"
  },
  "🎧": {
    "code": "1f3a7"
  },
  "🎼": {
    "code": "1f3bc"
  },
  "🎹": {
    "code": "1f3b9"
  },
  "🪇": {
    "code": "1fa87"
  },
  "🥁": {
    "code": "1f941"
  },
  "🪘": {
    "code": "1fa98"
  },
  "🎷": {
    "code": "1f3b7"
  },
  "🎺": {
    "code": "1f3ba"
  },
  "🪗": {
    "code": "1fa97"
  },
  "🎸": {
    "code": "1f3b8"
  },
  "🪕": {
    "code": "1fa95"
  },
  "🪉": {
    "code": "1fa89"
  },
  "🎻": {
    "code": "1f3bb"
  },
  "🪈": {
    "code": "1fa88"
  },
  "🎲": {
    "code": "1f3b2"
  },
  "♟️": {
    "code": "265f"
  },
  "🎯": {
    "code": "1f3af"
  },
  "🎳": {
    "code": "1f3b3"
  },
  "🎮": {
    "code": "1f3ae"
  },
  "🎰": {
    "code": "1f3b0"
  },
  "🧩": {
    "code": "1f9e9"
  },
  "🚗": {
    "code": "1f697"
  },
  "🚕": {
    "code": "1f695"
  },
  "🚙": {
    "code": "1f699"
  },
  "🚌": {
    "code": "1f68c"
  },
  "🚎": {
    "code": "1f68e"
  },
  "🏎️": {
    "code": "1f3ce"
  },
  "🚓": {
    "code": "1f693"
  },
  "🚑": {
    "code": "1f691"
  },
  "🚒": {
    "code": "1f692"
  },
  "🚐": {
    "code": "1f690"
  },
  "🛻": {
    "code": "1f6fb"
  },
  "🚚": {
    "code": "1f69a"
  },
  "🚛": {
    "code": "1f69b"
  },
  "🚜": {
    "code": "1f69c"
  },
  "🦯": {
    "code": "1f9af"
  },
  "🦽": {
    "code": "1f9bd"
  },
  "🦼": {
    "code": "1f9bc"
  },
  "🩼": {
    "code": "1fa7c"
  },
  "🛴": {
    "code": "1f6f4"
  },
  "🚲": {
    "code": "1f6b2"
  },
  "🛵": {
    "code": "1f6f5"
  },
  "🏍️": {
    "code": "1f3cd"
  },
  "🛺": {
    "code": "1f6fa"
  },
  "🛞": {
    "code": "1f6de"
  },
  "🚨": {
    "code": "1f6a8"
  },
  "🚔": {
    "code": "1f694"
  },
  "🚍": {
    "code": "1f68d"
  },
  "🚘": {
    "code": "1f698"
  },
  "🚖": {
    "code": "1f696"
  },
  "🚡": {
    "code": "1f6a1"
  },
  "🚠": {
    "code": "1f6a0"
  },
  "🚟": {
    "code": "1f69f"
  },
  "🚃": {
    "code": "1f683"
  },
  "🚋": {
    "code": "1f68b"
  },
  "🚞": {
    "code": "1f69e"
  },
  "🚝": {
    "code": "1f69d"
  },
  "🚄": {
    "code": "1f684"
  },
  "🚅": {
    "code": "1f685"
  },
  "🚈": {
    "code": "1f688"
  },
  "🚂": {
    "code": "1f682"
  },
  "🚆": {
    "code": "1f686"
  },
  "🚇": {
    "code": "1f687"
  },
  "🚊": {
    "code": "1f68a"
  },
  "🚉": {
    "code": "1f689"
  },
  "✈️": {
    "code": "2708"
  },
  "🛫": {
    "code": "1f6eb"
  },
  "🛬": {
    "code": "1f6ec"
  },
  "🛩️": {
    "code": "1f6e9"
  },
  "💺": {
    "code": "1f4ba"
  },
  "🛰️": {
    "code": "1f6f0"
  },
  "🚀": {
    "code": "1f680"
  },
  "🛸": {
    "code": "1f6f8"
  },
  "🚁": {
    "code": "1f681"
  },
  "🛶": {
    "code": "1f6f6"
  },
  "⛵️": {
    "code": "26f5"
  },
  "🚤": {
    "code": "1f6a4"
  },
  "🛥️": {
    "code": "1f6e5"
  },
  "🛳️": {
    "code": "1f6f3"
  },
  "⛴️": {
    "code": "26f4"
  },
  "🚢": {
    "code": "1f6a2"
  },
  "🛟": {
    "code": "1f6df"
  },
  "⚓️": {
    "code": "2693"
  },
  "🪝": {
    "code": "1fa9d"
  },
  "⛽️": {
    "code": "26fd"
  },
  "🚧": {
    "code": "1f6a7"
  },
  "🚦": {
    "code": "1f6a6"
  },
  "🚥": {
    "code": "1f6a5"
  },
  "🚏": {
    "code": "1f68f"
  },
  "🗺️": {
    "code": "1f5fa"
  },
  "🗿": {
    "code": "1f5ff"
  },
  "🗽": {
    "code": "1f5fd"
  },
  "🗼": {
    "code": "1f5fc"
  },
  "🏰": {
    "code": "1f3f0"
  },
  "🏯": {
    "code": "1f3ef"
  },
  "🏟️": {
    "code": "1f3df"
  },
  "🎡": {
    "code": "1f3a1"
  },
  "🎢": {
    "code": "1f3a2"
  },
  "🎠": {
    "code": "1f3a0"
  },
  "⛲️": {
    "code": "26f2"
  },
  "⛱️": {
    "code": "26f1"
  },
  "🏖️": {
    "code": "1f3d6"
  },
  "🏝️": {
    "code": "1f3dd"
  },
  "🏜️": {
    "code": "1f3dc"
  },
  "🌋": {
    "code": "1f30b"
  },
  "⛰️": {
    "code": "26f0"
  },
  "🏔️": {
    "code": "1f3d4"
  },
  "🗻": {
    "code": "1f5fb"
  },
  "🏕️": {
    "code": "1f3d5"
  },
  "⛺️": {
    "code": "26fa"
  },
  "🛖": {
    "code": "1f6d6"
  },
  "🏠": {
    "code": "1f3e0"
  },
  "🏡": {
    "code": "1f3e1"
  },
  "🏘️": {
    "code": "1f3d8"
  },
  "🏚️": {
    "code": "1f3da"
  },
  "🏗️": {
    "code": "1f3d7"
  },
  "🏭": {
    "code": "1f3ed"
  },
  "🏢": {
    "code": "1f3e2"
  },
  "🏬": {
    "code": "1f3ec"
  },
  "🏣": {
    "code": "1f3e3"
  },
  "🏤": {
    "code": "1f3e4"
  },
  "🏥": {
    "code": "1f3e5"
  },
  "🏦": {
    "code": "1f3e6"
  },
  "🏨": {
    "code": "1f3e8"
  },
  "🏪": {
    "code": "1f3ea"
  },
  "🏫": {
    "code": "1f3eb"
  },
  "🏩": {
    "code": "1f3e9"
  },
  "💒": {
    "code": "1f492"
  },
  "🏛️": {
    "code": "1f3db"
  },
  "⛪️": {
    "code": "26ea"
  },
  "🕌": {
    "code": "1f54c"
  },
  "🕍": {
    "code": "1f54d"
  },
  "🛕": {
    "code": "1f6d5"
  },
  "🕋": {
    "code": "1f54b"
  },
  "⛩️": {
    "code": "26e9"
  },
  "🛤️": {
    "code": "1f6e4"
  },
  "🛣️": {
    "code": "1f6e3"
  },
  "🗾": {
    "code": "1f5fe"
  },
  "🎑": {
    "code": "1f391"
  },
  "🏞️": {
    "code": "1f3de"
  },
  "🌅": {
    "code": "1f305"
  },
  "🌄": {
    "code": "1f304"
  },
  "🌠": {
    "code": "1f320"
  },
  "🎇": {
    "code": "1f387"
  },
  "🎆": {
    "code": "1f386"
  },
  "🌇": {
    "code": "1f307"
  },
  "🌆": {
    "code": "1f306"
  },
  "🏙️": {
    "code": "1f3d9"
  },
  "🌃": {
    "code": "1f303"
  },
  "🌌": {
    "code": "1f30c"
  },
  "🌉": {
    "code": "1f309"
  },
  "🌁": {
    "code": "1f301"
  },
  "⌚️": {
    "code": "231a"
  },
  "📱": {
    "code": "1f4f1"
  },
  "📲": {
    "code": "1f4f2"
  },
  "💻": {
    "code": "1f4bb"
  },
  "⌨️": {
    "code": "2328"
  },
  "🖥️": {
    "code": "1f5a5"
  },
  "🖨️": {
    "code": "1f5a8"
  },
  "🖱️": {
    "code": "1f5b1"
  },
  "🖲️": {
    "code": "1f5b2"
  },
  "🕹️": {
    "code": "1f579"
  },
  "🗜️": {
    "code": "1f5dc"
  },
  "💽": {
    "code": "1f4bd"
  },
  "💾": {
    "code": "1f4be"
  },
  "💿": {
    "code": "1f4bf"
  },
  "📀": {
    "code": "1f4c0"
  },
  "📼": {
    "code": "1f4fc"
  },
  "📷": {
    "code": "1f4f7"
  },
  "📸": {
    "code": "1f4f8"
  },
  "📹": {
    "code": "1f4f9"
  },
  "🎥": {
    "code": "1f3a5"
  },
  "📽️": {
    "code": "1f4fd"
  },
  "🎞️": {
    "code": "1f39e"
  },
  "📞": {
    "code": "1f4de"
  },
  "☎️": {
    "code": "260e"
  },
  "📟": {
    "code": "1f4df"
  },
  "📠": {
    "code": "1f4e0"
  },
  "📺": {
    "code": "1f4fa"
  },
  "📻": {
    "code": "1f4fb"
  },
  "🎙️": {
    "code": "1f399"
  },
  "🎚️": {
    "code": "1f39a"
  },
  "🎛️": {
    "code": "1f39b"
  },
  "🧭": {
    "code": "1f9ed"
  },
  "⏱️": {
    "code": "23f1"
  },
  "⏲️": {
    "code": "23f2"
  },
  "⏰": {
    "code": "23f0"
  },
  "🕰️": {
    "code": "1f570"
  },
  "⌛️": {
    "code": "231b"
  },
  "⏳": {
    "code": "23f3"
  },
  "📡": {
    "code": "1f4e1"
  },
  "🔋": {
    "code": "1f50b"
  },
  "🪫": {
    "code": "1faab"
  },
  "🔌": {
    "code": "1f50c"
  },
  "💡": {
    "code": "1f4a1"
  },
  "🔦": {
    "code": "1f526"
  },
  "🕯️": {
    "code": "1f56f"
  },
  "🪔": {
    "code": "1fa94"
  },
  "🧯": {
    "code": "1f9ef"
  },
  "🛢️": {
    "code": "1f6e2"
  },
  "💸": {
    "code": "1f4b8"
  },
  "💵": {
    "code": "1f4b5"
  },
  "💴": {
    "code": "1f4b4"
  },
  "💶": {
    "code": "1f4b6"
  },
  "💷": {
    "code": "1f4b7"
  },
  "🪙": {
    "code": "1fa99"
  },
  "💰": {
    "code": "1f4b0"
  },
  "💳": {
    "code": "1f4b3"
  },
  "🪪": {
    "code": "1faaa"
  },
  "💎": {
    "code": "1f48e"
  },
  "⚖️": {
    "code": "2696"
  },
  "🪜": {
    "code": "1fa9c"
  },
  "🧰": {
    "code": "1f9f0"
  },
  "🪛": {
    "code": "1fa9b"
  },
  "🔧": {
    "code": "1f527"
  },
  "🔨": {
    "code": "1f528"
  },
  "⚒️": {
    "code": "2692"
  },
  "🛠️": {
    "code": "1f6e0"
  },
  "⛏️": {
    "code": "26cf"
  },
  "🪏": {
    "code": "1fa8f"
  },
  "🪚": {
    "code": "1fa9a"
  },
  "🔩": {
    "code": "1f529"
  },
  "⚙️": {
    "code": "2699"
  },
  "🪤": {
    "code": "1faa4"
  },
  "🧱": {
    "code": "1f9f1"
  },
  "⛓️": {
    "code": "26d3"
  },
  "⛓️‍💥": {
    "code": "26d3-200d-1f4a5"
  },
  "🧲": {
    "code": "1f9f2"
  },
  "🔫": {
    "code": "1f52b"
  },
  "💣": {
    "code": "1f4a3"
  },
  "🧨": {
    "code": "1f9e8"
  },
  "🪓": {
    "code": "1fa93"
  },
  "🔪": {
    "code": "1f52a"
  },
  "🗡️": {
    "code": "1f5e1"
  },
  "⚔️": {
    "code": "2694"
  },
  "🛡️": {
    "code": "1f6e1"
  },
  "🚬": {
    "code": "1f6ac"
  },
  "⚰️": {
    "code": "26b0"
  },
  "🪦": {
    "code": "1faa6"
  },
  "⚱️": {
    "code": "26b1"
  },
  "🏺": {
    "code": "1f3fa"
  },
  "🔮": {
    "code": "1f52e"
  },
  "📿": {
    "code": "1f4ff"
  },
  "🧿": {
    "code": "1f9ff"
  },
  "🪬": {
    "code": "1faac"
  },
  "💈": {
    "code": "1f488"
  },
  "⚗️": {
    "code": "2697"
  },
  "🔭": {
    "code": "1f52d"
  },
  "🔬": {
    "code": "1f52c"
  },
  "🕳️": {
    "code": "1f573"
  },
  "🩻": {
    "code": "1fa7b"
  },
  "🩹": {
    "code": "1fa79"
  },
  "🩺": {
    "code": "1fa7a"
  },
  "💊": {
    "code": "1f48a"
  },
  "💉": {
    "code": "1f489"
  },
  "🩸": {
    "code": "1fa78"
  },
  "🧬": {
    "code": "1f9ec"
  },
  "🦠": {
    "code": "1f9a0"
  },
  "🧫": {
    "code": "1f9eb"
  },
  "🧪": {
    "code": "1f9ea"
  },
  "🌡️": {
    "code": "1f321"
  },
  "🧹": {
    "code": "1f9f9"
  },
  "🪠": {
    "code": "1faa0"
  },
  "🧺": {
    "code": "1f9fa"
  },
  "🧻": {
    "code": "1f9fb"
  },
  "🚽": {
    "code": "1f6bd"
  },
  "🚰": {
    "code": "1f6b0"
  },
  "🚿": {
    "code": "1f6bf"
  },
  "🛁": {
    "code": "1f6c1"
  },
  "🛀": {
    "code": "1f6c0"
  },
  "🧼": {
    "code": "1f9fc"
  },
  "🪥": {
    "code": "1faa5"
  },
  "🪒": {
    "code": "1fa92"
  },
  "🪮": {
    "code": "1faae"
  },
  "🧽": {
    "code": "1f9fd"
  },
  "🪣": {
    "code": "1faa3"
  },
  "🧴": {
    "code": "1f9f4"
  },
  "🛎️": {
    "code": "1f6ce"
  },
  "🔑": {
    "code": "1f511"
  },
  "🗝️": {
    "code": "1f5dd"
  },
  "🚪": {
    "code": "1f6aa"
  },
  "🪑": {
    "code": "1fa91"
  },
  "🛋️": {
    "code": "1f6cb"
  },
  "🛏️": {
    "code": "1f6cf"
  },
  "🛌": {
    "code": "1f6cc"
  },
  "🧸": {
    "code": "1f9f8"
  },
  "🪆": {
    "code": "1fa86"
  },
  "🖼️": {
    "code": "1f5bc"
  },
  "🪞": {
    "code": "1fa9e"
  },
  "🪟": {
    "code": "1fa9f"
  },
  "🛍️": {
    "code": "1f6cd"
  },
  "🛒": {
    "code": "1f6d2"
  },
  "🎁": {
    "code": "1f381"
  },
  "🎈": {
    "code": "1f388"
  },
  "🎏": {
    "code": "1f38f"
  },
  "🎀": {
    "code": "1f380"
  },
  "🪄": {
    "code": "1fa84"
  },
  "🪅": {
    "code": "1fa85"
  },
  "🎊": {
    "code": "1f38a"
  },
  "🎉": {
    "code": "1f389"
  },
  "🎎": {
    "code": "1f38e"
  },
  "🪭": {
    "code": "1faad"
  },
  "🏮": {
    "code": "1f3ee"
  },
  "🎐": {
    "code": "1f390"
  },
  "🪩": {
    "code": "1faa9"
  },
  "🧧": {
    "code": "1f9e7"
  },
  "✉️": {
    "code": "2709"
  },
  "📩": {
    "code": "1f4e9"
  },
  "📨": {
    "code": "1f4e8"
  },
  "📧": {
    "code": "1f4e7"
  },
  "💌": {
    "code": "1f48c"
  },
  "📥": {
    "code": "1f4e5"
  },
  "📤": {
    "code": "1f4e4"
  },
  "📦": {
    "code": "1f4e6"
  },
  "🏷️": {
    "code": "1f3f7"
  },
  "🪧": {
    "code": "1faa7"
  },
  "📪": {
    "code": "1f4ea"
  },
  "📫": {
    "code": "1f4eb"
  },
  "📬": {
    "code": "1f4ec"
  },
  "📭": {
    "code": "1f4ed"
  },
  "📮": {
    "code": "1f4ee"
  },
  "📯": {
    "code": "1f4ef"
  },
  "📜": {
    "code": "1f4dc"
  },
  "📃": {
    "code": "1f4c3"
  },
  "📄": {
    "code": "1f4c4"
  },
  "📑": {
    "code": "1f4d1"
  },
  "🧾": {
    "code": "1f9fe"
  },
  "📊": {
    "code": "1f4ca"
  },
  "📈": {
    "code": "1f4c8"
  },
  "📉": {
    "code": "1f4c9"
  },
  "🗒️": {
    "code": "1f5d2"
  },
  "🗓️": {
    "code": "1f5d3"
  },
  "📆": {
    "code": "1f4c6"
  },
  "📅": {
    "code": "1f4c5"
  },
  "🗑️": {
    "code": "1f5d1"
  },
  "📇": {
    "code": "1f4c7"
  },
  "🗃️": {
    "code": "1f5c3"
  },
  "🗳️": {
    "code": "1f5f3"
  },
  "🗄️": {
    "code": "1f5c4"
  },
  "📋": {
    "code": "1f4cb"
  },
  "📁": {
    "code": "1f4c1"
  },
  "📂": {
    "code": "1f4c2"
  },
  "🗂️": {
    "code": "1f5c2"
  },
  "🗞️": {
    "code": "1f5de"
  },
  "📰": {
    "code": "1f4f0"
  },
  "📓": {
    "code": "1f4d3"
  },
  "📔": {
    "code": "1f4d4"
  },
  "📒": {
    "code": "1f4d2"
  },
  "📕": {
    "code": "1f4d5"
  },
  "📗": {
    "code": "1f4d7"
  },
  "📘": {
    "code": "1f4d8"
  },
  "📙": {
    "code": "1f4d9"
  },
  "📚": {
    "code": "1f4da"
  },
  "📖": {
    "code": "1f4d6"
  },
  "🔖": {
    "code": "1f516"
  },
  "🧷": {
    "code": "1f9f7"
  },
  "🔗": {
    "code": "1f517"
  },
  "📎": {
    "code": "1f4ce"
  },
  "🖇️": {
    "code": "1f587"
  },
  "📐": {
    "code": "1f4d0"
  },
  "📏": {
    "code": "1f4cf"
  },
  "🧮": {
    "code": "1f9ee"
  },
  "📌": {
    "code": "1f4cc"
  },
  "📍": {
    "code": "1f4cd"
  },
  "✂️": {
    "code": "2702"
  },
  "🖊️": {
    "code": "1f58a"
  },
  "🖋️": {
    "code": "1f58b"
  },
  "✒️": {
    "code": "2712"
  },
  "🖌️": {
    "code": "1f58c"
  },
  "🖍️": {
    "code": "1f58d"
  },
  "📝": {
    "code": "1f4dd"
  },
  "✏️": {
    "code": "270f"
  },
  "🔍": {
    "code": "1f50d"
  },
  "🔎": {
    "code": "1f50e"
  },
  "🔏": {
    "code": "1f50f"
  },
  "🔐": {
    "code": "1f510"
  },
  "🔒": {
    "code": "1f512"
  },
  "🔓": {
    "code": "1f513"
  },
  "🩷": {
    "code": "1fa77"
  },
  "❤️": {
    "code": "2764"
  },
  "🧡": {
    "code": "1f9e1"
  },
  "💛": {
    "code": "1f49b"
  },
  "💚": {
    "code": "1f49a"
  },
  "🩵": {
    "code": "1fa75"
  },
  "💙": {
    "code": "1f499"
  },
  "💜": {
    "code": "1f49c"
  },
  "🖤": {
    "code": "1f5a4"
  },
  "🩶": {
    "code": "1fa76"
  },
  "🤍": {
    "code": "1f90d"
  },
  "🤎": {
    "code": "1f90e"
  },
  "💔": {
    "code": "1f494"
  },
  "❤️‍🔥": {
    "code": "2764-200d-1f525"
  },
  "❤️‍🩹": {
    "code": "2764-200d-1fa79"
  },
  "❣️": {
    "code": "2763"
  },
  "💕": {
    "code": "1f495"
  },
  "💞": {
    "code": "1f49e"
  },
  "💓": {
    "code": "1f493"
  },
  "💗": {
    "code": "1f497"
  },
  "💖": {
    "code": "1f496"
  },
  "💘": {
    "code": "1f498"
  },
  "💝": {
    "code": "1f49d"
  },
  "💟": {
    "code": "1f49f"
  },
  "☮️": {
    "code": "262e"
  },
  "✝️": {
    "code": "271d"
  },
  "☪️": {
    "code": "262a"
  },
  "🕉️": {
    "code": "1f549"
  },
  "☸️": {
    "code": "2638"
  },
  "🪯": {
    "code": "1faaf"
  },
  "✡️": {
    "code": "2721"
  },
  "🔯": {
    "code": "1f52f"
  },
  "🕎": {
    "code": "1f54e"
  },
  "☯️": {
    "code": "262f"
  },
  "☦️": {
    "code": "2626"
  },
  "🛐": {
    "code": "1f6d0"
  },
  "⛎": {
    "code": "26ce"
  },
  "♈️": {
    "code": "2648"
  },
  "♉️": {
    "code": "2649"
  },
  "♊️": {
    "code": "264a"
  },
  "♋️": {
    "code": "264b"
  },
  "♌️": {
    "code": "264c"
  },
  "♍️": {
    "code": "264d"
  },
  "♎️": {
    "code": "264e"
  },
  "♏️": {
    "code": "264f"
  },
  "♐️": {
    "code": "2650"
  },
  "♑️": {
    "code": "2651"
  },
  "♒️": {
    "code": "2652"
  },
  "♓️": {
    "code": "2653"
  },
  "🆔": {
    "code": "1f194"
  },
  "⚛️": {
    "code": "269b"
  },
  "🉑": {
    "code": "1f251"
  },
  "☢️": {
    "code": "2622"
  },
  "☣️": {
    "code": "2623"
  },
  "📴": {
    "code": "1f4f4"
  },
  "📳": {
    "code": "1f4f3"
  },
  "🈶": {
    "code": "1f236"
  },
  "🈚️": {
    "code": "1f21a"
  },
  "🈸": {
    "code": "1f238"
  },
  "🈺": {
    "code": "1f23a"
  },
  "🈷️": {
    "code": "1f237"
  },
  "✴️": {
    "code": "2734"
  },
  "🆚": {
    "code": "1f19a"
  },
  "💮": {
    "code": "1f4ae"
  },
  "🉐": {
    "code": "1f250"
  },
  "㊙️": {
    "code": "3299"
  },
  "㊗️": {
    "code": "3297"
  },
  "🈴": {
    "code": "1f234"
  },
  "🈵": {
    "code": "1f235"
  },
  "🈹": {
    "code": "1f239"
  },
  "🈲": {
    "code": "1f232"
  },
  "🅰️": {
    "code": "1f170"
  },
  "🅱️": {
    "code": "1f171"
  },
  "🆎": {
    "code": "1f18e"
  },
  "🆑": {
    "code": "1f191"
  },
  "🅾️": {
    "code": "1f17e"
  },
  "🆘": {
    "code": "1f198"
  },
  "❌": {
    "code": "274c"
  },
  "⭕️": {
    "code": "2b55"
  },
  "🛑": {
    "code": "1f6d1"
  },
  "⛔️": {
    "code": "26d4"
  },
  "📛": {
    "code": "1f4db"
  },
  "🚫": {
    "code": "1f6ab"
  },
  "💯": {
    "code": "1f4af"
  },
  "💢": {
    "code": "1f4a2"
  },
  "♨️": {
    "code": "2668"
  },
  "🚷": {
    "code": "1f6b7"
  },
  "🚯": {
    "code": "1f6af"
  },
  "🚳": {
    "code": "1f6b3"
  },
  "🚱": {
    "code": "1f6b1"
  },
  "🔞": {
    "code": "1f51e"
  },
  "📵": {
    "code": "1f4f5"
  },
  "🚭": {
    "code": "1f6ad"
  },
  "❗️": {
    "code": "2757"
  },
  "❕": {
    "code": "2755"
  },
  "❓": {
    "code": "2753"
  },
  "❔": {
    "code": "2754"
  },
  "‼️": {
    "code": "203c"
  },
  "⁉️": {
    "code": "2049"
  },
  "🔅": {
    "code": "1f505"
  },
  "🔆": {
    "code": "1f506"
  },
  "〽️": {
    "code": "303d"
  },
  "⚠️": {
    "code": "26a0"
  },
  "🚸": {
    "code": "1f6b8"
  },
  "🔱": {
    "code": "1f531"
  },
  "⚜️": {
    "code": "269c"
  },
  "🔰": {
    "code": "1f530"
  },
  "♻️": {
    "code": "267b"
  },
  "✅": {
    "code": "2705"
  },
  "🈯️": {
    "code": "1f22f"
  },
  "💹": {
    "code": "1f4b9"
  },
  "❇️": {
    "code": "2747"
  },
  "✳️": {
    "code": "2733"
  },
  "❎": {
    "code": "274e"
  },
  "🌐": {
    "code": "1f310"
  },
  "💠": {
    "code": "1f4a0"
  },
  "Ⓜ️": {
    "code": "24c2"
  },
  "🌀": {
    "code": "1f300"
  },
  "💤": {
    "code": "1f4a4"
  },
  "🏧": {
    "code": "1f3e7"
  },
  "🚾": {
    "code": "1f6be"
  },
  "♿️": {
    "code": "267f"
  },
  "🅿️": {
    "code": "1f17f"
  },
  "🛗": {
    "code": "1f6d7"
  },
  "🈳": {
    "code": "1f233"
  },
  "🈂️": {
    "code": "1f202"
  },
  "🛂": {
    "code": "1f6c2"
  },
  "🛃": {
    "code": "1f6c3"
  },
  "🛄": {
    "code": "1f6c4"
  },
  "🛅": {
    "code": "1f6c5"
  },
  "🛜": {
    "code": "1f6dc"
  },
  "🚹": {
    "code": "1f6b9"
  },
  "🚺": {
    "code": "1f6ba"
  },
  "🚼": {
    "code": "1f6bc"
  },
  "🧑‍🧑‍🧒": {
    "code": "1f9d1-200d-1f9d1-200d-1f9d2"
  },
  "🧑‍🧑‍🧒‍🧒": {
    "code": "1f9d1-200d-1f9d1-200d-1f9d2-200d-1f9d2"
  },
  "🧑‍🧒": {
    "code": "1f9d1-200d-1f9d2"
  },
  "🧑‍🧒‍🧒": {
    "code": "1f9d1-200d-1f9d2-200d-1f9d2"
  },
  "⚧️": {
    "code": "26a7"
  },
  "🚻": {
    "code": "1f6bb"
  },
  "🚮": {
    "code": "1f6ae"
  },
  "🎦": {
    "code": "1f3a6"
  },
  "📶": {
    "code": "1f4f6"
  },
  "🈁": {
    "code": "1f201"
  },
  "🔣": {
    "code": "1f523"
  },
  "ℹ️": {
    "code": "2139"
  },
  "🔤": {
    "code": "1f524"
  },
  "🔡": {
    "code": "1f521"
  },
  "🔠": {
    "code": "1f520"
  },
  "🆖": {
    "code": "1f196"
  },
  "🆗": {
    "code": "1f197"
  },
  "🆙": {
    "code": "1f199"
  },
  "🆒": {
    "code": "1f192"
  },
  "🆕": {
    "code": "1f195"
  },
  "🆓": {
    "code": "1f193"
  },
  "0️⃣": {
    "code": "30-20e3"
  },
  "1️⃣": {
    "code": "31-20e3"
  },
  "2️⃣": {
    "code": "32-20e3"
  },
  "3️⃣": {
    "code": "33-20e3"
  },
  "4️⃣": {
    "code": "34-20e3"
  },
  "5️⃣": {
    "code": "35-20e3"
  },
  "6️⃣": {
    "code": "36-20e3"
  },
  "7️⃣": {
    "code": "37-20e3"
  },
  "8️⃣": {
    "code": "38-20e3"
  },
  "9️⃣": {
    "code": "39-20e3"
  },
  "🔟": {
    "code": "1f51f"
  },
  "🔢": {
    "code": "1f522"
  },
  "#️⃣": {
    "code": "23-20e3"
  },
  "*️⃣": {
    "code": "2a-20e3"
  },
  "⏏️": {
    "code": "23cf"
  },
  "▶️": {
    "code": "25b6"
  },
  "⏸️": {
    "code": "23f8"
  },
  "⏯️": {
    "code": "23ef"
  },
  "⏹️": {
    "code": "23f9"
  },
  "⏺️": {
    "code": "23fa"
  },
  "⏭️": {
    "code": "23ed"
  },
  "⏮️": {
    "code": "23ee"
  },
  "⏩️": {
    "code": "23e9"
  },
  "⏪️": {
    "code": "23ea"
  },
  "⏫️": {
    "code": "23eb"
  },
  "⏬️": {
    "code": "23ec"
  },
  "◀️": {
    "code": "25c0"
  },
  "🔼": {
    "code": "1f53c"
  },
  "🔽": {
    "code": "1f53d"
  },
  "➡️": {
    "code": "27a1"
  },
  "⬅️": {
    "code": "2b05"
  },
  "⬆️": {
    "code": "2b06"
  },
  "⬇️": {
    "code": "2b07"
  },
  "↗️": {
    "code": "2197"
  },
  "↘️": {
    "code": "2198"
  },
  "↙️": {
    "code": "2199"
  },
  "↖️": {
    "code": "2196"
  },
  "↕️": {
    "code": "2195"
  },
  "↔️": {
    "code": "2194"
  },
  "↪️": {
    "code": "21aa"
  },
  "↩️": {
    "code": "21a9"
  },
  "⤴️": {
    "code": "2934"
  },
  "⤵️": {
    "code": "2935"
  },
  "🔀": {
    "code": "1f500"
  },
  "🔁": {
    "code": "1f501"
  },
  "🔂": {
    "code": "1f502"
  },
  "🔄": {
    "code": "1f504"
  },
  "🔃": {
    "code": "1f503"
  },
  "🎵": {
    "code": "1f3b5"
  },
  "🎶": {
    "code": "1f3b6"
  },
  "➕": {
    "code": "2795"
  },
  "➖": {
    "code": "2796"
  },
  "➗": {
    "code": "2797"
  },
  "✖️": {
    "code": "2716"
  },
  "🟰": {
    "code": "1f7f0"
  },
  "♾️": {
    "code": "267e"
  },
  "💲": {
    "code": "1f4b2"
  },
  "💱": {
    "code": "1f4b1"
  },
  "™️": {
    "code": "2122"
  },
  "©️": {
    "code": "a9"
  },
  "®️": {
    "code": "ae"
  },
  "👁️‍🗨️": {
    "code": "1f441-200d-1f5e8"
  },
  "🔚": {
    "code": "1f51a"
  },
  "🔙": {
    "code": "1f519"
  },
  "🔛": {
    "code": "1f51b"
  },
  "🔝": {
    "code": "1f51d"
  },
  "🔜": {
    "code": "1f51c"
  },
  "〰️": {
    "code": "3030"
  },
  "➰": {
    "code": "27b0"
  },
  "➿": {
    "code": "27bf"
  },
  "✔️": {
    "code": "2714"
  },
  "☑️": {
    "code": "2611"
  },
  "🔘": {
    "code": "1f518"
  },
  "🔴": {
    "code": "1f534"
  },
  "🟠": {
    "code": "1f7e0"
  },
  "🟡": {
    "code": "1f7e1"
  },
  "🟢": {
    "code": "1f7e2"
  },
  "🔵": {
    "code": "1f535"
  },
  "🟣": {
    "code": "1f7e3"
  },
  "⚫️": {
    "code": "26ab"
  },
  "⚪️": {
    "code": "26aa"
  },
  "🟤": {
    "code": "1f7e4"
  },
  "🔺": {
    "code": "1f53a"
  },
  "🔻": {
    "code": "1f53b"
  },
  "🔸": {
    "code": "1f538"
  },
  "🔹": {
    "code": "1f539"
  },
  "🔶": {
    "code": "1f536"
  },
  "🔷": {
    "code": "1f537"
  },
  "🔳": {
    "code": "1f533"
  },
  "🔲": {
    "code": "1f532"
  },
  "▪️": {
    "code": "25aa"
  },
  "▫️": {
    "code": "25ab"
  },
  "◾️": {
    "code": "25fe"
  },
  "◽️": {
    "code": "25fd"
  },
  "◼️": {
    "code": "25fc"
  },
  "◻️": {
    "code": "25fb"
  },
  "🟥": {
    "code": "1f7e5"
  },
  "🟧": {
    "code": "1f7e7"
  },
  "🟨": {
    "code": "1f7e8"
  },
  "🟩": {
    "code": "1f7e9"
  },
  "🟦": {
    "code": "1f7e6"
  },
  "🟪": {
    "code": "1f7ea"
  },
  "⬛️": {
    "code": "2b1b"
  },
  "⬜️": {
    "code": "2b1c"
  },
  "🟫": {
    "code": "1f7eb"
  },
  "🔈": {
    "code": "1f508"
  },
  "🔇": {
    "code": "1f507"
  },
  "🔉": {
    "code": "1f509"
  },
  "🔊": {
    "code": "1f50a"
  },
  "🔔": {
    "code": "1f514"
  },
  "🔕": {
    "code": "1f515"
  },
  "📣": {
    "code": "1f4e3"
  },
  "📢": {
    "code": "1f4e2"
  },
  "💬": {
    "code": "1f4ac"
  },
  "💭": {
    "code": "1f4ad"
  },
  "🗯️": {
    "code": "1f5ef"
  },
  "♠️": {
    "code": "2660"
  },
  "♣️": {
    "code": "2663"
  },
  "♥️": {
    "code": "2665"
  },
  "♦️": {
    "code": "2666"
  },
  "🃏": {
    "code": "1f0cf"
  },
  "🎴": {
    "code": "1f3b4"
  },
  "🀄️": {
    "code": "1f004"
  },
  "🕐": {
    "code": "1f550"
  },
  "🕑": {
    "code": "1f551"
  },
  "🕒": {
    "code": "1f552"
  },
  "🕓": {
    "code": "1f553"
  },
  "🕔": {
    "code": "1f554"
  },
  "🕕": {
    "code": "1f555"
  },
  "🕖": {
    "code": "1f556"
  },
  "🕗": {
    "code": "1f557"
  },
  "🕘": {
    "code": "1f558"
  },
  "🕙": {
    "code": "1f559"
  },
  "🕚": {
    "code": "1f55a"
  },
  "🕛": {
    "code": "1f55b"
  },
  "🕜": {
    "code": "1f55c"
  },
  "🕝": {
    "code": "1f55d"
  },
  "🕞": {
    "code": "1f55e"
  },
  "🕟": {
    "code": "1f55f"
  },
  "🕠": {
    "code": "1f560"
  },
  "🕡": {
    "code": "1f561"
  },
  "🕢": {
    "code": "1f562"
  },
  "🕣": {
    "code": "1f563"
  },
  "🕤": {
    "code": "1f564"
  },
  "🕥": {
    "code": "1f565"
  },
  "🕦": {
    "code": "1f566"
  },
  "🕧": {
    "code": "1f567"
  },
  "🏳️": {
    "code": "1f3f3"
  },
  "🏴": {
    "code": "1f3f4"
  },
  "🏴‍☠️": {
    "code": "1f3f4-200d-2620"
  },
  "🏁": {
    "code": "1f3c1"
  },
  "🚩": {
    "code": "1f6a9"
  },
  "🏳️‍🌈": {
    "code": "1f3f3-200d-1f308"
  },
  "🏳️‍⚧️": {
    "code": "1f3f3-200d-26a7"
  },
  "🇺🇳": {
    "code": "1f1fa-1f1f3"
  },
  "🇦🇫": {
    "code": "1f1e6-1f1eb"
  },
  "🇦🇽": {
    "code": "1f1e6-1f1fd"
  },
  "🇦🇱": {
    "code": "1f1e6-1f1f1"
  },
  "🇩🇿": {
    "code": "1f1e9-1f1ff"
  },
  "🇦🇸": {
    "code": "1f1e6-1f1f8"
  },
  "🇦🇩": {
    "code": "1f1e6-1f1e9"
  },
  "🇦🇴": {
    "code": "1f1e6-1f1f4"
  },
  "🇦🇮": {
    "code": "1f1e6-1f1ee"
  },
  "🇦🇶": {
    "code": "1f1e6-1f1f6"
  },
  "🇦🇬": {
    "code": "1f1e6-1f1ec"
  },
  "🇦🇷": {
    "code": "1f1e6-1f1f7"
  },
  "🇦🇲": {
    "code": "1f1e6-1f1f2"
  },
  "🇦🇼": {
    "code": "1f1e6-1f1fc"
  },
  "🇦🇺": {
    "code": "1f1e6-1f1fa"
  },
  "🇦🇹": {
    "code": "1f1e6-1f1f9"
  },
  "🇦🇿": {
    "code": "1f1e6-1f1ff"
  },
  "🇧🇸": {
    "code": "1f1e7-1f1f8"
  },
  "🇧🇭": {
    "code": "1f1e7-1f1ed"
  },
  "🇧🇩": {
    "code": "1f1e7-1f1e9"
  },
  "🇧🇧": {
    "code": "1f1e7-1f1e7"
  },
  "🇧🇾": {
    "code": "1f1e7-1f1fe"
  },
  "🇧🇪": {
    "code": "1f1e7-1f1ea"
  },
  "🇧🇿": {
    "code": "1f1e7-1f1ff"
  },
  "🇧🇯": {
    "code": "1f1e7-1f1ef"
  },
  "🇧🇲": {
    "code": "1f1e7-1f1f2"
  },
  "🇧🇹": {
    "code": "1f1e7-1f1f9"
  },
  "🇧🇴": {
    "code": "1f1e7-1f1f4"
  },
  "🇧🇦": {
    "code": "1f1e7-1f1e6"
  },
  "🇧🇼": {
    "code": "1f1e7-1f1fc"
  },
  "🇧🇷": {
    "code": "1f1e7-1f1f7"
  },
  "🇻🇬": {
    "code": "1f1fb-1f1ec"
  },
  "🇧🇳": {
    "code": "1f1e7-1f1f3"
  },
  "🇧🇬": {
    "code": "1f1e7-1f1ec"
  },
  "🇧🇫": {
    "code": "1f1e7-1f1eb"
  },
  "🇧🇮": {
    "code": "1f1e7-1f1ee"
  },
  "🇰🇭": {
    "code": "1f1f0-1f1ed"
  },
  "🇨🇲": {
    "code": "1f1e8-1f1f2"
  },
  "🇨🇦": {
    "code": "1f1e8-1f1e6"
  },
  "🇮🇨": {
    "code": "1f1ee-1f1e8"
  },
  "🇨🇻": {
    "code": "1f1e8-1f1fb"
  },
  "🇧🇶": {
    "code": "1f1e7-1f1f6"
  },
  "🇰🇾": {
    "code": "1f1f0-1f1fe"
  },
  "🇨🇫": {
    "code": "1f1e8-1f1eb"
  },
  "🇹🇩": {
    "code": "1f1f9-1f1e9"
  },
  "🇮🇴": {
    "code": "1f1ee-1f1f4"
  },
  "🇨🇱": {
    "code": "1f1e8-1f1f1"
  },
  "🇨🇳": {
    "code": "1f1e8-1f1f3"
  },
  "🇨🇽": {
    "code": "1f1e8-1f1fd"
  },
  "🇨🇨": {
    "code": "1f1e8-1f1e8"
  },
  "🇨🇴": {
    "code": "1f1e8-1f1f4"
  },
  "🇰🇲": {
    "code": "1f1f0-1f1f2"
  },
  "🇨🇬": {
    "code": "1f1e8-1f1ec"
  },
  "🇨🇩": {
    "code": "1f1e8-1f1e9"
  },
  "🇨🇰": {
    "code": "1f1e8-1f1f0"
  },
  "🇨🇷": {
    "code": "1f1e8-1f1f7"
  },
  "🇨🇮": {
    "code": "1f1e8-1f1ee"
  },
  "🇭🇷": {
    "code": "1f1ed-1f1f7"
  },
  "🇨🇺": {
    "code": "1f1e8-1f1fa"
  },
  "🇨🇼": {
    "code": "1f1e8-1f1fc"
  },
  "🇨🇾": {
    "code": "1f1e8-1f1fe"
  },
  "🇨🇿": {
    "code": "1f1e8-1f1ff"
  },
  "🇩🇰": {
    "code": "1f1e9-1f1f0"
  },
  "🇩🇯": {
    "code": "1f1e9-1f1ef"
  },
  "🇩🇲": {
    "code": "1f1e9-1f1f2"
  },
  "🇩🇴": {
    "code": "1f1e9-1f1f4"
  },
  "🇪🇨": {
    "code": "1f1ea-1f1e8"
  },
  "🇪🇬": {
    "code": "1f1ea-1f1ec"
  },
  "🇸🇻": {
    "code": "1f1f8-1f1fb"
  },
  "🇬🇶": {
    "code": "1f1ec-1f1f6"
  },
  "🇪🇷": {
    "code": "1f1ea-1f1f7"
  },
  "🇪🇪": {
    "code": "1f1ea-1f1ea"
  },
  "🇸🇿": {
    "code": "1f1f8-1f1ff"
  },
  "🇪🇹": {
    "code": "1f1ea-1f1f9"
  },
  "🇪🇺": {
    "code": "1f1ea-1f1fa"
  },
  "🇫🇰": {
    "code": "1f1eb-1f1f0"
  },
  "🇫🇴": {
    "code": "1f1eb-1f1f4"
  },
  "🇫🇯": {
    "code": "1f1eb-1f1ef"
  },
  "🇫🇮": {
    "code": "1f1eb-1f1ee"
  },
  "🇫🇷": {
    "code": "1f1eb-1f1f7"
  },
  "🇬🇫": {
    "code": "1f1ec-1f1eb"
  },
  "🇵🇫": {
    "code": "1f1f5-1f1eb"
  },
  "🇹🇫": {
    "code": "1f1f9-1f1eb"
  },
  "🇬🇦": {
    "code": "1f1ec-1f1e6"
  },
  "🇬🇲": {
    "code": "1f1ec-1f1f2"
  },
  "🇬🇪": {
    "code": "1f1ec-1f1ea"
  },
  "🇩🇪": {
    "code": "1f1e9-1f1ea"
  },
  "🇬🇭": {
    "code": "1f1ec-1f1ed"
  },
  "🇬🇮": {
    "code": "1f1ec-1f1ee"
  },
  "🇬🇷": {
    "code": "1f1ec-1f1f7"
  },
  "🇬🇱": {
    "code": "1f1ec-1f1f1"
  },
  "🇬🇩": {
    "code": "1f1ec-1f1e9"
  },
  "🇬🇵": {
    "code": "1f1ec-1f1f5"
  },
  "🇬🇺": {
    "code": "1f1ec-1f1fa"
  },
  "🇬🇹": {
    "code": "1f1ec-1f1f9"
  },
  "🇬🇬": {
    "code": "1f1ec-1f1ec"
  },
  "🇬🇳": {
    "code": "1f1ec-1f1f3"
  },
  "🇬🇼": {
    "code": "1f1ec-1f1fc"
  },
  "🇬🇾": {
    "code": "1f1ec-1f1fe"
  },
  "🇭🇹": {
    "code": "1f1ed-1f1f9"
  },
  "🇭🇳": {
    "code": "1f1ed-1f1f3"
  },
  "🇭🇰": {
    "code": "1f1ed-1f1f0"
  },
  "🇭🇺": {
    "code": "1f1ed-1f1fa"
  },
  "🇮🇸": {
    "code": "1f1ee-1f1f8"
  },
  "🇮🇳": {
    "code": "1f1ee-1f1f3"
  },
  "🇮🇩": {
    "code": "1f1ee-1f1e9"
  },
  "🇮🇷": {
    "code": "1f1ee-1f1f7"
  },
  "🇮🇶": {
    "code": "1f1ee-1f1f6"
  },
  "🇮🇪": {
    "code": "1f1ee-1f1ea"
  },
  "🇮🇲": {
    "code": "1f1ee-1f1f2"
  },
  "🇮🇱": {
    "code": "1f1ee-1f1f1"
  },
  "🇮🇹": {
    "code": "1f1ee-1f1f9"
  },
  "🇯🇲": {
    "code": "1f1ef-1f1f2"
  },
  "🇯🇵": {
    "code": "1f1ef-1f1f5"
  },
  "🎌": {
    "code": "1f38c"
  },
  "🇯🇪": {
    "code": "1f1ef-1f1ea"
  },
  "🇯🇴": {
    "code": "1f1ef-1f1f4"
  },
  "🇰🇿": {
    "code": "1f1f0-1f1ff"
  },
  "🇰🇪": {
    "code": "1f1f0-1f1ea"
  },
  "🇰🇮": {
    "code": "1f1f0-1f1ee"
  },
  "🇽🇰": {
    "code": "1f1fd-1f1f0"
  },
  "🇰🇼": {
    "code": "1f1f0-1f1fc"
  },
  "🇰🇬": {
    "code": "1f1f0-1f1ec"
  },
  "🇱🇦": {
    "code": "1f1f1-1f1e6"
  },
  "🇱🇻": {
    "code": "1f1f1-1f1fb"
  },
  "🇱🇧": {
    "code": "1f1f1-1f1e7"
  },
  "🇱🇸": {
    "code": "1f1f1-1f1f8"
  },
  "🇱🇷": {
    "code": "1f1f1-1f1f7"
  },
  "🇱🇾": {
    "code": "1f1f1-1f1fe"
  },
  "🇱🇮": {
    "code": "1f1f1-1f1ee"
  },
  "🇱🇹": {
    "code": "1f1f1-1f1f9"
  },
  "🇱🇺": {
    "code": "1f1f1-1f1fa"
  },
  "🇲🇴": {
    "code": "1f1f2-1f1f4"
  },
  "🇲🇬": {
    "code": "1f1f2-1f1ec"
  },
  "🇲🇼": {
    "code": "1f1f2-1f1fc"
  },
  "🇲🇾": {
    "code": "1f1f2-1f1fe"
  },
  "🇲🇻": {
    "code": "1f1f2-1f1fb"
  },
  "🇲🇱": {
    "code": "1f1f2-1f1f1"
  },
  "🇲🇹": {
    "code": "1f1f2-1f1f9"
  },
  "🇲🇭": {
    "code": "1f1f2-1f1ed"
  },
  "🇲🇶": {
    "code": "1f1f2-1f1f6"
  },
  "🇲🇷": {
    "code": "1f1f2-1f1f7"
  },
  "🇲🇺": {
    "code": "1f1f2-1f1fa"
  },
  "🇾🇹": {
    "code": "1f1fe-1f1f9"
  },
  "🇲🇽": {
    "code": "1f1f2-1f1fd"
  },
  "🇫🇲": {
    "code": "1f1eb-1f1f2"
  },
  "🇲🇩": {
    "code": "1f1f2-1f1e9"
  },
  "🇲🇨": {
    "code": "1f1f2-1f1e8"
  },
  "🇲🇳": {
    "code": "1f1f2-1f1f3"
  },
  "🇲🇪": {
    "code": "1f1f2-1f1ea"
  },
  "🇲🇸": {
    "code": "1f1f2-1f1f8"
  },
  "🇲🇦": {
    "code": "1f1f2-1f1e6"
  },
  "🇲🇿": {
    "code": "1f1f2-1f1ff"
  },
  "🇲🇲": {
    "code": "1f1f2-1f1f2"
  },
  "🇳🇦": {
    "code": "1f1f3-1f1e6"
  },
  "🇳🇷": {
    "code": "1f1f3-1f1f7"
  },
  "🇳🇵": {
    "code": "1f1f3-1f1f5"
  },
  "🇳🇱": {
    "code": "1f1f3-1f1f1"
  },
  "🇳🇨": {
    "code": "1f1f3-1f1e8"
  },
  "🇳🇿": {
    "code": "1f1f3-1f1ff"
  },
  "🇳🇮": {
    "code": "1f1f3-1f1ee"
  },
  "🇳🇪": {
    "code": "1f1f3-1f1ea"
  },
  "🇳🇬": {
    "code": "1f1f3-1f1ec"
  },
  "🇳🇺": {
    "code": "1f1f3-1f1fa"
  },
  "🇳🇫": {
    "code": "1f1f3-1f1eb"
  },
  "🇰🇵": {
    "code": "1f1f0-1f1f5"
  },
  "🇲🇰": {
    "code": "1f1f2-1f1f0"
  },
  "🇲🇵": {
    "code": "1f1f2-1f1f5"
  },
  "🇳🇴": {
    "code": "1f1f3-1f1f4"
  },
  "🇴🇲": {
    "code": "1f1f4-1f1f2"
  },
  "🇵🇰": {
    "code": "1f1f5-1f1f0"
  },
  "🇵🇼": {
    "code": "1f1f5-1f1fc"
  },
  "🇵🇸": {
    "code": "1f1f5-1f1f8"
  },
  "🇵🇦": {
    "code": "1f1f5-1f1e6"
  },
  "🇵🇬": {
    "code": "1f1f5-1f1ec"
  },
  "🇵🇾": {
    "code": "1f1f5-1f1fe"
  },
  "🇵🇪": {
    "code": "1f1f5-1f1ea"
  },
  "🇵🇭": {
    "code": "1f1f5-1f1ed"
  },
  "🇵🇳": {
    "code": "1f1f5-1f1f3"
  },
  "🇵🇱": {
    "code": "1f1f5-1f1f1"
  },
  "🇵🇹": {
    "code": "1f1f5-1f1f9"
  },
  "🇵🇷": {
    "code": "1f1f5-1f1f7"
  },
  "🇶🇦": {
    "code": "1f1f6-1f1e6"
  },
  "🇷🇪": {
    "code": "1f1f7-1f1ea"
  },
  "🇷🇴": {
    "code": "1f1f7-1f1f4"
  },
  "🇷🇺": {
    "code": "1f1f7-1f1fa"
  },
  "🇷🇼": {
    "code": "1f1f7-1f1fc"
  },
  "🇼🇸": {
    "code": "1f1fc-1f1f8"
  },
  "🇸🇲": {
    "code": "1f1f8-1f1f2"
  },
  "🇸🇹": {
    "code": "1f1f8-1f1f9"
  },
  "🇨🇶": {
    "code": "1f1e8-1f1f6"
  },
  "🇸🇦": {
    "code": "1f1f8-1f1e6"
  },
  "🇸🇳": {
    "code": "1f1f8-1f1f3"
  },
  "🇷🇸": {
    "code": "1f1f7-1f1f8"
  },
  "🇸🇨": {
    "code": "1f1f8-1f1e8"
  },
  "🇸🇱": {
    "code": "1f1f8-1f1f1"
  },
  "🇸🇬": {
    "code": "1f1f8-1f1ec"
  },
  "🇸🇽": {
    "code": "1f1f8-1f1fd"
  },
  "🇸🇰": {
    "code": "1f1f8-1f1f0"
  },
  "🇸🇮": {
    "code": "1f1f8-1f1ee"
  },
  "🇬🇸": {
    "code": "1f1ec-1f1f8"
  },
  "🇸🇧": {
    "code": "1f1f8-1f1e7"
  },
  "🇸🇴": {
    "code": "1f1f8-1f1f4"
  },
  "🇿🇦": {
    "code": "1f1ff-1f1e6"
  },
  "🇰🇷": {
    "code": "1f1f0-1f1f7"
  },
  "🇸🇸": {
    "code": "1f1f8-1f1f8"
  },
  "🇪🇸": {
    "code": "1f1ea-1f1f8"
  },
  "🇱🇰": {
    "code": "1f1f1-1f1f0"
  },
  "🇧🇱": {
    "code": "1f1e7-1f1f1"
  },
  "🇸🇭": {
    "code": "1f1f8-1f1ed"
  },
  "🇰🇳": {
    "code": "1f1f0-1f1f3"
  },
  "🇱🇨": {
    "code": "1f1f1-1f1e8"
  },
  "🇵🇲": {
    "code": "1f1f5-1f1f2"
  },
  "🇻🇨": {
    "code": "1f1fb-1f1e8"
  },
  "🇸🇩": {
    "code": "1f1f8-1f1e9"
  },
  "🇸🇷": {
    "code": "1f1f8-1f1f7"
  },
  "🇸🇪": {
    "code": "1f1f8-1f1ea"
  },
  "🇨🇭": {
    "code": "1f1e8-1f1ed"
  },
  "🇸🇾": {
    "code": "1f1f8-1f1fe"
  },
  "🇹🇼": {
    "code": "1f1f9-1f1fc"
  },
  "🇹🇯": {
    "code": "1f1f9-1f1ef"
  },
  "🇹🇿": {
    "code": "1f1f9-1f1ff"
  },
  "🇹🇭": {
    "code": "1f1f9-1f1ed"
  },
  "🇹🇱": {
    "code": "1f1f9-1f1f1"
  },
  "🇹🇬": {
    "code": "1f1f9-1f1ec"
  },
  "🇹🇰": {
    "code": "1f1f9-1f1f0"
  },
  "🇹🇴": {
    "code": "1f1f9-1f1f4"
  },
  "🇹🇹": {
    "code": "1f1f9-1f1f9"
  },
  "🇹🇳": {
    "code": "1f1f9-1f1f3"
  },
  "🇹🇷": {
    "code": "1f1f9-1f1f7"
  },
  "🇹🇲": {
    "code": "1f1f9-1f1f2"
  },
  "🇹🇨": {
    "code": "1f1f9-1f1e8"
  },
  "🇹🇻": {
    "code": "1f1f9-1f1fb"
  },
  "🇻🇮": {
    "code": "1f1fb-1f1ee"
  },
  "🇺🇬": {
    "code": "1f1fa-1f1ec"
  },
  "🇺🇦": {
    "code": "1f1fa-1f1e6"
  },
  "🇦🇪": {
    "code": "1f1e6-1f1ea"
  },
  "🇬🇧": {
    "code": "1f1ec-1f1e7"
  },
  "🏴󠁧󠁢󠁥󠁮󠁧󠁿": {
    "code": "1f3f4-e0067-e0062-e0065-e006e-e0067-e007f"
  },
  "🏴󠁧󠁢󠁳󠁣󠁴󠁿": {
    "code": "1f3f4-e0067-e0062-e0073-e0063-e0074-e007f"
  },
  "🏴󠁧󠁢󠁷󠁬󠁳󠁿": {
    "code": "1f3f4-e0067-e0062-e0077-e006c-e0073-e007f"
  },
  "🇺🇸": {
    "code": "1f1fa-1f1f8"
  },
  "🇺🇾": {
    "code": "1f1fa-1f1fe"
  },
  "🇺🇿": {
    "code": "1f1fa-1f1ff"
  },
  "🇻🇺": {
    "code": "1f1fb-1f1fa"
  },
  "🇻🇦": {
    "code": "1f1fb-1f1e6"
  },
  "🇻🇪": {
    "code": "1f1fb-1f1ea"
  },
  "🇻🇳": {
    "code": "1f1fb-1f1f3"
  },
  "🇼🇫": {
    "code": "1f1fc-1f1eb"
  },
  "🇪🇭": {
    "code": "1f1ea-1f1ed"
  },
  "🇾🇪": {
    "code": "1f1fe-1f1ea"
  },
  "🇿🇲": {
    "code": "1f1ff-1f1f2"
  },
  "🇿🇼": {
    "code": "1f1ff-1f1fc"
  }
}

export { whatsAppEmojiGroups, whatsAppEmojiMap }
